/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Map: { input: Record<string, unknown>; output: Record<string, unknown> };
  Time: { input: any; output: any };
  Upload: { input: any; output: any };
  Void: { input: any; output: any };
}

export interface AccountInformation {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: UserGender;
  lastName: Scalars['String']['input'];
}

export interface AccountInformation_V2 {
  /**
   * date format YYYY-MM-DD (e.g. 2006-01-02)
   *
   * field is optional, NULL will unset the current value
   */
  birthdate?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: UserGender;
  lastName: Scalars['String']['input'];
}

export enum AccountType {
  Guest = 'guest',
  Registered = 'registered',
}

export interface Action {
  data_v2: Scalars['String']['output'];
  method: Scalars['String']['output'];
  paymentData: Maybe<Scalars['String']['output']>;
  sdkData: Maybe<Scalars['Map']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface AddToCartItem {
  assemblyServiceAdded?: InputMaybe<Scalars['Boolean']['input']>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
}

export interface AddToCartItem_V2 {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  services?: InputMaybe<Array<AdditionalServiceType>>;
  servicesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sku: Scalars['String']['input'];
}

export interface AdditionalService {
  available: AdditionalServiceAvailability;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: AdditionalServicePrice;
  selected: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use id field instead - https://home24.atlassian.net/browse/SHOP-238 */
  type: AdditionalServiceType;
}

export enum AdditionalServiceAvailability {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Unknown = 'UNKNOWN',
}

export interface AdditionalServicePrice {
  currency: Scalars['String']['output'];
  regular: Scalars['Int']['output'];
}

export enum AdditionalServiceType {
  /** @deprecated Use AdditionalService.id instead - https://home24.atlassian.net/browse/SHOP-238 */
  Assembly = 'ASSEMBLY',
  /** @deprecated Use AdditionalService.id instead - https://home24.atlassian.net/browse/SHOP-238 */
  DeliveryToRoom = 'DELIVERY_TO_ROOM',
  /** @deprecated Use AdditionalService.id instead - https://home24.atlassian.net/browse/SHOP-238 */
  ElectronicsDisposal = 'ELECTRONICS_DISPOSAL',
  /** @deprecated Use AdditionalService.id instead - https://home24.atlassian.net/browse/SHOP-238 */
  FurnitureDisposal = 'FURNITURE_DISPOSAL',
  /** @deprecated Use AdditionalService.id instead - https://home24.atlassian.net/browse/SHOP-238 */
  Impregnation = 'IMPREGNATION',
  /** @deprecated Use AdditionalService.id instead - https://home24.atlassian.net/browse/SHOP-238 */
  Unpacking = 'UNPACKING',
}

export interface Address {
  additional: Scalars['String']['output'];
  additional2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  company: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Maybe<UserGender>;
  isDefaultBillingAddress: Scalars['Boolean']['output'];
  isDefaultShippingAddress: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  street: Scalars['String']['output'];
  taxId: Maybe<Scalars['String']['output']>;
  telephone: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
}

export interface AddressValidationRules {
  additional: Array<ValidationRule_V2>;
  additional2: Array<ValidationRule_V2>;
  city: Array<ValidationRule_V2>;
  company: Array<ValidationRule_V2>;
  countryCode: Array<ValidationRule_V2>;
  firstname: Array<ValidationRule_V2>;
  lastname: Array<ValidationRule_V2>;
  street: Array<ValidationRule_V2>;
  taxId: Array<ValidationRule_V2>;
  telephone: Array<ValidationRule_V2>;
  zip: Array<ValidationRule_V2>;
}

/**  ThirdParty analytics ID, so we could track sensitive data Backend to Backend  */
export interface AnalyticsContext {
  id: Scalars['String']['input'];
  source: AnalyticsSource;
}

/**  Depends on the platform request is initiated  */
export enum AnalyticsSource {
  /**  From Native apps  */
  FirebaseAndroid = 'FIREBASE_ANDROID',
  /**  From Native apps  */
  FirebaseIos = 'FIREBASE_IOS',
  /**  From WebSite (JavaScript)  */
  Gtm = 'GTM',
}

export interface ApplyVoucherResponse {
  cartResponse: Maybe<CartResponse>;
  /** Returns the requested voucher data irrespective of cart response. */
  requestedVoucher: Maybe<Voucher>;
}

export interface Article {
  accessories: Array<Maybe<Article>>;
  additionalServices: Maybe<Array<AdditionalService>>;
  alternativeVariations: Array<ArticleVariations_V2>;
  assembly: Maybe<ArticleAssembly>;
  attributes: Maybe<Attributes>;
  bestOffer: ArticleOffer;
  brand: Maybe<ArticleBrand>;
  /** @deprecated Uses data from CategoryService which is deprecated. */
  breadcrumbs: Array<ArticleBreadcrumb>;
  bulletpoints: Array<ArticleBulletpoint>;
  campaigns: Array<Maybe<ArticleCampaign>>;
  certificate: Maybe<ArticleCertificate>;
  clvScoreWithVoucher: Maybe<Scalars['Float']['output']>;
  clvScoreWithoutVoucher: Maybe<Scalars['Float']['output']>;
  contentCluster: Maybe<Scalars['String']['output']>;
  crossSelling: Array<ArticleRecommendation>;
  delivery_v2: Maybe<ArticleDelivery_V2>;
  description: Array<Scalars['String']['output']>;
  /** @deprecated Use `details_v2` */
  details: Array<ArticleDetail>;
  /**
   * details_v2: Includes certificates in FunctionAndQualityContent.
   * Maintained for backward compatibility with Native apps.
   */
  details_v2: Array<ArticleDetail_V2>;
  /** details_v3: Separates certificates into their own dedicated CertificatesContent section. */
  details_v3: Array<ArticleDetail_V3>;
  discount: Scalars['Int']['output'];
  ean: Maybe<Scalars['String']['output']>;
  energyClass_v3: Maybe<ArticleEnergyClass_V3>;
  fabricSample: Maybe<ArticleFabricSample>;
  faq: Maybe<ArticleFaq>;
  hasElectricItem: Scalars['Boolean']['output'];
  hasFakeParent: Scalars['Boolean']['output'];
  images: Array<ArticleGalleryImage>;
  inOutlets_v2: Array<ContentStoreShortInfo>;
  inShowrooms_v3: Array<ContentStoreShortInfo>;
  isAvailableOnStores: Scalars['Boolean']['output'];
  /** @deprecated Use isAvailableOnStores */
  isButlers: Scalars['Boolean']['output'];
  isSetOfProducts: Scalars['Boolean']['output'];
  /** @deprecated Use labels_v2 - Ref: https://home24.atlassian.net/browse/SPP-5900 */
  labels: Array<Maybe<ArticleLabel>>;
  labels_v2: Array<Maybe<ArticleLabelV2>>;
  materialType_v2: MaterialType;
  metrics: Maybe<ArticleStats>;
  name: Scalars['String']['output'];
  offers: Array<ArticleOffer>;
  parentSku: Scalars['String']['output'];
  /** @deprecated no Payback anymore */
  payback: Maybe<ArticlePaybackData>;
  prices: ArticlePrices;
  productEfficiencyValue: Maybe<Scalars['Float']['output']>;
  productServiceCharge: Maybe<Scalars['Int']['output']>;
  /** These values are pushed to GTM from clients */
  productShippingCharge: Maybe<Scalars['Int']['output']>;
  productTaxonomy: Array<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
  ratings: ArticleRatings;
  related: Array<Maybe<Article>>;
  resources: Array<ArticleResource>;
  reviewSummary: Maybe<ReviewSummary>;
  /** @deprecated Use `reviews_v2` */
  reviews: Array<Maybe<ArticleReview>>;
  /** @deprecated Use `reviews_v3`, https://home24.atlassian.net/browse/SPP-5618 */
  reviews_v2: Array<Maybe<ArticleReview>>;
  reviews_v3: Maybe<ArticleReviews>;
  safetyAndSustainability: Maybe<SafetyAndSustainability>;
  safetyInformation: Maybe<ProductSafetyInformation>;
  sellable: Scalars['Boolean']['output'];
  sellableVariants: Scalars['Boolean']['output'];
  /** @deprecated Use `seo_v2` */
  seo: Seo;
  seo_v2: Maybe<Seo>;
  sku: Scalars['String']['output'];
  sponsored: Maybe<Sponsored>;
  stock: ArticleStock;
  taxonomyBreadcrumbs: Array<ArticleBreadcrumb>;
  testInstituteCertificate: Maybe<Scalars['String']['output']>;
  testNumberCertificate: Maybe<Scalars['String']['output']>;
  totalVariations: Scalars['Int']['output'];
  trackingId: Maybe<Scalars['String']['output']>;
  upSelling: Array<ArticleRecommendation>;
  url: Scalars['String']['output'];
  usp: Maybe<ArticleUsp>;
  variantName: Scalars['String']['output'];
  /** @deprecated Use `variations_v2` */
  variations: Maybe<ArticleVariations>;
  variationsMinPrice: ArticleVariationPrice;
  variations_v2: Maybe<Array<Maybe<ArticleVariations_V2>>>;
  videos: Array<Maybe<ArticleVideo>>;
}

export interface ArticleAccessoriesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleAdditionalServicesArgs {
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface ArticleAlternativeVariationsArgs {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export interface ArticleCampaignsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pv2Token?: Scalars['String']['input'];
}

export interface ArticleCrossSellingArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleImagesArgs {
  format?: InputMaybe<ArticleImageFormat>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<ArticleImageType>;
}

export interface ArticleMetricsArgs {
  timeAgo?: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleOffersArgs {
  excludeBestOffer?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ArticleRelatedArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleResourcesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<ArticleResourceType>;
}

export interface ArticleReviewsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleReviews_V2Args {
  filters: InputMaybe<ArticleReviewFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: ArticleReviewSortOption;
}

export interface ArticleReviews_V3Args {
  filters: InputMaybe<ArticleReviewFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: ArticleReviewSortOption;
}

export interface ArticleUpSellingArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleVariations_V2Args {
  type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  with3dModelsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  with3dModelsWithTextureOnly?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ArticleAssembly {
  currency: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ArticleAttributeValue {
  imageUrl: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ArticleAttribute_V2 {
  key: Scalars['String']['output'];
  renderingType: Scalars['String']['output'];
  subAttributes: Array<ArticleSubAttribute>;
  title: Scalars['String']['output'];
}

export interface ArticleAvailability {
  possibleDeliveryDateMax: Scalars['String']['output'];
  possibleDeliveryDateMin: Scalars['String']['output'];
  possibleShippingDate: Scalars['String']['output'];
  possibleShippingTime: Maybe<ArticleDeliveryTime>;
  totalAvailableQuantity: Scalars['Int']['output'];
  totalWarehouseQuantity: Scalars['Int']['output'];
}

export interface ArticleBrand {
  imageSrc: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /**  Internal URL for Native apps  */
  pageLink: Maybe<UrlMappingTarget>;
  /**  SEO URL for Webshop  */
  pageUrl: Maybe<Scalars['String']['output']>;
  /**
   * As of first iteration, it is only enabled on BUTLERS DE.
   *
   * In the future, it will be replaced by ContentShopInShopSliceV2.data.homepage as part of contentPage_v2 response,
   * but currently there are no Prismic data that is of Production quality.
   * @deprecated use pageLink or pageUrl instead.
   */
  shopInShopUrl: Maybe<ContentLink>;
  /** @deprecated shopreboot and fashionforhome shutdown. Use `pageUrl`. */
  url: Maybe<Scalars['String']['output']>;
}

export interface ArticleBrandImageSrcArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleBreadcrumb {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface ArticleBulletpoint {
  title: Scalars['String']['output'];
  values: Array<Maybe<ArticleBulletpoint>>;
}

export interface ArticleCampaign {
  campaignBanner: Maybe<CampaignBannerSlice>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** @deprecated Use `campaignBanner`, https://home24.atlassian.net/browse/SPP-5738 */
  voucherBanner: Maybe<ContentVoucherBannerSlice>;
  /** @deprecated Use `campaignBanner`, https://home24.atlassian.net/browse/SPP-5738 */
  voucherBanner_v2: Maybe<ContentVoucherBannerSlice_V2>;
  /** @deprecated Use `campaignBanner`, https://home24.atlassian.net/browse/SPP-5738 */
  voucherBanner_v3: Maybe<ContentVoucherBannerSlice_V3>;
}

export interface ArticleCertificate {
  name: Scalars['String']['output'];
  values: Maybe<Array<ArticleCertificateResource>>;
}

export interface ArticleCertificateResource {
  image: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface ArticleCertificateResourceImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleDeliveryFlags {
  deliveryToCurb: Scalars['Boolean']['output'];
  fastDelivery: Scalars['Boolean']['output'];
  longDeliveryTime: Scalars['Boolean']['output'];
  lowWarehouseQuantity: Scalars['Boolean']['output'];
}

export interface ArticleDeliveryTime {
  numberOfDays: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  unit: Scalars['String']['output'];
}

export enum ArticleDeliveryType {
  FurnitureShipping = 'FURNITURE_SHIPPING',
  ParcelService = 'PARCEL_SERVICE',
  ShippingCompany = 'SHIPPING_COMPANY',
  Unknown = 'UNKNOWN',
  Virtual = 'VIRTUAL',
}

export interface ArticleDelivery_V2 {
  availability: Maybe<ArticleAvailability>;
  flags: Maybe<ArticleDeliveryFlags>;
  localizedShippingMethod: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `articles.bestOffer.shop.shippingInfo` */
  price: ShippingPrice;
  shippingMethod: ShippingMethod;
  time: ArticleDeliveryTime;
  type: ArticleDeliveryType;
}

export interface ArticleDetail {
  title: Scalars['String']['output'];
  values: Array<ArticleDetailValue>;
}

export type ArticleDetailContent =
  | ClpContent
  | EcoResponsibilityContent
  | ElectricalItemContent
  | FunctionAndQualityContent
  | PremiumBrandContent
  | ProductDescriptionContent
  | ProductDetailContent
  | ProductDimensionContent
  | ProductFaqContent;

export type ArticleDetailContent_V3 =
  | ClpContent
  | CertificatesContent
  | EcoResponsibilityContent
  | ElectricalItemContent
  | FunctionAndQualityContent_V3
  | PremiumBrandContent
  | ProductDescriptionContent
  | ProductDetailContent
  | ProductDimensionContent
  | ProductFaqContent;

export interface ArticleDetailValue {
  image: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
}

export interface ArticleDetailValueImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface ArticleDetail_V2 {
  content: ArticleDetailContent;
  title: ArticleDetailsTitle;
}

export interface ArticleDetail_V3 {
  content: ArticleDetailContent_V3;
  title: ArticleDetailsTitle;
}

export enum ArticleDetailsTitle {
  Certificates = 'CERTIFICATES',
  Clp = 'CLP',
  EcoResponsibility = 'ECO_RESPONSIBILITY',
  ElectricalItems = 'ELECTRICAL_ITEMS',
  Faq = 'FAQ',
  FunctionAndQuality = 'FUNCTION_AND_QUALITY',
  PremiumBrand = 'PREMIUM_BRAND',
  ProductDescription = 'PRODUCT_DESCRIPTION',
  ProductDetails = 'PRODUCT_DETAILS',
  ProductDimension = 'PRODUCT_DIMENSION',
}

export interface ArticleEnergyClass_V3 {
  class: Scalars['String']['output'];
  labelUrls: Maybe<Array<Scalars['String']['output']>>;
  scaleType: EnergyClassScaleType;
  type: Scalars['String']['output'];
}

export interface ArticleFabricSample {
  article: Article;
  sku: Scalars['String']['output'];
}

export interface ArticleFaq {
  items: Array<ArticleFaqItem>;
  title: Scalars['String']['output'];
}

export interface ArticleFaqItem {
  answer: Scalars['String']['output'];
  question: Maybe<Scalars['String']['output']>;
}

export interface ArticleGalleryImage {
  path: Scalars['String']['output'];
  type: Maybe<ArticleImageType>;
}

export interface ArticleHeaderBlock {
  articleTitle: Maybe<Scalars['String']['output']>;
  articleTitleColor: Maybe<Scalars['String']['output']>;
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isArticleInfoHidden: Maybe<Scalars['Boolean']['output']>;
  isCategoryHidden: Maybe<Scalars['Boolean']['output']>;
  isHeaderLeftAligned: Maybe<Scalars['Boolean']['output']>;
  isHeaderWithReducedWidth: Maybe<Scalars['Boolean']['output']>;
}

export enum ArticleImageFormat {
  Avif = 'AVIF',
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP',
}

export enum ArticleImageType {
  Accessory = 'ACCESSORY',
  AngularLeft = 'ANGULAR_LEFT',
  AngularPerspective = 'ANGULAR_PERSPECTIVE',
  AngularRight = 'ANGULAR_RIGHT',
  AssemblyInstruction = 'ASSEMBLY_INSTRUCTION',
  Back = 'BACK',
  Detail = 'DETAIL',
  Fabric = 'FABRIC',
  Front = 'FRONT',
  Function = 'FUNCTION',
  FunctionActive = 'FUNCTION_ACTIVE',
  IconSeal = 'ICON_SEAL',
  InnerView = 'INNER_VIEW',
  Mood = 'MOOD',
  Packaging = 'PACKAGING',
  Set = 'SET',
  SideLeft = 'SIDE_LEFT',
  SideRight = 'SIDE_RIGHT',
  Sketch = 'SKETCH',
  Top = 'TOP',
  WardrobeDesign = 'WARDROBE_DESIGN',
  WardrobeDoors = 'WARDROBE_DOORS',
  WardrobeInterior = 'WARDROBE_INTERIOR',
  WardrobeSize = 'WARDROBE_SIZE',
}

export interface ArticleInstallmentPrice {
  months: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  value: Scalars['Int']['output'];
}

export interface ArticleLabel {
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface ArticleLabelPercentage {
  value: Scalars['Int']['output'];
}

export interface ArticleLabelPrice {
  value: Scalars['Int']['output'];
}

export interface ArticleLabelString {
  value: Scalars['String']['output'];
}

export enum ArticleLabelType {
  AbsoluteDiscount = 'ABSOLUTE_DISCOUNT',
  Campaign = 'CAMPAIGN',
  Home24Selection = 'HOME24_SELECTION',
  New = 'NEW',
  PercentageDiscount = 'PERCENTAGE_DISCOUNT',
  ValuePack = 'VALUE_PACK',
}

export interface ArticleLabelV2 {
  type: ArticleLabelType;
  value: ArticleLabelValue;
}

export type ArticleLabelValue = ArticleLabelPercentage | ArticleLabelPrice | ArticleLabelString;

export interface ArticleOffer {
  blockedForB2B: Scalars['Boolean']['output'];
  /** @deprecated Use `prices.currency` */
  currency: Scalars['String']['output'];
  id: Maybe<Scalars['String']['output']>;
  isHome24: Scalars['Boolean']['output'];
  /**
   * overFreeShippingThreshold flags if the offer price is higher than the free threshold. Currently does not respect offer shipping type but will in the future. --> https://home24.atlassian.net/browse/PDE-815.
   * @deprecated Use `overFreeShippingThreshold_v2`
   */
  overFreeShippingThreshold: Scalars['Boolean']['output'];
  overFreeShippingThreshold_v2: Maybe<Scalars['Boolean']['output']>;
  prices: ArticleOfferPrices;
  shippingInfo: ArticleOfferShippingInfo;
  shop: Maybe<Shop>;
  stockQuantity: Maybe<Scalars['Int']['output']>;
}

export interface ArticleOfferOverFreeShippingThreshold_V2Args {
  zip: InputMaybe<Scalars['String']['input']>;
}

export interface ArticleOfferShopArgs {
  zip: InputMaybe<Scalars['String']['input']>;
}

export interface ArticleOfferPrices {
  currency: Scalars['String']['output'];
  regular: Scalars['Int']['output'];
  special: Maybe<Scalars['Int']['output']>;
}

export interface ArticleOfferShippingInfo {
  deliveryTime: Scalars['Int']['output'];
  deliveryType: ArticleDeliveryType;
  leadTimeToShip: Maybe<Scalars['Int']['output']>;
  price: Maybe<Scalars['Int']['output']>;
}

export interface ArticlePaybackData {
  basicPoints: Scalars['Int']['output'];
}

export interface ArticlePrices {
  currency: Scalars['String']['output'];
  deliveryCharge: Maybe<DeliveryCharge>;
  deliveryChargeApplicable: Scalars['Boolean']['output'];
  /** @deprecated Installment is not available anymore. */
  installment: Maybe<ArticleInstallmentPrice>;
  /** price per measurement unit */
  measurement: Maybe<ArticleUnitPricingMeasure>;
  paypalClientID: Scalars['String']['output'];
  /** price per item */
  regular: Maybe<ArticleRegularPrice>;
  rrp: Maybe<ArticleRecommendedRetailPrice>;
  special: Maybe<ArticleSpecialPrice>;
  tax: Maybe<ArticlePricesTax>;
}

export interface ArticlePricesTax {
  ecoMobilier: Maybe<ArticlePricesTaxEcoMobilier>;
}

export interface ArticlePricesTaxEcoMobilier {
  amountWithVat: Scalars['Int']['output'];
  amountWithoutVat: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  codeDescription: Scalars['String']['output'];
  ecoCode: Scalars['String']['output'];
}

export interface ArticleRatings {
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  distributions: Array<Maybe<ArticleRatingsDistribution>>;
}

export interface ArticleRatingsDistribution {
  count: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
}

export interface ArticleRecommendation {
  article: Article;
  id: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
}

export interface ArticleRecommendedRetailPrice {
  discount: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
}

export interface ArticleRegularPrice {
  isRrp: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
}

export interface ArticleResource {
  path: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export enum ArticleResourceType {
  AssemblyInstruction = 'ASSEMBLY_INSTRUCTION',
  DataSheet = 'DATA_SHEET',
  Image = 'IMAGE',
  Model_3D = 'MODEL_3D',
  Model_3DWithTexture = 'MODEL_3D_WITH_TEXTURE',
  ShareImage = 'SHARE_IMAGE',
}

export interface ArticleReview {
  city: Scalars['String']['output'];
  date: Scalars['String']['output'];
  isTranslation: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  variantName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use variantName instead. */
  variation: Article;
}

export interface ArticleReviewFilters {
  keywordID?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingMax?: InputMaybe<Scalars['Int']['input']>;
  ratingMin?: InputMaybe<Scalars['Int']['input']>;
}

export enum ArticleReviewSortOption {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  RatingAsc = 'RATING_ASC',
  RatingDesc = 'RATING_DESC',
}

export interface ArticleReviews {
  reviews: Array<Maybe<ArticleReview>>;
  totalCount: Scalars['Int']['output'];
}

export interface ArticleSpecialPrice {
  discount: Scalars['Int']['output'];
  displayCountdown: Scalars['Boolean']['output'];
  validTill: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
}

export interface ArticleStats {
  wishlist: ArticleStatsCounts;
}

export interface ArticleStatsCounts {
  count: Scalars['Int']['output'];
  parentCount: Scalars['Int']['output'];
}

export interface ArticleStock {
  description: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
}

export interface ArticleSubAttribute {
  key: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  values: Array<Maybe<ArticleAttributeValue>>;
}

export interface ArticleUsp {
  name: Scalars['String']['output'];
  values: Maybe<Array<ArticleUspResource>>;
}

export interface ArticleUspResource {
  image: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface ArticleUspResourceImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

/** E.g. selling 10ml bottles for €6,99. So €699,00 / 1 l */
export interface ArticleUnitPricingMeasure {
  /** Amount that indicates the measurement units we are counting in. Usually 1 */
  quantity: Scalars['Float']['output'];
  /** Unit of Measurement. E.g. kg */
  unit: Scalars['String']['output'];
  /** Bulk Price or Total Cost of a quantity. E.g. 69900 */
  value: Scalars['Int']['output'];
}

export interface ArticleVariation {
  article: Article;
  key: Scalars['String']['output'];
}

export interface ArticleVariationDisabledAttribute {
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
}

export interface ArticleVariationGroup {
  key: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  totalVariationGroupItems: Scalars['Int']['output'];
  values: Array<Maybe<ArticleVariationGroupValues>>;
}

export interface ArticleVariationGroupValuesArgs {
  limit: InputMaybe<Scalars['Int']['input']>;
  sortingBySelectedOption: InputMaybe<Scalars['Boolean']['input']>;
  withoutDisabledOnly: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ArticleVariationGroupValues {
  article: Maybe<Article>;
  disabled: Scalars['Boolean']['output'];
  has3DModel: Scalars['Boolean']['output'];
  has3DModelWithTexture: Scalars['Boolean']['output'];
  hasAlternatives: Maybe<Scalars['Boolean']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  sku: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
}

export interface ArticleVariationPrice {
  currency: Scalars['String']['output'];
  price: Scalars['Int']['output'];
}

export interface ArticleVariationSelectedAttribute {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface ArticleVariations {
  disabledAttributes: Array<Maybe<ArticleVariationDisabledAttribute>>;
  selectableArticles: Array<Maybe<ArticleVariation>>;
  selectableAttributes_v2: Array<Maybe<ArticleAttribute_V2>>;
  selectedAttributes: Array<Maybe<ArticleVariationSelectedAttribute>>;
}

export interface ArticleVariationsSelectedValue {
  groupKey: Maybe<Scalars['String']['output']>;
  groupTitle: Maybe<Scalars['String']['output']>;
  valueKey: Scalars['String']['output'];
  valueTitle: Scalars['String']['output'];
  variationKey: Scalars['String']['output'];
  variationTitle: Scalars['String']['output'];
}

export interface ArticleVariations_V2 {
  groups: Array<Maybe<ArticleVariationGroup>>;
  key: Scalars['String']['output'];
  renderingType: Scalars['String']['output'];
  selectedValues: Array<ArticleVariationsSelectedValue>;
  title: Scalars['String']['output'];
}

export interface ArticleVideo {
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface ArticlesNavigationBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export enum ArticlesSortingScore {
  A = 'A',
  B = 'B',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  B4 = 'B4',
}

export interface AttachmentUploadEntry {
  filePath: Scalars['String']['output'];
  formFields: Array<AttachmentUploadFieldValue>;
  url: Scalars['String']['output'];
}

export interface AttachmentUploadFieldValue {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface AttachmentUploadRequestEntry {
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
}

export interface Attribute {
  localized: Maybe<Scalars['String']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  value: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface Attributes {
  color: Maybe<Attribute>;
  colorDetail: Maybe<Attribute>;
  colorSubcolor: Maybe<Attribute>;
  depth: Maybe<Attribute>;
  height: Maybe<Attribute>;
  material: Maybe<Attribute>;
  pattern: Maybe<Attribute>;
  width: Maybe<Attribute>;
}

export enum AuthenticationProvider {
  Apple = 'apple',
  Google = 'google',
  Home24Password = 'home24Password',
}

/**
 * ***Author*** contains author information following Google's Article structured data specification.
 * https://developers.google.com/search/docs/appearance/structured-data/article
 */
export interface Author {
  /** Date the author content page was last modified */
  dateModified: Maybe<Scalars['String']['output']>;
  /** Date the author content page was published */
  datePublished: Maybe<Scalars['String']['output']>;
  /** Author headline (meta description of Content document) */
  headline: Maybe<Scalars['String']['output']>;
  /** Author profile image (OpenGraph image of Content document) */
  image: Maybe<ContentImage>;
  /** Author name (meta title of Content document) */
  name: Scalars['String']['output'];
  /** Use PERSON when available, ORGANIZATION as default */
  type: AuthorType;
  /** URL link to author page */
  url: Maybe<ContentLink>;
}

export enum AuthorType {
  Organization = 'ORGANIZATION',
  Person = 'PERSON',
}

/** Deprecated: per category based suggestion when backend=Home24 */
export interface AutoSuggestion {
  category: Scalars['String']['output'];
  image: Scalars['String']['output'];
  /** @deprecated Use SearchSuggestion.image for backend:ThirdParty */
  name: Scalars['String']['output'];
  /** @deprecated Use SearchSuggestion.total for backend:ThirdParty */
  results: Scalars['Int']['output'];
}

/** Deprecated: per category based suggestion when backend=Home24 */
export interface AutoSuggestionImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
}

export type AutoSuggestionResult = AutoSuggestion | ProductSuggestion | SearchSuggestion;

export enum AvailabilityType {
  Available = 'AVAILABLE',
  DisplayOnly = 'DISPLAY_ONLY',
  Few = 'FEW',
  NotAvailable = 'NOT_AVAILABLE',
}

export interface BasketBasedPrice extends ShippingPrice {
  /**  Shipping becomes free, when basket price is more than this value (cents)  */
  freeSinceBasketPrice: Scalars['Int']['output'];
  /**  Shipping price in cents  */
  value: Scalars['Int']['output'];
  /**  Where we can ship the product  */
  zone: ShippingZoneName;
}

export enum BranchType {
  PointOfSale = 'POINT_OF_SALE',
  Showroom = 'SHOWROOM',
}

export interface BrandGlossary {
  allBrands: Array<BrandsGlossaryItem>;
  sections: Array<BrandGlossarySection>;
}

export interface BrandGlossarySection {
  brands: Array<Maybe<BrandsGlossaryItem>>;
  key: Scalars['String']['output'];
}

export interface BrandsGlossaryItem {
  name: Scalars['String']['output'];
  target: BrandsGlossaryTarget;
  url: Scalars['String']['output'];
}

export type BrandsGlossaryTarget = UrlMappingTarget_ContentPage | UrlMappingTarget_ContentTreeNode;

export interface ClpContent {
  name: Scalars['String']['output'];
  values: Maybe<Array<ClpResource>>;
}

export interface ClpResource {
  image: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
}

export interface ClpResourceImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface CampaignBannerSlice {
  campaignBackgroundColor: Maybe<Scalars['String']['output']>;
  campaignTextColor: Maybe<Scalars['String']['output']>;
  /** Either coupon or voucher type. Optional for cases where banner has no voucher/coupon, just title/subtitle/countdown etc */
  campaignType: Maybe<CampaignType>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  extraDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /**
   * Should always return a value for Coupons.
   * For vouchers, it is Optional when price is applied only on cart (e.g. Free shipping, cascading vouchers above single item price) or code is not valid.
   */
  priceAfterDiscount: Maybe<Scalars['Int']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
}

export interface CampaignDocumentCommonFields {
  backgroundColor: Maybe<Scalars['String']['output']>;
  campaignDuration: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  isMultiVoucher: Maybe<Scalars['Boolean']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
  voucherCode: Maybe<Scalars['String']['output']>;
}

export type CampaignType = OnlineCoupon | Voucher;

export enum CarrierType {
  ManHandlingPull = 'MAN_HANDLING_PULL',
  ManHandlingPush = 'MAN_HANDLING_PUSH',
  ParcelService = 'PARCEL_SERVICE',
}

export interface Cart {
  /** Returns grandTotal - giftCardsDeductionTotal */
  amountDue: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  discountPendingTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  ecoMobilierTotal: Maybe<Scalars['Int']['output']>;
  giftCards: Maybe<Array<GiftCard>>;
  giftCardsDeductionTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  items: Array<CartItem>;
  /** @deprecated no Payback anymore */
  payback: Maybe<PaybackData>;
  paymentOptions: Maybe<Array<ExpressPaymentOption>>;
  preShipping: PreShipping;
  savingsTotal: Scalars['Int']['output'];
  serviceTotal: Maybe<Scalars['Int']['output']>;
  shippingTotal: Scalars['Int']['output'];
  shippingTotalRegular: Scalars['Int']['output'];
  shippingZip: Maybe<Scalars['String']['output']>;
  subOrders: Array<CartSubOrder>;
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  voucher: Maybe<CartVoucher>;
  voucherCode: Maybe<Scalars['String']['output']>;
}

export interface CartPaymentOptionsArgs {
  locale: GQLLocale;
}

export interface CartSubOrdersArgs {
  groupBy?: SubOrdersGrouping;
}

export interface CartCascadingAbsoluteVoucherDetails {
  /** amount in cents that is needed to reach the next discount level */
  amountUntilNextDiscount: Maybe<Scalars['Int']['output']>;
  /** next discount in cents, e.g. 1000 for 10.00€ */
  nextDiscount: Maybe<Scalars['Int']['output']>;
}

export interface CartCascadingRelativeVoucherDetails {
  /** amount in cents that is needed to reach the next discount level */
  amountUntilNextDiscount: Maybe<Scalars['Int']['output']>;
  /** next discount in percentage, e.g. 10 for 10 % */
  nextDiscount: Maybe<Scalars['Int']['output']>;
}

export interface CartError {
  code: CartErrorCode;
  message: Scalars['String']['output'];
}

export enum CartErrorCode {
  BadRequest = 'BAD_REQUEST',
  Forbidden = 'FORBIDDEN',
  GiftcardAppDomainNotAllowed = 'GIFTCARD_APP_DOMAIN_NOT_ALLOWED',
  GiftcardBlocked = 'GIFTCARD_BLOCKED',
  GiftcardDuplicate = 'GIFTCARD_DUPLICATE',
  GiftcardExpired = 'GIFTCARD_EXPIRED',
  GiftcardInvalidCode = 'GIFTCARD_INVALID_CODE',
  GiftcardInvalidPin = 'GIFTCARD_INVALID_PIN',
  GiftcardLimitExceeded = 'GIFTCARD_LIMIT_EXCEEDED',
  GiftcardNotActive = 'GIFTCARD_NOT_ACTIVE',
  GiftcardNotFound = 'GIFTCARD_NOT_FOUND',
  GiftcardNoBalance = 'GIFTCARD_NO_BALANCE',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  ItemsNotAdded = 'ITEMS_NOT_ADDED',
  ItemNotAddableToCartType = 'ITEM_NOT_ADDABLE_TO_CART_TYPE',
  ItemNotExist = 'ITEM_NOT_EXIST',
  ItemNotSellable = 'ITEM_NOT_SELLABLE',
  NotFound = 'NOT_FOUND',
  Unknown = 'UNKNOWN',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
  VoucherAccountTypeMismatch = 'VOUCHER_ACCOUNT_TYPE_MISMATCH',
  VoucherActivationConflictWithCoupon = 'VOUCHER_ACTIVATION_CONFLICT_WITH_COUPON',
  VoucherConsumed = 'VOUCHER_CONSUMED',
  VoucherCustomerNumberMismatch = 'VOUCHER_CUSTOMER_NUMBER_MISMATCH',
  VoucherExclusivityInvalid = 'VOUCHER_EXCLUSIVITY_INVALID',
  VoucherExpired = 'VOUCHER_EXPIRED',
  VoucherInactive = 'VOUCHER_INACTIVE',
  VoucherInvalid = 'VOUCHER_INVALID',
  VoucherLowBalance = 'VOUCHER_LOW_BALANCE',
  VoucherNotApplicable = 'VOUCHER_NOT_APPLICABLE',
  VoucherNotApplicableDueToCoupon = 'VOUCHER_NOT_APPLICABLE_DUE_TO_COUPON',
  VoucherNotEnoughItems = 'VOUCHER_NOT_ENOUGH_ITEMS',
  VoucherNotHomeClubMember = 'VOUCHER_NOT_HOME_CLUB_MEMBER',
  VoucherNotValidYet = 'VOUCHER_NOT_VALID_YET',
  VoucherNoFirstPartyItem = 'VOUCHER_NO_FIRST_PARTY_ITEM',
  VoucherServiceError = 'VOUCHER_SERVICE_ERROR',
  VoucherWrongAppDomain = 'VOUCHER_WRONG_APP_DOMAIN',
}

export interface CartItem {
  additionalServices: Maybe<Array<AdditionalService>>;
  article: Article;
  couponCode: Maybe<Scalars['String']['output']>;
  couponDiscountAmount: Maybe<Scalars['Int']['output']>;
  deliveries: Array<CartItemDelivery>;
  hasVoucherDiscount: Scalars['Boolean']['output'];
  /** @deprecated use itemPrice_v2 */
  itemPrice: CartItemPrice;
  /** @deprecated use itemPrice_v3. https://home24.atlassian.net/browse/CHO-2125 */
  itemPrice_v2: CartItemPrice_V2;
  itemPrice_v3: CartItemPrice_V3;
  quantity: Scalars['Int']['output'];
  /** @deprecated use selectedOffer_v2(locale: Locale!) */
  selectedOffer: ArticleOffer;
  selectedOffer_v2: ArticleOffer;
  withAssemblyService: Scalars['Boolean']['output'];
  withElectronicsDisposal: Scalars['Boolean']['output'];
}

export interface CartItemArticleArgs {
  locale: GQLLocale;
}

export interface CartItemSelectedOffer_V2Args {
  locale: GQLLocale;
}

export interface CartItemDelivery {
  deliveryGroup: Scalars['String']['output'];
  deliveryTime: ArticleDeliveryTime;
  deliveryToCurb: Scalars['Boolean']['output'];
  isDelayed: Scalars['Boolean']['output'];
  localizedShippingMethod: Maybe<Scalars['String']['output']>;
  possibleDeliveryDateMax: Scalars['String']['output'];
  possibleDeliveryDateMin: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  shippingMethod: ShippingMethod;
  transportationType: Scalars['String']['output'];
  type: ArticleDeliveryType;
}

export interface CartItemPrice {
  ecoMobilierTax: Scalars['Int']['output'];
  ecoMobilierTaxWithoutVAT: Scalars['Int']['output'];
  gross: Scalars['Int']['output'];
  net: Scalars['Int']['output'];
  original: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
}

export interface CartItemPrice_V2 {
  ecoMobilierTax: Maybe<Scalars['Int']['output']>;
  ecoMobilierTaxWithoutVAT: Maybe<Scalars['Int']['output']>;
  gross: Scalars['Int']['output'];
  net: Scalars['Int']['output'];
  original: Maybe<Scalars['Int']['output']>;
  tax: Scalars['Int']['output'];
}

export interface CartItemPrice_V3 {
  discounted: Maybe<Scalars['Int']['output']>;
  ecoMobilierTax: Maybe<Scalars['Int']['output']>;
  ecoMobilierTaxWithoutVAT: Maybe<Scalars['Int']['output']>;
  final: Scalars['Int']['output'];
  net: Scalars['Int']['output'];
  original: Maybe<Scalars['Int']['output']>;
  tax: Scalars['Int']['output'];
}

export interface CartMessage {
  affectedItems: Array<CartItem>;
  code: Scalars['String']['output'];
  global: Scalars['Boolean']['output'];
}

export interface CartResponse {
  cart: Maybe<Cart>;
  /** @deprecated use error_v2. https://home24.atlassian.net/browse/CHO-2275 */
  error: Maybe<Scalars['String']['output']>;
  error_v2: Maybe<CartError>;
  messages: Maybe<Array<CartMessage>>;
}

export interface CartSubOrder {
  /** delivery types per delivery unit (E.g. seller) */
  deliveryTypes: Array<ArticleDeliveryType>;
  /** discount per delivery unit (E.g. seller) */
  discountSubTotal: Scalars['Int']['output'];
  isHome24: Scalars['Boolean']['output'];
  /** items sold by a seller */
  items: Array<CartItem>;
  /** shipping campaign per delivery unit (E.g. seller) */
  shippingCampaign: Maybe<ShippingCampaign>;
  /** shipping cost per delivery unit (E.g. seller) */
  shippingSubTotal: Scalars['Int']['output'];
  /** shipping cost per delivery unit (E.g. seller) excluding discounts */
  shippingSubTotalRegular: Scalars['Int']['output'];
  /** Seller information */
  shop: Shop;
  /** costs without shipping costs per delivery unit (E.g. seller) */
  subTotal: Scalars['Int']['output'];
}

export interface CartSubOrderShopArgs {
  locale: GQLLocale;
}

export enum CartType {
  Default = 'DEFAULT',
  Digital = 'DIGITAL',
}

export interface CartVoucher {
  /** amount in cents the voucher discount calculation is based on */
  applicableCartAmount: Scalars['Int']['output'];
  appliesToAllItems: Scalars['Boolean']['output'];
  channel: VoucherChannel;
  code: Scalars['String']['output'];
  details: Maybe<CartVoucherDetails>;
  method: VoucherMethod;
}

export type CartVoucherDetails =
  | CartCascadingAbsoluteVoucherDetails
  | CartCascadingRelativeVoucherDetails;

export interface CategoriesCollection {
  count: Scalars['Int']['output'];
  list: Array<Maybe<Category>>;
}

export interface Category {
  active: Scalars['Boolean']['output'];
  appDomainId: Scalars['Int']['output'];
  articleCount: Scalars['Int']['output'];
  breadcrumbs: Array<Maybe<CategoryBreadcrumb>>;
  /** Paginated collection of articles belonging to the category */
  categoryArticles: CategoryArticles;
  /**
   * By default only **active children categories that have articles** are returned. See the parameters list to tweak the query.
   * @deprecated Use childrenCategories_v2
   */
  childrenCategories: Array<Maybe<Category>>;
  childrenCategories_v2: CategoriesCollection;
  doNotShowOnDevice: Array<Maybe<Scalars['String']['output']>>;
  fullCms: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategory: Maybe<Category>;
  redirectCategory: Maybe<Category>;
  redirectUrl: Maybe<Scalars['String']['output']>;
  seo: Seo;
  seoBlock_v2: Maybe<CategorySeoBlock>;
  seoCms: Maybe<Scalars['String']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  styleAndTrendsCms: Maybe<Scalars['String']['output']>;
  urlPath: Scalars['String']['output'];
  visualNavigationEnabled: Scalars['Boolean']['output'];
}

export interface CategoryCategoryArticlesArgs {
  filters: InputMaybe<CategoryFiltersValues>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  optionsSorting?: InputMaybe<CategoryFilterOptionsSorting>;
  sort?: InputMaybe<CategoryArticlesSortOption>;
  urlParams: InputMaybe<Scalars['String']['input']>;
}

export interface CategoryChildrenCategoriesArgs {
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<CategoryListCategoryIn>;
  showOnDevice: InputMaybe<Array<CategoryDevice>>;
}

export interface CategoryChildrenCategories_V2Args {
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<CategoryListCategoryIn>;
  showOnDevice: InputMaybe<Array<CategoryDevice>>;
}

export interface CategoryImageArgs {
  format?: InputMaybe<CategoryImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface CategoryArticles {
  /** Collection of articles. */
  articles: Array<Maybe<Article>>;
  /** Number of articles in the current slice. */
  count: Scalars['Int']['output'];
  /** Collection of possible filters that can be used as selection criteria. */
  filters: Array<Maybe<CategoryFilter>>;
  /** Selected sort option */
  selectedSort: CategoryArticlesSortOption;
  /** Total number of articles meeting provided criteria. */
  totalCount: Scalars['Int']['output'];
}

export enum CategoryArticlesSortOption {
  AverageRating = 'AVERAGE_RATING',
  DiscountDesc = 'DISCOUNT_DESC',
  FirstSellableAtDesc = 'FIRST_SELLABLE_AT_DESC',
  Popularity = 'POPULARITY',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
}

export interface CategoryArticlesSortOptionLocalized {
  localized: Scalars['String']['output'];
  option: CategoryArticlesSortOption;
}

export interface CategoryBreadcrumb {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export enum CategoryDevice {
  /** Web browser on desktop device */
  Desktop = 'DESKTOP',
  /** Web browser on mobile device */
  Mobile = 'MOBILE',
  /** Mobile native application */
  MobileApp = 'MOBILE_APP',
}

export type CategoryFilter = CategoryOptionFilter | CategoryRangeFilter;

export enum CategoryFilterOptionsSorting {
  Alphabetical = 'ALPHABETICAL',
  ByArticleCountDesc = 'BY_ARTICLE_COUNT_DESC',
}

export interface CategoryFilterOptionsValue {
  key: Scalars['String']['input'];
  selected: Array<Scalars['String']['input']>;
}

export interface CategoryFilterRangeValue {
  key: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
}

export interface CategoryFiltersValues {
  options?: InputMaybe<Array<CategoryFilterOptionsValue>>;
  ranges?: InputMaybe<Array<CategoryFilterRangeValue>>;
}

export enum CategoryImageFormat {
  Avif = 'AVIF',
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP',
}

export enum CategoryListCategoryIn {
  MainNavigation = 'MAIN_NAVIGATION',
  MobileLegacyNavigation = 'MOBILE_LEGACY_NAVIGATION',
  SideNavigation = 'SIDE_NAVIGATION',
  VisualNavigation = 'VISUAL_NAVIGATION',
}

/**
 * **CategoryOptionFilter** represents a filter object that is used for selecting articles
 * having an article quality defined as one or multiple possible options.
 */
export interface CategoryOptionFilter {
  /** Filter `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Multiple options can be selected if `multiselect` is true. */
  multiselect: Maybe<Scalars['Boolean']['output']>;
  /** It is a localized filter name displayed on a page. */
  name: Scalars['String']['output'];
  /** Collection of filter options that can be selected for the current set of articles. */
  options: Array<Maybe<CategoryOptionFilterItem>>;
  /** Defines whether option icons should be displayed or not */
  showIcon: Maybe<Scalars['Boolean']['output']>;
}

/** **CategoryOptionFilterItem** represents a single option filter item that could be selected. */
export interface CategoryOptionFilterItem {
  /** It's a path to optional image that could be displayed together or instead of the text value. */
  imagePath: Maybe<Scalars['String']['output']>;
  /** Option `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Number of articles with particular option value. */
  numberOfArticles: Scalars['Int']['output'];
  /** `True` means that the options has been used in selection criteria of the current collection of articles. */
  selected: Scalars['Boolean']['output'];
  /** It is a localized value displayed on a page. */
  value: Scalars['String']['output'];
}

export interface CategoryPage {
  /** @deprecated Categories are no longer used. Use content tree. */
  categoryArticlesSortOptions: Array<CategoryArticlesSortOptionLocalized>;
  productList: Maybe<ProductList>;
  productListSortOptions: Array<ProductListArticlesSortOptionLocalized>;
}

/**
 * **CategoryRangeFilter** represents a filter object that is used for selecting articles
 * having a numerical value of an article quality withing [min, max] range.
 */
export interface CategoryRangeFilter {
  /** Maximum value that can be selected for the current collection of articles. */
  currentMax: Scalars['Int']['output'];
  /** Minimum value that can be selected for the current collection of articles. */
  currentMin: Scalars['Int']['output'];
  /** Filter `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Maximum value that can be selected for the current collection of articles. */
  max: Scalars['Int']['output'];
  /** Minimum value that can be selected for the current collection of articles. */
  min: Scalars['Int']['output'];
  /** It is a localized filter name displayed on a page. */
  name: Scalars['String']['output'];
  /** Optional maximum value selected by the user */
  selectedMax: Maybe<Scalars['Int']['output']>;
  /** Optional minimum value selected by the user */
  selectedMin: Maybe<Scalars['Int']['output']>;
  /** Unit of measure. */
  unit: Maybe<Scalars['String']['output']>;
}

export interface CategorySeoBlock {
  content: Scalars['String']['output'];
  richText: Scalars['Boolean']['output'];
}

/** Search result in category */
export interface CategorySuggestion {
  categoryId: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface CertificatesContent {
  certificate: Maybe<ArticleCertificate>;
}

/**
 * Challenge defines a commonly used input for protecting resources with a challenge.
 * See ChallengeType for supported challenges.
 */
export interface Challenge {
  payload: Scalars['String']['input'];
  type: ChallengeType;
}

export enum ChallengeType {
  /**
   * Providing this challenge type will perform a check against
   * AppCheck token sent inside request header.
   * Payload can be any or empty string.
   * The exact same logic will be performed if the "Challenge" field
   * is not provided at all.
   */
  AppCheckHeader = 'appCheckHeader',
  ReCaptcha = 'reCaptcha',
}

export interface CheckGiftCardBalanceBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface CheckGiftCardBalanceSlice extends ContentPageSlice {
  /** @deprecated use ContentPlaceholder */
  type: Scalars['String']['output'];
}

export interface Checkout {
  billingAddress: Maybe<Address>;
  id: Maybe<Scalars['String']['output']>;
  /**  returns a chosen payment method data  */
  payment: Maybe<Payment>;
  /**  returns available payment options for the checkout  */
  paymentOptions: CheckoutPaymentOptionResponse;
  shippingAddress: Maybe<Address>;
}

export interface CheckoutAddressInput {
  additional?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender: UserGender;
  lastName: Scalars['String']['input'];
  street: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
}

export interface CheckoutApplePayData {
  token: Scalars['String']['input'];
}

export enum CheckoutDesignType {
  Default = 'DEFAULT',
  SinglePage = 'SINGLE_PAGE',
}

export interface CheckoutDevice {
  browser?: InputMaybe<CheckoutDeviceBrowser>;
  deviceData?: InputMaybe<CheckoutDeviceData>;
  ip: Scalars['String']['input'];
  os: CheckoutDeviceOs;
  sessionId: Scalars['String']['input'];
  type: DeviceType;
}

export interface CheckoutDeviceBrowser {
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface CheckoutDeviceData {
  acceptHeader: Scalars['String']['input'];
  colorDepth: Scalars['Int']['input'];
  javaEnabled: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timeZoneOffset: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
}

export interface CheckoutDeviceOs {
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface CheckoutError {
  error: Scalars['String']['output'];
  errorDetail: Scalars['String']['output'];
}

export interface CheckoutOrder {
  activity: OrdersActivity;
  amountDue: Scalars['Int']['output'];
  billingAddress: Address;
  checkoutOrderGroups: Maybe<Array<SubOrder>>;
  currency: Scalars['String']['output'];
  discountTotal: Scalars['Int']['output'];
  ecoMobilierTotal: Maybe<Scalars['Int']['output']>;
  giftCardsDeductionTotal: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  netTotal: Scalars['Int']['output'];
  payback: Maybe<OrderPaybackData>;
  payment: OrderPayment;
  savingsTotal: Scalars['Int']['output'];
  shippingAddress: Address;
  shippingTotal: Scalars['Int']['output'];
  /** @deprecated use checkoutOrderGroups */
  subOrders: Maybe<Array<SubOrder>>;
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  voucherCode: Maybe<Scalars['String']['output']>;
}

export interface CheckoutPaymentAdyenCardUpdate {
  saveMode?: InputMaybe<CheckoutPaymentCardSaveMode>;
}

export enum CheckoutPaymentCardSaveMode {
  DoNotStore = 'DO_NOT_STORE',
  Immediate = 'IMMEDIATE',
  OnOrder = 'ON_ORDER',
}

export interface CheckoutPaymentData {
  applePay?: InputMaybe<CheckoutApplePayData>;
}

export interface CheckoutPaymentInput {
  creditcardAdyen?: InputMaybe<CheckoutPaymentInputAdyenCard>;
  creditcardPayone?: InputMaybe<CheckoutPaymentInputPayoneCard>;
  idealPayone?: InputMaybe<CheckoutPaymentInputIdealPayone>;
  maestroPayone?: InputMaybe<CheckoutPaymentInputPayoneCard>;
}

export interface CheckoutPaymentInputAdyenCard {
  cardType?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber: Scalars['String']['input'];
  encryptedExpiryMonth: Scalars['String']['input'];
  encryptedExpiryYear: Scalars['String']['input'];
  encryptedSecurityCode: Scalars['String']['input'];
  lastFour?: InputMaybe<Scalars['String']['input']>;
  owner: Scalars['String']['input'];
  saveMode?: InputMaybe<CheckoutPaymentCardSaveMode>;
}

export interface CheckoutPaymentInputIdealPayone {
  bankGroupType?: InputMaybe<Scalars['String']['input']>;
}

export interface CheckoutPaymentInputPayoneCard {
  expiryMonth: Scalars['String']['input'];
  expiryYear: Scalars['String']['input'];
  maskedCardNumber: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  pseudoCardPan: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

export enum CheckoutPaymentMethodType {
  AlmaAdyen = 'ALMA_ADYEN',
  ApplePay = 'APPLE_PAY',
  CreditcardAdyen = 'CREDITCARD_ADYEN',
  CreditcardPayone = 'CREDITCARD_PAYONE',
  Free = 'FREE',
  GcFree = 'GC_FREE',
  IdealAdyen = 'IDEAL_ADYEN',
  IdealPayone = 'IDEAL_PAYONE',
  InstallmentAfterpay = 'INSTALLMENT_AFTERPAY',
  InstallmentKlarna = 'INSTALLMENT_KLARNA',
  InvoiceH24 = 'INVOICE_H24',
  InvoiceKlarna = 'INVOICE_KLARNA',
  MaestroPayone = 'MAESTRO_PAYONE',
  Paypal = 'PAYPAL',
  PaypalAdyen = 'PAYPAL_ADYEN',
  PrepaymentH24 = 'PREPAYMENT_H24',
  TwintAdyen = 'TWINT_ADYEN',
}

export interface CheckoutPaymentMethodUpdate {
  adyenCard?: InputMaybe<CheckoutPaymentAdyenCardUpdate>;
}

export interface CheckoutPaymentOption {
  allowed: Scalars['Boolean']['output'];
  data: PaymentOption;
  method: CheckoutPaymentMethodType;
}

export interface CheckoutPaymentOptionResponse {
  paymentOptions: Maybe<Array<CheckoutPaymentOption>>;
  paymentOptionsErrors: Maybe<Array<CheckoutError>>;
}

export interface CheckoutResponse {
  cart: Maybe<CartResponse>;
  checkout: Maybe<Checkout>;
  errors: Maybe<Array<CheckoutError>>;
}

export interface CheckoutTracking {
  designType?: InputMaybe<CheckoutDesignType>;
}

export enum CheckoutType {
  Default = 'DEFAULT',
  Digital = 'DIGITAL',
}

export interface CheckoutWithCartResponse {
  cart: Maybe<CartResponse>;
  checkout: Maybe<CheckoutResponse>;
}

export enum ChildProductListSortOption {
  ArticleCount = 'articleCount',
  Position = 'position',
}

export interface CompanyValidationRules {
  legalForm: Array<ValidationRule_V2>;
  name: Array<ValidationRule_V2>;
  taxNumber: Array<ValidationRule_V2>;
  vatNumber: Array<ValidationRule_V2>;
}

export interface ConsolidatedItem {
  additionalServices: Maybe<Array<AdditionalService>>;
  allowedReclamationType: Maybe<ReclamationType>;
  article: Maybe<Article>;
  assemblyService: Maybe<OrderItemAssembly>;
  cancellationStatus: Maybe<OrderStatus>;
  delivery: OrderItemDelivery;
  electronicsDisposal: Scalars['Boolean']['output'];
  itemOrders: Array<OrderItemOrderV2>;
  lastItemOrder: OrderItemOrderV2;
  lastStatus: Maybe<OrderStatus>;
  lineID: Scalars['String']['output'];
  oms: Maybe<OrderItemOms>;
  price: Maybe<OrderItemPrice>;
  quantity: Scalars['Int']['output'];
  reclamationRequestsItems: Maybe<Array<ReclamationItem>>;
}

export interface ConsolidatedItemArticleArgs {
  locale: GQLLocale;
}

/**
 * Constructor.io feature flag with name and variant value.
 * Only enabled features (where features[name] = true) are included in the response.
 */
export interface ConstructorFeatureFlag {
  /** Feature name from Constructor.io (e.g., "query_items", "personalization") */
  featureName: Scalars['String']['output'];
  /** Feature variant value (e.g., "query_items_ctr_and_l2r", "default_personalization") */
  featureValue: Scalars['String']['output'];
}

export interface ContactForm {
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  slices: Array<Maybe<ContactFormSlice>>;
}

export interface ContactFormCallbackSolutionFieldSlice extends ContactFormSlice {
  disabled: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface ContactFormClaimReturnBlockSlice extends ContactFormSlice {
  type: Scalars['String']['output'];
}

export enum ContactFormCommunicationChannel {
  /** phone channel. Customer waits for callback from h24 */
  Callback = 'callback',
  /** regular channel where communication happens via email */
  Email = 'email',
}

export interface ContactFormCtaBlockSlice extends ContactFormSlice {
  type: Scalars['String']['output'];
}

export interface ContactFormNumericFieldSlice extends ContactFormSlice {
  fieldName: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface ContactFormOrderNumberFieldSlice extends ContactFormSlice {
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface ContactFormOutletBlockSlice extends ContactFormSlice {
  type: Scalars['String']['output'];
}

export interface ContactFormPhoneFieldSlice extends ContactFormSlice {
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface ContactFormSettings {
  closingTime: Scalars['String']['output'];
  disabledHolidays: Array<Maybe<DisabledHoliday>>;
  disabledWeekdays: Array<Maybe<DisabledWeekday>>;
  isEnabled: Scalars['Boolean']['output'];
  openingTime: Scalars['String']['output'];
}

export interface ContactFormSlice {
  type: Scalars['String']['output'];
}

export interface ContactFormTextFieldSlice extends ContactFormSlice {
  fieldName: Maybe<Scalars['String']['output']>;
  fieldType: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface Content {
  campaign: Maybe<ContentCampaign>;
  /** @deprecated Use `contentTreeCategoryPage_v2`, https://home24.atlassian.net/browse/SPP-5855 */
  contentTreeCategoryPage: Maybe<ContentCategoryPage>;
  contentTreeCategoryPage_v2: Maybe<ContentCategoryPage>;
  generalDisclaimerInfo: Maybe<ContentGeneralDisclaimerInfo>;
  howToTakeAGoodPicture: Maybe<ContentHowToTakeAGoodPicture>;
  miniUspTeaser: Maybe<ContentUspTeaser>;
  navigation_v2: Maybe<ContentGlobalNavigation_V2>;
  referralRegistrationPage: Maybe<ContentReferralRegistrationPage>;
}

export interface ContentCampaignArgs {
  ref: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
}

export interface ContentContentTreeCategoryPageArgs {
  ref: InputMaybe<Scalars['String']['input']>;
  urlPath: Scalars['String']['input'];
}

export interface ContentContentTreeCategoryPage_V2Args {
  ref: InputMaybe<Scalars['String']['input']>;
  urlParams: InputMaybe<Scalars['String']['input']>;
  urlPath: Scalars['String']['input'];
}

export interface ContentGeneralDisclaimerInfoArgs {
  ref: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
}

export interface ContentHowToTakeAGoodPictureArgs {
  ref: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
}

export interface ContentMiniUspTeaserArgs {
  ref: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
}

export interface ContentNavigation_V2Args {
  ref: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
}

export interface ContentReferralRegistrationPageArgs {
  ref: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
}

export interface ContentArticleHeader extends ContentPageSlice {
  articleTitle: Scalars['String']['output'];
  articleTitleColor: Maybe<Scalars['String']['output']>;
  /** @deprecated Use author_v2, https://home24.atlassian.net/browse/FP-4711 */
  author: Maybe<Scalars['String']['output']>;
  author_v2: Array<Maybe<Author>>;
  category: Maybe<Scalars['String']['output']>;
  isArticleInfoHidden: Scalars['Boolean']['output'];
  isCategoryHidden: Scalars['Boolean']['output'];
  isHeaderLeftAligned: Scalars['Boolean']['output'];
  isHeaderWithReducedWidth: Scalars['Boolean']['output'];
  publishingDate: Maybe<Scalars['String']['output']>;
  readingTimeMinutes: Scalars['Int']['output'];
  type: Scalars['String']['output'];
}

export interface ContentArticlesNavigation extends ContentPageSlice {
  nextArticle: Maybe<ContentNamedContentLink>;
  prevArticle: Maybe<ContentNamedContentLink>;
  type: Scalars['String']['output'];
}

export interface ContentBrandsGlossarySlice extends ContentPageSlice {
  glossary: Maybe<BrandGlossary>;
  heading: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface ContentCampaign {
  campaignBanner: Maybe<CampaignBannerSlice>;
  globalRibbons: Array<ContentGlobalRibbonSlice>;
  inspirationalTeasers: Array<ContentInspirationalTeaserSlice>;
  listNavigations: Array<ContentListNavigationSlice>;
  listViewTeasers: Array<ProductListViewTeaser>;
  newsletterOverlays: Array<ContentNewsletterOverlaySlice>;
  newsletters: Array<ContentNewsletterSlice>;
  offerTeasers: Array<ContentOfferTeaserSlice>;
  offerTeasersV2: Array<ContentOfferTeaserV2Slice>;
  popUps: Array<ContentPopUpSlice>;
  smartBaners: Array<ContentSmartBannerSlice>;
  tabBars: Array<ContentTabBar>;
  topBanners: Array<ContentTopBannerSlice>;
  topBannersV2: Array<ContentTopBannerV2Slice>;
  /** @deprecated use topTeasersV2 */
  topTeasers: Array<ContentTopTeaserSlice>;
  topTeasersV2: Array<ContentTopTeaserV2Slice>;
  visualNavigation: Array<ContentVisualNavigationSlice>;
  /** @deprecated Use `campaignBanner`, https://home24.atlassian.net/browse/SPP-5738 */
  voucherBanners: Array<ContentVoucherBannerSlice>;
  /** @deprecated Use `campaignBanner`, https://home24.atlassian.net/browse/SPP-5738 */
  voucherBanners_v2: Array<ContentVoucherBannerSlice_V2>;
  /** @deprecated Use `campaignBanner`, https://home24.atlassian.net/browse/SPP-5738  */
  voucherBanners_v3: Maybe<ContentVoucherBannerSlice_V3>;
  voucherPromotions: Array<ContentVoucherPromotions>;
}

export interface ContentCardGridItem {
  headline: Maybe<Scalars['String']['output']>;
  href: Maybe<ContentLink>;
  image: Maybe<ContentExtendedContentImageSet>;
  subline: Maybe<Scalars['String']['output']>;
}

export interface ContentCardGridSlice extends ContentPageSlice {
  isLayoutCarousel: Maybe<Scalars['Boolean']['output']>;
  items: Array<Maybe<ContentCardGridItem>>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

/**
 * ***ContentCategory*** contains category fields coming from the integration
 * of the CategoryService with prismic.
 */
export interface ContentCategory {
  /** IDs of children categories. */
  childrenIds: Array<Maybe<Scalars['String']['output']>>;
  /** URL of the category icon (for mobile app). */
  icon: Maybe<Scalars['String']['output']>;
  /** Category ID. */
  id: Maybe<Scalars['String']['output']>;
  /** URL of the category image for visual navigation. */
  image: Maybe<Scalars['String']['output']>;
  /** Short title. */
  shortTitle: Maybe<Scalars['String']['output']>;
  /** Category title. */
  title: Maybe<Scalars['String']['output']>;
  /** Relative path to the category page (eg. 'kategorie/moebel/') */
  urlPath: Maybe<Scalars['String']['output']>;
}

export interface ContentCategoryFaqBlock {
  faqItems: Maybe<Array<Maybe<ContentCategoryFaqItem>>>;
  title: Maybe<Scalars['String']['output']>;
}

export interface ContentCategoryFaqItem {
  answer: Maybe<Scalars['String']['output']>;
  question: Maybe<Scalars['String']['output']>;
}

export interface ContentCategoryPage {
  /** Links to localized versions of the same document. */
  altLocales: Array<Maybe<ContentDocLink>>;
  categoryUrlPath: Maybe<Scalars['String']['output']>;
  contentTreeUrlPath: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  faqBlock: Maybe<ContentCategoryFaqBlock>;
  locale: Scalars['String']['output'];
  seoBlock: Maybe<ContentCategorySeoBlock>;
  uid: Maybe<Scalars['String']['output']>;
}

export interface ContentCategorySeoBlock {
  seoContent: Maybe<Scalars['String']['output']>;
}

export enum ContentCtaButtonType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

export interface ContentCtaButtons extends ContentPageSlice {
  items: Array<Maybe<ContentCtaButtonsItem>>;
  type: Scalars['String']['output'];
}

export interface ContentCtaButtonsItem {
  ariaLabel: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentImage>;
  kind: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  link: Maybe<ContentLink>;
}

export interface ContentDyGlobalRibbon extends ContentPageSlice {
  type: Scalars['String']['output'];
}

export interface ContentDyListNavigation extends ContentPageSlice {
  selector: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface ContentDyOfferTeaserV2Slice extends ContentPageSlice {
  isGridComponentType: Scalars['Boolean']['output'];
  mainSubtitle: Maybe<Scalars['String']['output']>;
  mainTitle: Maybe<Scalars['String']['output']>;
  selector: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  withCardFrame: Scalars['Boolean']['output'];
}

export interface ContentDyTopBanner extends ContentPageSlice {
  type: Scalars['String']['output'];
}

export interface ContentDyVisualNavigation extends ContentPageSlice {
  selector: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentDyVoucherPromotions extends ContentPageSlice {
  selector: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

/**
 * ***ContentDocLink*** is a reference to a Prismic document identified by:
 * document `type`, `locale`, and `uid`. `id` is a global unique identifier
 * of a document in Prismic, however there is no use of it in `Cosmic API`.
 */
export interface ContentDocLink {
  id: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uid: Scalars['String']['output'];
}

export interface ContentDoublePictureTextSlice extends ContentPageSlice {
  items: Array<Maybe<ContentPictureTextSliceItem>>;
  type: Scalars['String']['output'];
}

/**
 * ***ContentExtendedContentImageSet*** contains original image, a thumbnail, and
 * 3 images suitable for different screen size break points of a particular device.
 */
export interface ContentExtendedContentImageSet {
  /** The image of original size that was uploaded to Prismic. */
  original: Maybe<ContentImage>;
  /** The thumbnail image. */
  thumbnail: Maybe<ContentImage>;
  /** Small size image. */
  x1: Maybe<ContentImage>;
  /** Medium size image. */
  x2: Maybe<ContentImage>;
  /** Large size image. */
  x3: Maybe<ContentImage>;
}

export interface ContentExternalScript extends ContentPageSlice {
  /** @deprecated use ContentPlaceholder */
  selector: Scalars['String']['output'];
  /** @deprecated use ContentPlaceholder */
  type: Scalars['String']['output'];
}

/** ***ContentFooterItem_v2*** is a single element in the footer. */
export interface ContentFooterItem_V2 {
  href: Maybe<Scalars['String']['output']>;
  /** An icon */
  icon: Maybe<ContentImage>;
  /** Usually label is displayed if there is no icon. */
  label: Maybe<Scalars['String']['output']>;
  target: Maybe<Scalars['String']['output']>;
  /** Usually used as 'title' attribute of HTML <a> tag. */
  title: Maybe<Scalars['String']['output']>;
}

/** ***ContentFooterSection*** represents a group of elements in the footer. */
export interface ContentFooterSection_V2 {
  items: Array<ContentFooterItem_V2>;
  /** Section title. */
  title: Scalars['String']['output'];
}

export interface ContentFooter_V2 {
  /** General links */
  general: Maybe<ContentFooterSection_V2>;
  /** Help and customer related links */
  help: Maybe<ContentFooterSection_V2>;
  /** Links to other home24 domains */
  international: Maybe<ContentFooterSection_V2>;
  legalText: Maybe<Scalars['String']['output']>;
  /** Payment methods */
  payment: Maybe<ContentFooterSection_V2>;
  /** Carriers */
  shipping: Maybe<ContentFooterSection_V2>;
  /** Links to home24 profile in social media */
  socialMedia: Maybe<ContentFooterSection_V2>;
}

/**
 * Contains an image with various sizes suitable for
 * desktop, tablet, and mobile screens. Original image
 * and its thumbnail are present too.
 */
export interface ContentFullContentImageSet {
  /** Set of images suitable for a desktop. */
  forDesktop: Maybe<ContentImageSet>;
  /** Set of images suitable for a large desktop */
  forLargeDesktop: Maybe<ContentImageSet>;
  /** Set of images suitable for a mobile */
  forMobile: Maybe<ContentImageSet>;
  /** Set of images suitable for a tablet. */
  forTablet: Maybe<ContentImageSet>;
  /** The image of original size that was uploaded to Prismic. */
  original: Maybe<ContentImage>;
  /** The thumbnail image. */
  thumbnail: Maybe<ContentImage>;
}

export interface ContentGeneralDisclaimerInfo {
  documentType: Scalars['String']['output'];
  linkLabel: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<ContentLink>;
  locale: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  showMessage: Scalars['Boolean']['output'];
  uid: Scalars['String']['output'];
}

/**
 * ***ContentGeoPoint*** represents geographical coordinates:
 * `latitude` and `longitude` as floating point numbers.
 */
export interface ContentGeoPoint {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
}

export interface ContentGlobalNavigation_V2 {
  footer: Maybe<ContentFooter_V2>;
  navigation: Maybe<ContentNavigation>;
  newsletterSignupBox: Maybe<ContentNewsletterSignup_V2>;
  trustSeals: Array<Maybe<TrustSealItem>>;
  uspBar_v2: Maybe<ContentUspBar_V2>;
}

export interface ContentGlobalRibbonSlice {
  contentId: Maybe<Scalars['String']['output']>;
  countdownColor: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  countdownLabel: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaColor: Maybe<Scalars['String']['output']>;
  ctaLink: Maybe<ContentLink>;
  ctaText: Maybe<Scalars['String']['output']>;
  endBgColor: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  headlineColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLabelColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  startBgColor: Maybe<Scalars['String']['output']>;
  storer: Maybe<Scalars['String']['output']>;
  storerLineColor: Maybe<Scalars['String']['output']>;
  storerTextColor: Maybe<Scalars['String']['output']>;
  subTitle: Maybe<Scalars['String']['output']>;
  subTitleColor: Maybe<Scalars['String']['output']>;
}

export interface ContentHalfPictureTextSlice extends ContentPageSlice {
  items: Array<Maybe<ContentPictureTextSliceItem>>;
  type: Scalars['String']['output'];
}

export interface ContentHomeClubSlice extends ContentPageSlice {
  /** @deprecated use ContentPlaceholder */
  type: Scalars['String']['output'];
}

export interface ContentHowToTakeAGoodPicture {
  description: Maybe<Scalars['String']['output']>;
  photoSectionDamage: Array<Maybe<ContentHowToTakeAGoodPicturePhotoSection>>;
  photoSectionPackaging: Array<Maybe<ContentHowToTakeAGoodPicturePhotoSection>>;
  photoSectionToAvoid: Array<Maybe<ContentHowToTakeAGoodPicturePhotoSection>>;
  textSectionDamage: Array<Maybe<ContentHowToTakeAGoodPictureTextSection>>;
  textSectionPackaging: Array<Maybe<ContentHowToTakeAGoodPictureTextSection>>;
  textSectionToAvoid: Array<Maybe<ContentHowToTakeAGoodPictureTextSection>>;
  title: Maybe<Scalars['String']['output']>;
}

export interface ContentHowToTakeAGoodPicturePhotoSection {
  photo: Maybe<ContentExtendedContentImageSet>;
}

export interface ContentHowToTakeAGoodPictureTextSection {
  heading: Maybe<Scalars['String']['output']>;
  paragraph: Maybe<Scalars['String']['output']>;
}

/** ***ContentImage*** represents a single image (no resized variants). */
export interface ContentImage {
  /** `alt` attribute of the HTML `<img>` tag. */
  alt: Maybe<Scalars['String']['output']>;
  /** Copyright text of the image. */
  copyright: Maybe<Scalars['String']['output']>;
  /** Height of the image in pixels. */
  height: Scalars['Int']['output'];
  /** Reference to a Media document. */
  media: Maybe<Media>;
  /** Image URL. */
  url: Scalars['String']['output'];
  /** Width of the image in pixels. */
  width: Scalars['Int']['output'];
}

/**
 * ***ContentImageSet*** contains 3 images suitable for different
 * screen size break points of a particular device.
 */
export interface ContentImageSet {
  /** Small size image. */
  x1: Maybe<ContentImage>;
  /** Medium size image. */
  x2: Maybe<ContentImage>;
  /** Large size image. */
  x3: Maybe<ContentImage>;
}

export interface ContentInspirationalTeaserSlice {
  category: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  enhancedImage: Maybe<ContentFullContentImageSet>;
  image: Maybe<ContentFullContentImageSet>;
  link: Maybe<ContentLink>;
  name: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
}

/**
 * ***ContentLink*** repesents external or Prismic internal link.
 * If `type == 'web'` use `url` and `target` fields.
 * If `type == 'document'` use `locale`, `documentType`, and `uid` fields.
 */
export interface ContentLink {
  /** Prismic document type of referenced document. */
  documentType: Maybe<Scalars['String']['output']>;
  /** If present it's a full url with host name, regardless the url is just a relative path or a full url too */
  fullUrl: Maybe<Scalars['String']['output']>;
  /** `id` of referenced Prismic document. */
  id: Maybe<Scalars['String']['output']>;
  /** `linkTarget` could be `ContentPageTarget`, `UrlMappingTarget` */
  linkTarget: UrlMappingTarget;
  /** `locale` of referenced Prismic document. */
  locale: Maybe<Scalars['String']['output']>;
  /** `target` attribute of `<href>` HTML tag. */
  target: Maybe<Scalars['String']['output']>;
  /** Link type could be `web`, `document`, `any` */
  type: Scalars['String']['output'];
  /** `uid` of referenced Prismic document. */
  uid: Maybe<Scalars['String']['output']>;
  /**
   * Link URL.
   * @deprecated due to inconsistent behavior use rather `fullUrl` field
   */
  url: Maybe<Scalars['String']['output']>;
}

export interface ContentListNavigationSlice extends ContentPageSlice {
  contentId: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<ContentListNavigationSliceItem>>;
  name: Maybe<Scalars['String']['output']>;
  seeAllLabel: Maybe<Scalars['String']['output']>;
  seeAllLink: Maybe<ContentLink>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentListNavigationSliceItem {
  description: Maybe<Scalars['String']['output']>;
  link: Maybe<ContentLink>;
}

export interface ContentLocalBusinessDataSlice {
  addressLocality: Maybe<Scalars['String']['output']>;
  geo: Maybe<ContentGeoPoint>;
  images: Maybe<Array<Maybe<ContentFullContentImageSet>>>;
  locationUrl: Maybe<ContentLink>;
  name: Scalars['String']['output'];
  openingHoursSpecification: Maybe<Array<Maybe<OpeningHours>>>;
  phone: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
}

/** ***ContentNamedContentLink*** contains a link and it's name. */
export interface ContentNamedContentLink {
  link: Maybe<ContentLink>;
  name: Maybe<Scalars['String']['output']>;
}

export interface ContentNavigation {
  isContentTree: Maybe<Scalars['Boolean']['output']>;
  items: Array<Maybe<ContentNavigationLevel1Item>>;
  name: Scalars['String']['output'];
  tabs: Array<ContentNavigationTab>;
}

export interface ContentNavigationLevel1Item {
  href: Scalars['String']['output'];
  /** Display only on new global nav or on both */
  isInTopNavigation: Scalars['Boolean']['output'];
  /** If the item is below or above the line */
  isPrimary: Scalars['Boolean']['output'];
  items: Array<Maybe<ContentNavigationLevel1ItemChild>>;
  modifiers: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail: Maybe<ContentImage>;
}

export interface ContentNavigationLevel1ItemItemsArgs {
  withPromo: Scalars['Boolean']['input'];
  withTopCategory: InputMaybe<Scalars['Boolean']['input']>;
}

export type ContentNavigationLevel1ItemChild =
  | ContentNavigationLevel1ItemImgChild
  | ContentNavigationLevel2Item;

export interface ContentNavigationLevel1ItemImgChild {
  promoImg: Maybe<ContentNavigationPromoImage>;
  promoImgV2: Maybe<ContentNavigationPromoImageV2>;
}

export type ContentNavigationLevel2Child =
  | ContentNavigationLevel2ItemImgChild
  | ContentNavigationLevel3Item;

export interface ContentNavigationLevel2Item {
  column: Maybe<Scalars['Int']['output']>;
  href: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  items: Array<Maybe<ContentNavigationLevel3Item>>;
  itemsV2: Array<Maybe<ContentNavigationLevel2Child>>;
  modifiers: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail: Maybe<ContentImage>;
}

export interface ContentNavigationLevel2ItemItemsV2Args {
  withPromo: Scalars['Boolean']['input'];
}

export interface ContentNavigationLevel2ItemImgChild {
  promoImgV2: Maybe<ContentNavigationPromoImageV2>;
}

export interface ContentNavigationLevel3Item {
  href: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  modifiers: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail: Maybe<ContentImage>;
}

export interface ContentNavigationPromoImage {
  alt: Maybe<Scalars['String']['output']>;
  copyright: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  thumbnail: Maybe<Scalars['String']['output']>;
  x1: Maybe<Scalars['String']['output']>;
  x2: Maybe<Scalars['String']['output']>;
  x3: Maybe<Scalars['String']['output']>;
}

export interface ContentNavigationPromoImageV2 {
  alt: Maybe<Scalars['String']['output']>;
  copyright: Maybe<Scalars['String']['output']>;
  ctaLink: Maybe<ContentLink>;
  ctaText: Maybe<Scalars['String']['output']>;
  headlineText: Maybe<Scalars['String']['output']>;
  x1: Maybe<Scalars['String']['output']>;
  x2: Maybe<Scalars['String']['output']>;
  x3: Maybe<Scalars['String']['output']>;
}

export interface ContentNavigationTab {
  items: Array<ContentNavigationLevel1Item>;
  label: Scalars['String']['output'];
}

export interface ContentNewsletterOverlaySlice {
  asteriskColor: Maybe<Scalars['String']['output']>;
  asteriskText: Maybe<Scalars['String']['output']>;
  backgroundColor: Maybe<Scalars['String']['output']>;
  contentColor: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  contentText: Maybe<Scalars['String']['output']>;
  headingColor: Maybe<Scalars['String']['output']>;
  headingText: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  newsletterType: SubscriptionTypeAnon;
  timeOnPage: Maybe<Scalars['Float']['output']>;
  triggerType: Maybe<Scalars['String']['output']>;
}

export interface ContentNewsletterSignupVoucher {
  amount: Maybe<Scalars['Int']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
}

export interface ContentNewsletterSignup_V2 {
  headline: Maybe<Scalars['String']['output']>;
  voucher: Maybe<ContentNewsletterSignupVoucher>;
}

export interface ContentNewsletterSlice extends ContentPageSlice {
  asteriskText: Maybe<Scalars['String']['output']>;
  buttonKind: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  endColor: Maybe<Scalars['String']['output']>;
  headingText: Maybe<Scalars['String']['output']>;
  icon: Maybe<ContentExtendedContentImageSet>;
  name: Maybe<Scalars['String']['output']>;
  newsletterType: SubscriptionTypeAnon;
  startColor: Maybe<Scalars['String']['output']>;
  subline: Maybe<Scalars['String']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentOfferTeaserImage {
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonLink: Maybe<ContentLink>;
  enhancedImage: Maybe<ContentFullContentImageSet>;
  image: Maybe<ContentFullContentImageSet>;
  /** ***legalDisclaimerContent*** is a raw JSON strings representing a rich text field in Prismic. */
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  placement: Maybe<Scalars['String']['output']>;
  stoererBorderColor: Maybe<Scalars['String']['output']>;
  stoererLabel: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
}

export interface ContentOfferTeaserSlice {
  contentId: Maybe<Scalars['String']['output']>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonLink: Maybe<ContentLink>;
  enhancedImage: Maybe<ContentFullContentImageSet>;
  image: Maybe<ContentFullContentImageSet>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  stoererBorderColor: Maybe<Scalars['String']['output']>;
  stoererLabel: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
}

export interface ContentOfferTeaserV2Slice extends ContentPageSlice {
  backgroundColor: Maybe<Scalars['String']['output']>;
  bodyText: Maybe<Scalars['String']['output']>;
  campaignDuration: Maybe<Scalars['String']['output']>;
  caption: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonType: Maybe<Scalars['String']['output']>;
  ctaButtonUrl: Maybe<ContentLink>;
  image: Maybe<ContentFullContentImageSet>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  /** Common fields for all campaign teaser slices */
  textColor: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  /** Specific fields for the offer teaser slice */
  type: Scalars['String']['output'];
  /** @deprecated deprecate it's no longer use. https://home24.atlassian.net/browse/SPP-5599 */
  voucherCode: Maybe<Scalars['String']['output']>;
}

export interface ContentOneTrustSettingsOverlay extends ContentPageSlice {
  /** @deprecated use ContentPlaceholder */
  type: Scalars['String']['output'];
}

export interface ContentOrganizationDataSlice {
  contactType: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sameAs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telephone: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
}

export interface ContentPage {
  /** Links to localized versions of the same document. */
  altLocales: Array<Maybe<ContentDocLink>>;
  author: Array<Author>;
  breadcrumbs: Array<Maybe<ContentNamedContentLink>>;
  dateModified: Scalars['String']['output'];
  datePublished: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  headline: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  schemaOrgType: SchemaOrgType;
  /** @deprecated Use seo_v2 */
  seo: ContentPageSeo;
  seo_v2: Maybe<ContentPageSeo>;
  slices: Array<Maybe<ContentPageSlice>>;
  /** @deprecated Use seo_v2.metaTitle */
  title: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
}

export interface ContentPageSeo {
  canonicalUrl: Maybe<ContentLink>;
  contentPageL1: Maybe<Scalars['String']['output']>;
  contentPageL2: Maybe<Scalars['String']['output']>;
  localBusinessStructuredData: Maybe<ContentLocalBusinessDataSlice>;
  metaDescription: Maybe<Scalars['String']['output']>;
  metaTitle: Maybe<Scalars['String']['output']>;
  /** @deprecated Use openGraphImage_v2 */
  openGraphImage: Maybe<ContentImage>;
  openGraphImage_v2: Maybe<ContentFullContentImageSet>;
  organizationStructuredData: Maybe<ContentOrganizationDataSlice>;
  robots: Scalars['String']['output'];
  websiteStructuredData: Maybe<ContentWebsiteDataSlice>;
}

export interface ContentPageSlice {
  type: Scalars['String']['output'];
}

export interface ContentPictureTextSliceItem {
  ctaBackgroundColor: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaLabelColor: Maybe<Scalars['String']['output']>;
  ctaUrl: Maybe<ContentLink>;
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  imageMarkers: Maybe<Array<Maybe<ImageMarker>>>;
  revert: Scalars['Boolean']['output'];
  showInPremium: Scalars['Boolean']['output'];
}

export interface ContentPlaceholder extends ContentPageSlice {
  selector: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface ContentPlaceholderSlice extends ContentPageSlice {
  isTitleCenterAligned: Scalars['Boolean']['output'];
  titleText: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentPopUpSlice {
  asteriskColor: Maybe<Scalars['String']['output']>;
  asteriskText: Maybe<Scalars['String']['output']>;
  backgroundColor: Maybe<Scalars['String']['output']>;
  contentColor: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  contentText: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaButtonHref: Maybe<ContentLink>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonType: Maybe<Scalars['String']['output']>;
  headingColor: Maybe<Scalars['String']['output']>;
  headingText: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  headlineColor: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  isFullScreen: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  newsletterType: SubscriptionTypeAnon;
  showCta: Scalars['Boolean']['output'];
  showNewsletterInputField: Scalars['Boolean']['output'];
  timeOnPage: Maybe<Scalars['Float']['output']>;
  triggerType: Maybe<Scalars['String']['output']>;
}

export type ContentPreviewPage_V2 =
  | CategoryPage
  | ContentCampaign
  | ContentGeneralDisclaimerInfo
  | ContentGlobalNavigation_V2
  | ContentPage;

/**
 * Prismic-native GlobalRibbon slice that allows content editors to author
 * promotional ribbon banners directly in Prismic CMS without Dynamic Yield.
 * Used for promotional ribbons on content pages like Intermediary Category Page.
 */
export interface ContentPrismicGlobalRibbonSlice extends ContentPageSlice {
  contentId: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaColor: Maybe<Scalars['String']['output']>;
  ctaLink: Maybe<ContentLink>;
  ctaText: Maybe<Scalars['String']['output']>;
  endBgColor: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  headlineColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLabelColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  startBgColor: Maybe<Scalars['String']['output']>;
  storer: Maybe<Scalars['String']['output']>;
  storerLineColor: Maybe<Scalars['String']['output']>;
  storerTextColor: Maybe<Scalars['String']['output']>;
  subtitleColor: Maybe<Scalars['String']['output']>;
  subtitleText: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

/**
 * Individual card item within a Prismic OfferTeaserV2 slice.
 * Each card can have an image, title, CTA button, countdown timer, and legal disclaimer.
 */
export interface ContentPrismicOfferTeaserV2Item {
  backgroundColor: Maybe<Scalars['String']['output']>;
  bodyText: Maybe<Scalars['String']['output']>;
  campaignDuration: Maybe<Scalars['String']['output']>;
  caption: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonType: Maybe<Scalars['String']['output']>;
  ctaButtonUrl: Maybe<ContentLink>;
  image: Maybe<ContentFullContentImageSet>;
  isMultiVoucher: Maybe<Scalars['Boolean']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  voucherCode: Maybe<Scalars['String']['output']>;
}

/**
 * Prismic-native OfferTeaserV2 slice that allows content editors to author
 * multiple card items directly in Prismic CMS without Dynamic Yield.
 * Used for promotional grids/carousels on pages like Intermediary Category Page.
 */
export interface ContentPrismicOfferTeaserV2Slice extends ContentPageSlice {
  isGridComponentType: Scalars['Boolean']['output'];
  items: Array<ContentPrismicOfferTeaserV2Item>;
  mainSubtitle: Maybe<Scalars['String']['output']>;
  mainTitle: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  withCardFrame: Scalars['Boolean']['output'];
}

export interface ContentProductListSlice extends ContentPageSlice {
  articles: Array<Maybe<Article>>;
  ctaHref: Maybe<ContentLink>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaType: Maybe<ContentCtaButtonType>;
  heading: Maybe<Scalars['String']['output']>;
  headingCenterAligned: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface ContentRecommendationSlider extends ContentPageSlice {
  selector: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentReferralRegistrationPage {
  disclaimerText: Maybe<Scalars['String']['output']>;
  offerText: Maybe<Scalars['String']['output']>;
  topIcon: Maybe<ContentImage>;
}

export interface ContentShopInShopSlice extends ContentPageSlice {
  /** @deprecated use ContentShopInShopSliceV2 */
  logoImage: Maybe<ContentFullContentImageSet>;
  /** @deprecated use ContentShopInShopSliceV2 */
  shopName: Scalars['String']['output'];
  /** @deprecated use ContentShopInShopSliceV2 */
  type: Scalars['String']['output'];
}

export interface ContentShopInShopSliceV2 extends ContentPageSlice {
  data: ShopInShopData;
  dataDocUid: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface ContentShopTheLookSlice extends ContentPageSlice {
  desktopImage: Maybe<ContentFullContentImageSet>;
  desktopImageMarkers: Maybe<Array<Maybe<ImageMarker>>>;
  /** @deprecated Use mobileImage and desktopImage for device-specific images - https://home24.atlassian.net/browse/INSP-59 */
  image: Maybe<ContentFullContentImageSet>;
  /** @deprecated Use mobileImageMarkers and desktopImageMarkers for device-specific markers - https://home24.atlassian.net/browse/INSP-59 */
  imageMarkers: Maybe<Array<Maybe<ImageMarker>>>;
  items: Array<Maybe<Article>>;
  mobileImage: Maybe<ContentFullContentImageSet>;
  mobileImageMarkers: Maybe<Array<Maybe<ImageMarker>>>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentShowroomOutletHeadingSlice extends ContentPageSlice {
  addressLocality: Maybe<Scalars['String']['output']>;
  extraInfo: Maybe<Scalars['String']['output']>;
  instagramLabel: Maybe<Scalars['String']['output']>;
  instagramLink: Maybe<ContentLink>;
  locationUrl: Maybe<ContentLink>;
  openingHoursSpecification: Maybe<Array<Maybe<OpeningHours>>>;
  phone: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentSlider extends ContentPageSlice {
  /** Default items limit is 21 and maximum is 100 */
  items: Maybe<Array<ContentSliderItem>>;
  seeAllLink: Maybe<ContentLink>;
  seeAllText: Maybe<Scalars['String']['output']>;
  titleText: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentSliderItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface ContentSliderItem {
  headline: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  subtitle: Maybe<Scalars['String']['output']>;
  url: Maybe<ContentLink>;
}

export interface ContentSmartBannerSlice {
  contentId: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaType: Maybe<ContentCtaButtonType>;
  endBackgroundColor: Maybe<Scalars['String']['output']>;
  icon: Maybe<ContentExtendedContentImageSet>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  startBackgroundColor: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  titleColor: Maybe<Scalars['String']['output']>;
}

export interface ContentStoreShortInfo {
  image: Maybe<ContentFullContentImageSet>;
  link: Maybe<ContentLink>;
  metaTitle: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
}

export interface ContentTabBar extends ContentPageSlice {
  activeBackgroundColor: Maybe<Scalars['String']['output']>;
  activeTextColor: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<ContentTabBarItem>>;
  name: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentTabBarItem {
  ariaLabel: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  link: Maybe<ContentLink>;
  text: Maybe<Scalars['String']['output']>;
}

export interface ContentTextBlock extends ContentPageSlice {
  content: Scalars['String']['output'];
  isContentCenterAligned: Scalars['Boolean']['output'];
  isContentWithReducedWidth: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface ContentTopBannerSlice extends ContentPageSlice {
  bannerEndBgColor: Maybe<Scalars['String']['output']>;
  bannerStartBgColor: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownColor: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  countdownLabel: Maybe<Scalars['String']['output']>;
  ctaColor: Maybe<Scalars['String']['output']>;
  ctaDisclaimerText: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLabelColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  storer: Maybe<Scalars['String']['output']>;
  storerLineColor: Maybe<Scalars['String']['output']>;
  storerTextColor: Maybe<Scalars['String']['output']>;
  subTitle: Maybe<Scalars['String']['output']>;
  subTitleColor: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  titleColor: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  voucherCode: Maybe<Scalars['String']['output']>;
  voucherCodeBoxBgColor: Maybe<Scalars['String']['output']>;
  voucherCodeLabel: Maybe<Scalars['String']['output']>;
  voucherCodeTextColor: Maybe<Scalars['String']['output']>;
}

export interface ContentTopBannerV2Slice extends CampaignDocumentCommonFields, ContentPageSlice {
  backgroundColor: Maybe<Scalars['String']['output']>;
  campaignDuration: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaDisclaimerContent: Maybe<Scalars['String']['output']>;
  desktopImage: Maybe<ContentFullContentImageSet>;
  desktopImageSlim: Maybe<ContentFullContentImageSet>;
  desktopVideo: Maybe<Scalars['String']['output']>;
  isFullWidth: Maybe<Scalars['Boolean']['output']>;
  isMultiVoucher: Maybe<Scalars['Boolean']['output']>;
  isViewportWide: Maybe<Scalars['Boolean']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  logoImage: Maybe<ContentExtendedContentImageSet>;
  mobileImage: Maybe<ContentFullContentImageSet>;
  mobileImageSlim: Maybe<ContentFullContentImageSet>;
  mobileVideo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  /** Common fields for all campaign banner slices */
  textColor: Maybe<Scalars['String']['output']>;
  textContainerOpacity: Maybe<Scalars['String']['output']>;
  textContainerPosition: Maybe<TextContainerPosition>;
  title: Maybe<Scalars['String']['output']>;
  /** Specific fields for campaign banner slices */
  type: Scalars['String']['output'];
  voucherCode: Maybe<Scalars['String']['output']>;
}

export interface ContentTopNewsSection extends ContentPageSlice {
  /** headline_big_image field from Prismic. */
  headlineLargeImage: Scalars['String']['output'];
  headlineSmallImages: Scalars['String']['output'];
  items: Array<Maybe<ContentTopNewsSectionItem>>;
  /** big_image field from Prismic. */
  largeImage: ContentFullContentImageSet;
  /** subtitle_big_image field from Prismic. */
  subtitleLargeImage: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** url_big_image field from Prismic. */
  urlLargeImage: ContentLink;
}

export interface ContentTopNewsSectionItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface ContentTopNewsSectionItem {
  headline: Scalars['String']['output'];
  image: ContentFullContentImageSet;
  subtitle: Scalars['String']['output'];
  url: ContentLink;
}

export interface ContentTopTeaserSlice {
  campaignDuration: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  countdownLabel: Maybe<Scalars['String']['output']>;
  ctaButtonHref: Maybe<ContentLink>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonType: Maybe<Scalars['String']['output']>;
  fullWidthImage: Scalars['Boolean']['output'];
  halfImage: Maybe<ContentFullContentImageSet>;
  image: Maybe<ContentFullContentImageSet>;
  informationBoxBackground: Maybe<Scalars['String']['output']>;
  informationBoxColorText: Maybe<Scalars['String']['output']>;
  /**
   * It's a raw JSON string representing a rich text field in Prismic.
   * It's meant to be parsed by a consuming application
   */
  legalNotesContent: Maybe<Scalars['String']['output']>;
  legalNotesLink: Maybe<Scalars['String']['output']>;
  legalNotesLinkColor: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  stoererBorderColor: Maybe<Scalars['String']['output']>;
  /**
   * It's a raw JSON string representing a rich text field in Prismic.
   * It's meant to be parsed by a consuming application
   */
  stoererLabel: Maybe<Scalars['String']['output']>;
  subTitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
}

export interface ContentTopTeaserV2Slice extends CampaignDocumentCommonFields, ContentPageSlice {
  backgroundColor: Maybe<Scalars['String']['output']>;
  campaignDuration: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaButtonLabel: Maybe<Scalars['String']['output']>;
  ctaButtonType: Maybe<Scalars['String']['output']>;
  ctaButtonUrl: Maybe<ContentLink>;
  desktopImage: Maybe<ContentFullContentImageSet>;
  desktopImageSlim: Maybe<ContentFullContentImageSet>;
  desktopVideo: Maybe<Scalars['String']['output']>;
  isFullWidth: Maybe<Scalars['Boolean']['output']>;
  isMultiVoucher: Maybe<Scalars['Boolean']['output']>;
  isViewportWide: Maybe<Scalars['Boolean']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  logoImage: Maybe<ContentExtendedContentImageSet>;
  mobileImage: Maybe<ContentFullContentImageSet>;
  mobileImageSlim: Maybe<ContentFullContentImageSet>;
  mobileVideo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  /** Common fields for all campaign teaser slices */
  textColor: Maybe<Scalars['String']['output']>;
  textContainerOpacity: Maybe<Scalars['String']['output']>;
  textContainerPosition: Maybe<TextContainerPosition>;
  title: Maybe<Scalars['String']['output']>;
  /** Specific fields for campaign teaser slices */
  type: Scalars['String']['output'];
  voucherCode: Maybe<Scalars['String']['output']>;
}

export interface ContentTwoThirdsPictureTextSlice extends ContentPageSlice {
  items: Array<Maybe<ContentPictureTextSliceItem>>;
  type: Scalars['String']['output'];
}

export interface ContentUspBar_V2 {
  entryPoints: Array<UspBarEntryPoint>;
  text: Scalars['String']['output'];
  textUrl: Maybe<ContentLink>;
  urgentMessage: UspBarUrgentMessage;
}

export interface ContentUspTeaser extends ContentPageSlice {
  backgroundColor: Maybe<Scalars['String']['output']>;
  ctaLinkLabel: Maybe<Scalars['String']['output']>;
  ctaLinkUrl: Maybe<ContentLink>;
  isContentWithReducedWidth: Scalars['Boolean']['output'];
  items: Array<Maybe<ContentUspTeaserItem>>;
  /** ***subtitle*** is a raw JSON strings representing a rich text field in Prismic. */
  subtitle: Maybe<Scalars['String']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentUspTeaserItem {
  /** @deprecated use image_v2 */
  image: Maybe<ContentExtendedContentImageSet>;
  image_v2: Maybe<ContentFullContentImageSet>;
  /** ***text*** is a raw JSON strings representing a rich text field in Prismic. */
  text: Maybe<Scalars['String']['output']>;
}

export interface ContentVerticalSpacingSlice extends ContentPageSlice {
  type: Scalars['String']['output'];
}

export interface ContentVisualNavigationSlice extends ContentPageSlice {
  contentId: Maybe<Scalars['String']['output']>;
  isGridLayout: Maybe<Scalars['Boolean']['output']>;
  items: Array<Maybe<ContentVisualNavigationSliceItem>>;
  name: Maybe<Scalars['String']['output']>;
  renderingType: VisualNavigationRenderingType;
  seeAllLabel: Maybe<Scalars['String']['output']>;
  seeAllLink: Maybe<ContentLink>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentVisualNavigationSliceItem {
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentExtendedContentImageSet>;
  link: Maybe<ContentLink>;
}

export interface ContentVoucherBannerSlice {
  campaignLink: Maybe<ContentLink>;
  color: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownColor: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  countdownLabel: Maybe<Scalars['String']['output']>;
  ctaColor: Maybe<Scalars['String']['output']>;
  ctaDisclaimerText: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  isContentCenterAligned: Maybe<Scalars['Boolean']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLabelColor: Maybe<Scalars['String']['output']>;
  legalDisclaimerLinkLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subTitle: Maybe<Scalars['String']['output']>;
  subTitleColor: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  voucherBannerEndBgColor: Maybe<Scalars['String']['output']>;
  voucherBannerStartBgColor: Maybe<Scalars['String']['output']>;
  voucherCode: Maybe<Scalars['String']['output']>;
  voucherCodeBgColor: Maybe<Scalars['String']['output']>;
  voucherCodeLabel: Maybe<Scalars['String']['output']>;
  voucherCodeTextColor: Maybe<Scalars['String']['output']>;
  voucherDiscount: Maybe<Scalars['Int']['output']>;
}

export interface ContentVoucherBannerSlice_V2 {
  campaignBackgroundColor: Scalars['String']['output'];
  campaignTextColor: Scalars['String']['output'];
  contentId: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  extraDisclaimerContent: Maybe<Scalars['String']['output']>;
  isHomeClubExclusive: Scalars['Boolean']['output'];
  isMultiVoucherCampaign: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /**
   * Cents value for VoucherAbsolute and VoucherRelative type.
   * Null for VoucherFreeShipping, because not shown to the end customer as no calculation for this type
   */
  priceAfterDiscount: Maybe<Scalars['Int']['output']>;
  shortName: Scalars['String']['output'];
  voucherCode: Scalars['String']['output'];
  voucherType: VoucherType;
}

/**  Since marketing is reusing every possible field. Clients need to handle empty fields  */
export interface ContentVoucherBannerSlice_V3 {
  campaignBackgroundColor: Maybe<Scalars['String']['output']>;
  campaignTextColor: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  extraDisclaimerContent: Maybe<Scalars['String']['output']>;
  isMultiVoucherCampaign: Scalars['Boolean']['output'];
  /**  Optional when voucher code is not valid  */
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /**
   * Optional when price is applied only on cart (e.g. Free shipping, cascading vouchers above single item price).
   * Optional when voucher code is not valid.
   */
  priceAfterDiscount: Maybe<Scalars['Int']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  /**  Optional when voucher code is not valid  */
  voucher: Maybe<Voucher>;
}

export interface ContentVoucherPromotionItem {
  ctaButtonLabel: Scalars['String']['output'];
  ctaButtonLink: ContentLink;
  ctaButtonType: Scalars['String']['output'];
  disclaimerLabel: Scalars['String']['output'];
  disclaimerLabelColor: Scalars['String']['output'];
  disclaimerText: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  image: ContentFullContentImageSet;
  subheading: Scalars['String']['output'];
  timerEndDate: Maybe<Scalars['String']['output']>;
  timerLabel: Maybe<Scalars['String']['output']>;
  voucherCode: Maybe<Scalars['String']['output']>;
  voucherCodeLabel: Maybe<Scalars['String']['output']>;
}

export interface ContentVoucherPromotions extends ContentPageSlice {
  contentId: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<ContentVoucherPromotionItem>>;
  name: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface ContentWebsiteDataSlice {
  alternateName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  searchQueryInput: Maybe<Scalars['String']['output']>;
  searchTarget: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
}

export interface Content_V2 {
  author: Maybe<Scalars['String']['output']>;
  body: Maybe<Array<Content_V2_Body>>;
  brand: Maybe<Content_V2_Brand>;
  breadcrumbs: Maybe<Array<Content_V2_Breadcrumbs>>;
  canonicalUid: Maybe<Scalars['String']['output']>;
  canonicalUrl: Maybe<Scalars['String']['output']>;
  contentMacroArea: Maybe<Content_V2_ContentMacroArea>;
  contentType: Maybe<Content_V2_ContentType>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  customer: Maybe<Array<Content_V2_Customer>>;
  filters: Maybe<Array<Content_V2_Filters>>;
  id: Scalars['String']['output'];
  link: Maybe<ContentLink>;
  metaDescription: Maybe<Scalars['String']['output']>;
  metaTitle: Maybe<Scalars['String']['output']>;
  navigationName: Maybe<Scalars['String']['output']>;
  opengraphImage: Maybe<ContentImage>;
  opengraphImageV2: Maybe<ContentFullContentImageSet>;
  pageTitle: Maybe<Scalars['String']['output']>;
  parent: Maybe<Content_V2>;
  prismicDocumentName: Maybe<Scalars['String']['output']>;
  prismicId: Maybe<Scalars['String']['output']>;
  prismicTags: Maybe<Array<Scalars['String']['output']>>;
  publishingDate: Maybe<Scalars['DateTime']['output']>;
  robots: Maybe<Content_V2_Robots>;
  season: Maybe<Array<Content_V2_Season>>;
  subtitle: Maybe<Scalars['String']['output']>;
  taxonomy: Maybe<Array<Content_V2_Taxonomy>>;
  uid: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userType: Maybe<Array<Content_V2_UserType>>;
}

export interface Content_V2ParentArgs {
  locale: InputMaybe<GQLLocale>;
}

export type Content_V2_Body =
  | ArticleHeaderBlock
  | ArticlesNavigationBlock
  | CheckGiftCardBalanceBlock
  | CtaButtonsBlock
  | DoublePictureTextBlock
  | DyGlobalRibbonBlock
  | DyListNavigationBlock
  | DyNewsletterBlock
  | DyOfferTeaserV2Block
  | DyTopBannerBlock
  | DyTopBannerV2Block
  | DyTopTeaserV2Block
  | DyVisualNavigationBlock
  | DyVoucherPromotionsBlock
  | ExternalScriptBlock
  | HalfPictureTextBlock
  | HomeclubBlock
  | ImageBlock
  | InspirationalTeaserBlock
  | NewsletterBlock
  | OfferTeaserBlock
  | OlapicBlock
  | OnetrustSettingsOverlayBlock
  | ProductListWithSkusBlock
  | RecommendationSliderBlock
  | ShopTheLookBlock
  | TextBlockBlock
  | TopTeaserBlock
  | TwoThirdsPictureTextBlock
  | VerticalSpacingBlock
  | VideoBlock;

export interface Content_V2_Brand {
  brandName: Maybe<Scalars['String']['output']>;
  brandUrl: Maybe<Scalars['String']['output']>;
  catalogId: Maybe<Scalars['String']['output']>;
}

export interface Content_V2_Breadcrumbs {
  doc: Maybe<Content_V2>;
  id: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
}

export interface Content_V2_BreadcrumbsDocArgs {
  locale: InputMaybe<GQLLocale>;
}

export interface Content_V2_Customer {
  id: Maybe<Scalars['String']['output']>;
  type: Maybe<Content_V2_Customer_Type>;
}

export enum Content_V2_Customer_Type {
  Families = 'Families',
  SingleFemale = 'SingleFemale',
  SingleMale = 'SingleMale',
  All = 'all',
}

export interface Content_V2_Filters {
  attribute: Maybe<Content_V2_Filters_Attribute>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
}

export interface Content_V2_Filters_Attribute {
  key: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
}

export interface Content_V2_Season {
  id: Maybe<Scalars['String']['output']>;
  type: Maybe<Content_V2_Season_Type>;
}

export enum Content_V2_Season_Type {
  Autumn = 'Autumn',
  BlackFriday = 'BlackFriday',
  HomieDays = 'HomieDays',
  Otherseasonalcampaign = 'Otherseasonalcampaign',
  SaleTember = 'Sale_tember',
  Spring = 'Spring',
  Summer = 'Summer',
  Winter = 'Winter',
  All = 'all',
}

export interface Content_V2_Taxonomy {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  level: Maybe<Content_V2_Taxonomy_Level>;
  title: Maybe<Scalars['String']['output']>;
}

export interface Content_V2_Taxonomy_Level {
  levelId: Maybe<Scalars['String']['output']>;
}

export interface Content_V2_UserType {
  id: Maybe<Scalars['String']['output']>;
  type: Maybe<Content_V2_UserType_Type>;
}

export enum Content_V2_UserType_Type {
  DiscountOriented = 'DiscountOriented',
  InspirationOriented = 'InspirationOriented',
  QualityOriented = 'QualityOriented',
  All = 'all',
}

export interface Content_V2_Brand__BrandName_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Brand__BrandUrl_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Brand__CatalogId_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Breadcrumbs__Doc_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_Breadcrumbs__Label_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Breadcrumbs__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export enum Content_V2_ContentMacroArea {
  Affiliate = 'Affiliate',
  Beratung = 'Beratung',
  ButlersCollection = 'ButlersCollection',
  Inspiration = 'Inspiration',
  Merchandising = 'Merchandising',
  Others = 'Others',
  Stores = 'Stores',
}

export enum Content_V2_ContentMacroArea_Input {
  Affiliate = 'Affiliate',
  Beratung = 'Beratung',
  ButlersCollection = 'ButlersCollection',
  Inspiration = 'Inspiration',
  Merchandising = 'Merchandising',
  Others = 'Others',
  Stores = 'Stores',
}

export enum Content_V2_ContentType {
  ButlersBlog = 'ButlersBlog',
  ButlersCategories = 'ButlersCategories',
  CampaignPage = 'CampaignPage',
  CataloguePage = 'CataloguePage',
  Geschenke = 'Geschenke',
  GiftguidePage = 'GiftguidePage',
  KundeberatungPages = 'KundeberatungPages',
  LexiconPage = 'LexiconPage',
  LifestylePages = 'LifestylePages',
  MixandMatchPage = 'MixandMatchPage',
  NeuheitenPage = 'NeuheitenPage',
  Others = 'Others',
  OutletPage = 'OutletPage',
  PremiumBrandPage = 'PremiumBrandPage',
  RatgeberPage = 'RatgeberPage',
  Seasonal = 'Seasonal',
  SeriesButlers = 'SeriesButlers',
  SeriesPage = 'SeriesPage',
  ShoptheLookPage = 'ShoptheLookPage',
  ShowroomPage = 'ShowroomPage',
  SignatureCampaignPage = 'SignatureCampaignPage',
  StyleFavorites = 'StyleFavorites',
  StylePage = 'StylePage',
  Thementische = 'Thementische',
  TippsundIdeenPage = 'TippsundIdeenPage',
  TrendLookPage = 'Trend_LookPage',
}

export enum Content_V2_ContentType_Input {
  ButlersBlog = 'ButlersBlog',
  ButlersCategories = 'ButlersCategories',
  CampaignPage = 'CampaignPage',
  CataloguePage = 'CataloguePage',
  Geschenke = 'Geschenke',
  GiftguidePage = 'GiftguidePage',
  KundeberatungPages = 'KundeberatungPages',
  LexiconPage = 'LexiconPage',
  LifestylePages = 'LifestylePages',
  MixandMatchPage = 'MixandMatchPage',
  NeuheitenPage = 'NeuheitenPage',
  Others = 'Others',
  OutletPage = 'OutletPage',
  PremiumBrandPage = 'PremiumBrandPage',
  RatgeberPage = 'RatgeberPage',
  Seasonal = 'Seasonal',
  SeriesButlers = 'SeriesButlers',
  SeriesPage = 'SeriesPage',
  ShoptheLookPage = 'ShoptheLookPage',
  ShowroomPage = 'ShowroomPage',
  SignatureCampaignPage = 'SignatureCampaignPage',
  StyleFavorites = 'StyleFavorites',
  StylePage = 'StylePage',
  Thementische = 'Thementische',
  TippsundIdeenPage = 'TippsundIdeenPage',
  TrendLookPage = 'Trend_LookPage',
}

export enum Content_V2_Customer__Type_Input {
  Families = 'Families',
  SingleFemale = 'SingleFemale',
  SingleMale = 'SingleMale',
  All = 'all',
}

export interface Content_V2_Filters__Attribute__Key_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Filters__Attribute__Value_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Filters__Description_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Filters__Id_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Filters__Title_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Link__DocumentType_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Link__FullUrl_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X1__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X1__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X1__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X1__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X1__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X2__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X2__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X2__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X2__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X2__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X3__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X3__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X3__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X3__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForDesktop__X3__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X1__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X1__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X1__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X1__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X1__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X2__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X2__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X2__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X2__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X2__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X3__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X3__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X3__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X3__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForLargeDesktop__X3__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X1__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X1__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X1__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X1__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X1__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X2__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X2__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X2__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X2__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X2__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X3__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X3__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X3__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X3__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForMobile__X3__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X1__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X1__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X1__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X1__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X1__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X2__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X2__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X2__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X2__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X2__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X3__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X3__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X3__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X3__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__ForTablet__X3__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__Original__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__Original__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__Original__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__Original__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__Original__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__Thumbnail__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__Thumbnail__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImageV2__Thumbnail__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__Thumbnail__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImageV2__Thumbnail__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImage__Alt_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImage__Height_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_OpengraphImage__Media_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_OpengraphImage__Url_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_OpengraphImage__Width_Operator {
  equals?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  greater_than?: InputMaybe<Scalars['Float']['input']>;
  greater_than_equal?: InputMaybe<Scalars['Float']['input']>;
  less_than?: InputMaybe<Scalars['Float']['input']>;
  less_than_equal?: InputMaybe<Scalars['Float']['input']>;
  not_equals?: InputMaybe<Scalars['Float']['input']>;
}

export interface Content_V2_Parent_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  not_equals?: InputMaybe<Scalars['JSON']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
}

export interface Content_V2_PrismicId_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export enum Content_V2_Robots {
  IndexFollow = 'index_follow',
  NoindexFollow = 'noindex_follow',
}

export enum Content_V2_Robots_Input {
  IndexFollow = 'index_follow',
  NoindexFollow = 'noindex_follow',
}

export enum Content_V2_Season__Type_Input {
  Autumn = 'Autumn',
  BlackFriday = 'BlackFriday',
  HomieDays = 'HomieDays',
  Otherseasonalcampaign = 'Otherseasonalcampaign',
  SaleTember = 'Sale_tember',
  Spring = 'Spring',
  Summer = 'Summer',
  Winter = 'Winter',
  All = 'all',
}

export interface Content_V2_Taxonomy__Description_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Taxonomy__Id_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Taxonomy__Level__LevelId_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Taxonomy__Title_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface Content_V2_Uid_Operator {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  like?: InputMaybe<Scalars['String']['input']>;
  not_equals?: InputMaybe<Scalars['String']['input']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export enum Content_V2_UserType__Type_Input {
  DiscountOriented = 'DiscountOriented',
  InspirationOriented = 'InspirationOriented',
  QualityOriented = 'QualityOriented',
  All = 'all',
}

export interface Content_V2_Where {
  prismicId?: InputMaybe<Content_V2_PrismicId_Operator>;
  uid?: InputMaybe<Content_V2_Uid_Operator>;
}

export interface Content_V2_Where_And {
  prismicId?: InputMaybe<Content_V2_PrismicId_Operator>;
  uid?: InputMaybe<Content_V2_Uid_Operator>;
}

export interface Content_V2_Where_Or {
  prismicId?: InputMaybe<Content_V2_PrismicId_Operator>;
  uid?: InputMaybe<Content_V2_Uid_Operator>;
}

export interface Contents_V2 {
  docs: Array<Content_V2>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextPage: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  pagingCounter: Scalars['Int']['output'];
  prevPage: Maybe<Scalars['Int']['output']>;
  totalDocs: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
}

/** Represents a store coupon and not online promotional coupons. */
export interface Coupon {
  code: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  image: Maybe<ContentFullContentImageSet>;
  legalInfo: Maybe<Scalars['String']['output']>;
  storeType: StoreType;
  title: Scalars['String']['output'];
  validFrom: Scalars['Time']['output'];
  validTo: Scalars['Time']['output'];
}

export enum CouponFilter {
  /**  Available while in early development phase, but potentially will be deprecated by more granular filtering  */
  All = 'ALL',
}

export interface CreateAddressInput {
  additional?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<UserGender>;
  isDefaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  street: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
}

export interface CreateExpressOrderPaymentData {
  paymentMethodType: CheckoutPaymentMethodType;
}

export interface CreateExpressOrderResponse {
  error: Maybe<Scalars['String']['output']>;
  paymentData: Maybe<CreateExpressOrderResponsePaymentData>;
}

export interface CreateExpressOrderResponsePaymentData {
  paymentMethodType: CheckoutPaymentMethodType;
}

export interface CreateExpressOrderResponsePaypalAdyenPaymentData extends CreateExpressOrderResponsePaymentData {
  action: Action;
  paymentMethodType: CheckoutPaymentMethodType;
}

export interface CreateExpressOrderResponsePaypalPaymentData extends CreateExpressOrderResponsePaymentData {
  orderID: Scalars['String']['output'];
  paymentMethodType: CheckoutPaymentMethodType;
}

export interface CreatePayPalOrderResponse {
  error: Maybe<Scalars['String']['output']>;
  orderID: Scalars['String']['output'];
}

export interface CtaButtonsBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<ContentCtaButtonsItem>>;
}

/** Represents a custom shortcut filter. */
export interface CustomFilter {
  filters: Array<Maybe<ProductListFilter>>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CustomerRequest {
  channel?: InputMaybe<ContactFormCommunicationChannel>;
  comment?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lineNumbers: Array<Scalars['String']['input']>;
  locale?: InputMaybe<GQLLocale>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reasonName: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  urls: Array<Scalars['String']['input']>;
}

export interface DangerousSubstances {
  containsADangerousSubstance: Maybe<Scalars['String']['output']>;
  containsASubstanceOfVeryHighConcern: Maybe<Scalars['String']['output']>;
  nameOfTheDangerousSubstance: Maybe<Scalars['String']['output']>;
  nameOfTheSubstanceOfVeryHighConcern: Maybe<Scalars['String']['output']>;
}

export interface DeliveryCharge {
  threshold: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
}

export enum DeliveryType {
  Other = 'Other',
  /**  STD: Parcel standard: PCL - M  */
  ParcelService = 'PARCEL_SERVICE',
}

export interface DeliveryTypeBasedPrice extends ShippingPrice {
  /**  Shipping price for additional product in cents  */
  additionalItemValue: Scalars['Int']['output'];
  /**  Combination of Mirakl logistic class and shipping type  */
  deliveryType: DeliveryType;
  /**  Shipping price in cents  */
  value: Scalars['Int']['output'];
  zone: ShippingZoneName;
}

export enum DeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  MobileAndroid = 'MOBILE_ANDROID',
  MobileIos = 'MOBILE_IOS',
  MobileNative = 'MOBILE_NATIVE',
  MobileNativeAndroid = 'MOBILE_NATIVE_ANDROID',
  MobileNativeIos = 'MOBILE_NATIVE_IOS',
  MobilePhone = 'MOBILE_PHONE',
  Tablet = 'TABLET',
  TabletAndroid = 'TABLET_ANDROID',
  TabletIos = 'TABLET_IOS',
  TabletNativeAndroid = 'TABLET_NATIVE_ANDROID',
  TabletNativeIos = 'TABLET_NATIVE_IOS',
  Unknown = 'UNKNOWN',
}

export interface DimensionValue {
  localized: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface Dimensions {
  primaryDimensions: Maybe<Section>;
  secondaryDimensions: Maybe<Section>;
  weightDimensions: Maybe<Section>;
}

export interface DisabledHoliday {
  date: Scalars['String']['output'];
}

export interface DisabledWeekday {
  weekday: Scalars['String']['output'];
}

export interface Domain {
  flagUrl: Scalars['String']['output'];
  locale: GQLLocale;
}

export interface DoublePictureTextBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<DoublePictureTextBlockItem>>;
}

export interface DoublePictureTextBlockItem {
  ctaBackgroundColor: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaLabelColor: Maybe<Scalars['String']['output']>;
  ctaUrl: Maybe<ContentLink>;
  description: Maybe<Scalars['JSON']['output']>;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
}

export interface DoublePictureTextBlockItemDescriptionArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export interface DyGlobalRibbonBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface DyListNavigationBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  selector: DyListNavigationBlock_Selector;
}

export enum DyListNavigationBlock_Selector {
  ContentListNav1 = 'ContentListNav1',
  ContentListNav2 = 'ContentListNav2',
  ContentListNav3 = 'ContentListNav3',
}

export interface DyNewsletterBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface DyOfferTeaserV2Block {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  componentType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  mainSubtitle: Maybe<Scalars['String']['output']>;
  mainTitle: Maybe<Scalars['String']['output']>;
  selector: DyOfferTeaserV2Block_Selector;
}

export enum DyOfferTeaserV2Block_Selector {
  OfferTeaser1 = 'OfferTeaser1',
  OfferTeaser2 = 'OfferTeaser2',
  OfferTeaser3 = 'OfferTeaser3',
}

export interface DyTopBannerBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface DyTopBannerV2Block {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface DyTopTeaserV2Block {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface DyVisualNavigationBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  selector: DyVisualNavigationBlock_Selector;
}

export enum DyVisualNavigationBlock_Selector {
  ContentVisNav1 = 'ContentVisNav1',
  ContentVisNav2 = 'ContentVisNav2',
  ContentVisNav3 = 'ContentVisNav3',
  ContentVisNav4 = 'ContentVisNav4',
  ContentVisNav5 = 'ContentVisNav5',
}

export interface DyVoucherPromotionsBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  selector: DyVoucherPromotionsBlock_Selector;
}

export enum DyVoucherPromotionsBlock_Selector {
  ContentVoucherPromo1 = 'ContentVoucherPromo1',
  ContentVoucherPromo2 = 'ContentVoucherPromo2',
  ContentVoucherPromo3 = 'ContentVoucherPromo3',
  ContentVoucherPromo4 = 'ContentVoucherPromo4',
  ContentVoucherPromo5 = 'ContentVoucherPromo5',
}

export enum DynamicYieldChannel {
  App = 'APP',
  FromHeader = 'FROM_HEADER',
  Web = 'WEB',
}

export interface DynamicYieldDecision {
  id: Scalars['String']['output'];
  /** Decision name corresponds to a selector from the request */
  name: Scalars['String']['output'];
  /** @deprecated use `variations_v2` */
  variations: Array<DynamicYieldHome24Variation>;
  variations_v2: Maybe<Array<DynamicYieldVariation>>;
}

export interface DynamicYieldHome24Variation {
  campaign: Maybe<ContentCampaign>;
  dataItemId: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
}

export interface DynamicYieldPageAttribute {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export enum DynamicYieldPageContexType {
  Cart = 'CART',
  Category = 'CATEGORY',
  Homepage = 'HOMEPAGE',
  Other = 'OTHER',
  Post = 'POST',
  Product = 'PRODUCT',
  /**
   * WISHLIST maps to PRODUCT in DY, with the difference that it also
   * passes the customer's most expensive article in the wishlist
   * This also overrides the isImplicitPageView argument to false
   */
  Wishlist = 'WISHLIST',
}

export interface DynamicYieldRecommendation {
  article: Maybe<Article>;
  slotId: Scalars['String']['output'];
}

export interface DynamicYieldRecommendations {
  dataItemId: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slots: Array<DynamicYieldRecommendation>;
  title: Maybe<Scalars['String']['output']>;
}

export type DynamicYieldVariation = DynamicYieldHome24Variation | DynamicYieldRecommendations;

export interface EcoResponsibilityContent {
  delivery: Maybe<ArticleDelivery_V2>;
  materialType: MaterialType;
}

export interface ElectricalItemContent {
  bestOffer: ArticleOffer;
  hasElectricItem: Scalars['Boolean']['output'];
}

export interface EmailValidationDetails {
  /** The domain of the provided email address. (bob@example.com -> example.com) */
  domain: Scalars['String']['output'];
  /** `true` if the email address uses a disposable domain like trashmail.com or mailinator.com */
  isDisposableDomain: Scalars['Boolean']['output'];
  /** `true` if the email was accepted, but the domain appears to accept all emails addressed to that domain */
  isDomainAcceptingAllEmails: Scalars['Boolean']['output'];
  /** `true` if the email address uses a free email service like gmail.com or yahoo.com */
  isFreeEmailService: Scalars['Boolean']['output'];
  /** `true` if the email address is a role address (postmaster@example.com, support@example.com, etc) */
  isRoleEmail: Scalars['Boolean']['output'];
  /** Returns a normalized version of the provided email address. (BoB@example.com -> bob@example.com) */
  normalizedEmail: Scalars['String']['output'];
  /** A quality score of the provided email address ranging between 0 (no quality) and 1 (perfect quality) */
  qualityScore: Scalars['Float']['output'];
  /** The reason for the result */
  reason: EmailValidationDetailsReason;
  /** `true` if the Kickbox API request was successful (i.e., no authentication or unexpected errors occurred) */
  requestSuccessful: Scalars['Boolean']['output'];
  /** The verification result: deliverable, undeliverable, risky, unknown */
  result: EmailValidationDetailsResult;
  /** Returns a suggested email if a possible spelling error was detected. (john.doe@gamil.com -> john.doe@gmail.com) */
  suggestedEmail: Maybe<Scalars['String']['output']>;
  /** The user (a.k.a local part) of the provided email address. (bob@example.com -> bob) */
  user: Scalars['String']['output'];
}

export enum EmailValidationDetailsReason {
  /** Email address was accepted by the SMTP server */
  AcceptedEmail = 'accepted_email',
  /** Domain for email does not exist */
  InvalidDomain = 'invalid_domain',
  /** Specified email is not a valid email address syntax */
  InvalidEmail = 'invalid_email',
  /** SMTP server returned an unexpected/invalid response */
  InvalidSmtp = 'invalid_smtp',
  /** Email address appears to be deliverable, but deliverability cannot be guaranteed */
  LowDeliverability = 'low_deliverability',
  /** Email address has quality issues that may make it a risky or low-value address */
  LowQuality = 'low_quality',
  /** Could not connect to SMTP server */
  NoConnect = 'no_connect',
  /** Email address was rejected by the SMTP server, email address does not exist */
  RejectedEmail = 'rejected_email',
  /** SMTP session timed out */
  Timeout = 'timeout',
  /** SMTP server was unavailable to process our request */
  UnavailableSmtp = 'unavailable_smtp',
  /** An unexpected error has occurred */
  UnexpectedError = 'unexpected_error',
}

export enum EmailValidationDetailsResult {
  Deliverable = 'deliverable',
  Risky = 'risky',
  Undeliverable = 'undeliverable',
  Unknown = 'unknown',
}

export interface EmailValidationResult {
  /** Full response from the Kickbox email validation service */
  details: Maybe<EmailValidationDetails>;
  /**
   * valid is `true`:
   * - if the request to the Kickbox service was successful and result was `deliverable`, `risky`, or `unknown`,
   * - if the request to the Kickbox service was unsuccessful and the email address matches an email regex pattern.
   */
  valid: Scalars['Boolean']['output'];
}

export enum EnergyClassScaleType {
  New = 'NEW',
  Old = 'OLD',
}

export interface ExpressPaymentOption {
  allowed: Scalars['Boolean']['output'];
  config: Maybe<ExpressPaymentOptionConfig>;
  express: Scalars['Boolean']['output'];
  method: CheckoutPaymentMethodType;
  priority: Scalars['Int']['output'];
}

export type ExpressPaymentOptionConfig = PaymentOptionPayPalAdyenConfig | PaymentOptionPayPalConfig;

export interface ExternalScriptBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  selector: ExternalScriptBlock_Selector;
}

export enum ExternalScriptBlock_Selector {
  AppSalesSection = 'AppSalesSection',
  Butlers = 'Butlers',
  CheckGiftCardBalance = 'CheckGiftCardBalance',
  HomeClub = 'HomeClub',
  Olapic = 'Olapic',
  OneTrustSettingsOverlay = 'OneTrustSettingsOverlay',
  ReferAFriend = 'ReferAFriend',
}

export interface FaqBlockItem {
  answer: Maybe<Scalars['String']['output']>;
  question: Maybe<Scalars['String']['output']>;
}

export interface FaqBlockSlice extends SeoPageSlice {
  faqItems: Array<FaqBlockItem>;
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface FreeShipping extends ShippingPrice {
  /**  Zero for free shipping before Marketplace  */
  value: Scalars['Int']['output'];
}

export interface FunctionAndQualityContent {
  bulletpoints: Array<ArticleBulletpoint>;
  certificate: Maybe<ArticleCertificate>;
  usp: Maybe<ArticleUsp>;
}

export interface FunctionAndQualityContent_V3 {
  bulletpoints: Array<ArticleBulletpoint>;
  usp: Maybe<ArticleUsp>;
}

export interface GiftCard {
  balance: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  maskedCode: Scalars['String']['output'];
  /** amount in cents, which would be deducted after successful order with current cart */
  redeemedBalance: Scalars['Int']['output'];
  /** amount in cents, that would remain after successful order with the current cart */
  remainingBalance: Scalars['Int']['output'];
  validUntil: Scalars['String']['output'];
}

export interface GiftCardStatus {
  active: Scalars['Boolean']['output'];
  /**  Returns the available balance of the gift card INCLUDING the reservedBalance.  */
  balance: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /**  Returns the internally used ID of the gift card. ID is NOT the gift card code  */
  id: Scalars['String']['output'];
  /**  Returns the balance of the gift card at the time it was initially created or has been used for the first time in our system  */
  initialAmount: Scalars['Int']['output'];
  maskedCode: Scalars['String']['output'];
  /**  Returns amount of balance which is currently reserved. Reservation means its blocked, but not yet redeemed. Reservation might be deleted after a while if not captured  */
  reservedBalance: Scalars['Int']['output'];
  validUntil: Maybe<Scalars['String']['output']>;
}

export interface GiftCardValidationRules {
  code: Array<ValidationRule_V2>;
  pin: Array<ValidationRule_V2>;
}

export interface HalfPictureTextBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<HalfPictureTextBlockItem>>;
}

export interface HalfPictureTextBlockItem {
  ctaBackgroundColor: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaLabelColor: Maybe<Scalars['String']['output']>;
  ctaUrl: Maybe<ContentLink>;
  description: Maybe<Scalars['JSON']['output']>;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  revert: Maybe<Scalars['Boolean']['output']>;
}

export interface HalfPictureTextBlockItemDescriptionArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export interface HomeClub {
  code: Maybe<Scalars['String']['output']>;
  status: HomeClubStatus;
}

export enum HomeClubOptInDevice {
  Desktop = 'Desktop',
  NativeAndroid = 'NativeAndroid',
  NativeIos = 'NativeIOS',
  WebAndroid = 'WebAndroid',
  WebIos = 'WebIOS',
}

export enum HomeClubStatus {
  /** because gradual rollout, different country or campaign over */
  Disabled = 'Disabled',
  /** happy path, code ready to be used */
  Generated = 'Generated',
  /** requires agreeing for terms and conditions */
  NeedOptIn = 'NeedOptIn',
  /** errors on backend, should be retried later */
  TemporaryUnavailable = 'TemporaryUnavailable',
}

export interface HomeclubBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

/** Hreflang link for SEO */
export interface Hreflang {
  lang: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface ImageBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  isContentCenterAligned: Maybe<Scalars['Boolean']['output']>;
  isContentWithReducedWidth: Maybe<Scalars['Boolean']['output']>;
}

export interface ImageInfo {
  mimetype: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
}

export interface ImageMarker {
  article: Maybe<Article>;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
}

export interface InspirationalTeaserBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isTitleCenterAligned: Maybe<Scalars['Boolean']['output']>;
  titleText: Maybe<Scalars['JSON']['output']>;
}

export interface InspirationalTeaserBlockTitleTextArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

/**
 * **Locale** type defines all possible locales that are used.
 * Having `de_FFH` value, which is not a standard locale, we have
 * eliminated necessity of the `appDomainId` as input parameters in queries.
 */
export enum GQLLocale {
  /** German language in `home24.at` website. */
  DeAt = 'de_AT',
  /** German language in `home24.ch` website. */
  DeCh = 'de_CH',
  /** German language in `home24.de` website. */
  DeDe = 'de_DE',
  /**
   * German language in `fashionforhome.de` website.
   * @deprecated fashionforhome shutdown
   */
  DeFfh = 'de_FFH',
  /** French language in `home24.be` website. */
  FrBe = 'fr_BE',
  /** French language in `home24.ch` website. */
  FrCh = 'fr_CH',
  /** French language in `home24.fr` website. */
  FrFr = 'fr_FR',
  /** Italian language in `home24.it` website. */
  ItIt = 'it_IT',
  /** Dutch language in `home24.be` website. */
  NlBe = 'nl_BE',
  /** Dutch language in `home24.nl` website. */
  NlNl = 'nl_NL',
}

export interface Location {
  address: Scalars['String']['output'];
  address_addition: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  distance: Scalars['Int']['output'];
  lat: Scalars['String']['output'];
  lon: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: BranchType;
  zip_code: Scalars['String']['output'];
}

export interface LocationResponse {
  last_page: Scalars['Int']['output'];
  list: Maybe<Array<Location>>;
}

export enum LoginFlow {
  Mobile = 'mobile',
  RememberMe = 'rememberMe',
  WebsiteSession = 'websiteSession',
}

export interface LoginResponse {
  tokens: Maybe<Tokens>;
  user: Maybe<User>;
}

export interface LoginWithThirdPartyProviderError {
  existentAssociations: Array<AuthenticationProvider>;
}

export enum LogoImageFormat {
  Avif = 'AVIF',
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP',
}

export enum MaterialType {
  FabricSamples = 'FABRIC_SAMPLES',
  GiftCard = 'GIFT_CARD',
  NonStock = 'NON_STOCK',
  Service = 'SERVICE',
  SparePart = 'SPARE_PART',
  TradingGood = 'TRADING_GOOD',
  Unknown = 'UNKNOWN',
}

/** ***Media*** represents an uploaded or externally-linked media asset. */
export interface Media {
  alt: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
}

export interface Mutation {
  /** @deprecated Use activateStoreCoupon instead. https://home24.atlassian.net/browse/PDE-3704 */
  activateCoupon: Maybe<Scalars['Void']['output']>;
  activateStoreCoupon: Maybe<Scalars['Void']['output']>;
  /** @deprecated Use addArticlesToWishlist */
  addArticleToWishlist: Maybe<Wishlist>;
  addArticlesToWishlist: Maybe<Wishlist>;
  addCheckoutAddress: CheckoutResponse;
  addCheckoutBillingAddress: CheckoutResponse;
  addCheckoutPaymentMethod: CheckoutResponse;
  /** @deprecated Use `isAddedToClaim` in `updateReclamation`. */
  addOrDeleteItemInReclamationRequest: Maybe<Scalars['String']['output']>;
  /** @deprecated use addToCart_v2 */
  addToCart: Maybe<CartResponse>;
  /** @deprecated use addToCartBatch_v2 */
  addToCartBatch: Maybe<CartResponse>;
  addToCartBatch_v2: Maybe<CartResponse>;
  addToCart_v2: Maybe<CartResponse>;
  /** @deprecated use addToCart_v2 */
  addToDigitalCart: Maybe<CartResponse>;
  applyVoucher_V2: Maybe<ApplyVoucherResponse>;
  associateWithThirdPartyProvider: Maybe<Scalars['String']['output']>;
  cancelCheckout: CheckoutResponse;
  closeMiraklIncident: Maybe<Scalars['Void']['output']>;
  closeThread: Maybe<Scalars['Void']['output']>;
  completeCheckoutOrderMethod: TakeOrderResponse;
  confirmSubscription_v2: Maybe<Scalars['Void']['output']>;
  /** convert guest to regular customer */
  convertGuest: Maybe<LoginResponse>;
  /** convert guest to regular customer using a third party provider */
  convertGuestWithThirdPartyProvider: Maybe<LoginResponse>;
  /** Creates a new Address associated with the user account */
  createAddress: Address;
  createCustomerRequest: Maybe<Scalars['String']['output']>;
  createExpressOrder: CreateExpressOrderResponse;
  /** @deprecated use createExpressOrder instead, https://home24.atlassian.net/browse/CHO-2107 */
  createPayPalOrder: CreatePayPalOrderResponse;
  createReclamationRequest: Maybe<Reclamation>;
  createReview: Maybe<Scalars['Void']['output']>;
  /** Deletes user's address */
  deleteAddress: Maybe<Scalars['Void']['output']>;
  deleteCheckoutAddress: CheckoutResponse;
  deleteCheckoutPaymentMethod: CheckoutResponse;
  deleteReclamationAttachment: Maybe<Scalars['String']['output']>;
  /** @deprecated use deleteVoucher_v2 */
  deleteVoucher: Maybe<CartResponse>;
  deleteVoucher_v2: Maybe<CartResponse>;
  getReviewLink: ReviewLinkResponse;
  /**
   * link account to another existing customer account using email and password
   * Applies rate limiting and challenge checks.
   * Returns
   *   BAD_CREDENTIALS error code if credentials not found,
   *   RATE_LIMIT_EXCEEDED if rate limit exceeded,
   *   CHALLENGE_VALIDATION_FAILED if challenge validation failed.
   */
  linkAccountWithEmailAndPassword: Maybe<LoginResponse>;
  /** link account to another existing customer account using third party authentication */
  linkAccountWithThirdPartyProvider: Maybe<ThirdPartyProviderLoginResponse>;
  /** Login anonymously. If `accessToken` defined, it's subject will be reused in the new generated token. Returns null if operation failed. */
  loginAnonymously: Maybe<LoginResponse>;
  /**
   * Login as guest using an order number and a one-time password.
   *
   * Applies rate limiting.
   *
   * Returns null if credentials not found.
   */
  loginGuestWithOrderNumberAndOTP: Maybe<LoginResponse>;
  /** Login as guest. Returns null if credentials not found. */
  loginGuest_v2: Maybe<LoginResponse>;
  /**
   * Login with email and password. Returns null if credentials not found.
   * Returns BAD_CREDENTIALS on challenge validation failure.
   * Use v2 for more informative error messages.
   * @deprecated use loginWithEmailAndPassword_v2
   */
  loginWithEmailAndPassword: Maybe<LoginResponse>;
  /**
   * Login with email and password.
   * Applies rate limiting and challenge checks.
   * Returns BAD_CREDENTIALS error code if credentials not found,
   *   RATE_LIMIT_EXCEEDED if rate limit exceeded,
   *   CHALLENGE_VALIDATION_FAILED if challenge validation failed.
   */
  loginWithEmailAndPassword_v2: Maybe<LoginResponse>;
  loginWithThirdPartyProvider: Maybe<ThirdPartyProviderLoginResponse>;
  /** @deprecated use logout_v3 to not get into mutation race conditions */
  logout_v2: Maybe<Scalars['Void']['output']>;
  /** Logout current user and login anonymously. Returns null if operation failed. */
  logout_v3: Maybe<LoginResponse>;
  /**
   * create homeClub membership, assuming agreed to the terms and conditions
   *
   * Possible errors:
   * BUTLERS_DISABLED – should not be called, as homeClub.status = Disabled
   * Internal Server Error – other unexpected errors, ask user to retry full flow
   */
  optInToHomeClub: Scalars['String']['output'];
  /** delete homeClub membership */
  optOutOfHomeClub: Maybe<Scalars['Void']['output']>;
  /** @deprecated use redeemGiftCard_v2 */
  redeemGiftCard: Maybe<CartResponse>;
  redeemGiftCard_v2: Maybe<CartResponse>;
  reevaluateCartDiscounts: Maybe<CartResponse>;
  /** Get new authorization tokens. Returns null if refresh token is invalid. No flow means reuse old one */
  refreshToken: Maybe<LoginResponse>;
  /** Registers a guest customer and start checkout */
  registerGuestCustomer: RegisterResponse_V2;
  registerWithThirdPartyProvider: Maybe<ThirdPartyProviderLoginResponse>;
  register_v3: RegisterResponse_V2;
  removeArticleFromSavedForLater: Maybe<NamedArticlesList>;
  removeArticleFromWishlist: Maybe<Wishlist>;
  /** @deprecated use removeFromCart_v2 */
  removeFromCart: Maybe<CartResponse>;
  removeFromCart_v2: Maybe<CartResponse>;
  /** @deprecated use removeFromCart_v2 */
  removeFromDigitalCart: Maybe<CartResponse>;
  /** @deprecated use removeGiftCard_v2 */
  removeGiftCard: Maybe<CartResponse>;
  removeGiftCard_v2: Maybe<CartResponse>;
  removeThirdPartyProviderAssociation: Maybe<Scalars['String']['output']>;
  replyToThread: Maybe<Scalars['Void']['output']>;
  requestAttachmentUpload: Array<AttachmentUploadEntry>;
  /**
   * request a one-time password (OTP) using an orderId from a tradebyte marketplace, a zip code and an email address
   *
   * Applies rate limiting.
   *
   * returns a h24 orderId which will be needed for login with OTP
   */
  requestOTPWithTBMarketplaceOrderIdAndZipAndEmail: Maybe<Scalars['String']['output']>;
  /** Request password reset. Returns error if user not found. */
  requestPasswordReset_v2: Maybe<Scalars['Void']['output']>;
  saveArticleForLater: Maybe<NamedArticlesList>;
  selectCheckoutShippingAddress: CheckoutResponse;
  /** Sets user's address as default shipping or/and billing address */
  setAddressAsDefault: Address;
  /** Sets new password => password. Returns null if hash not valid. */
  setNewPassword_v2: SetNewPasswordResponse;
  /** @deprecated use startExpressCheckout_v2 instead, https://home24.atlassian.net/browse/CHO-2124 */
  startExpressCheckout: StartExpressCheckoutResponse;
  startExpressCheckout_v2: StartExpressCheckoutResponse;
  submitReclamationRequest: Maybe<Scalars['String']['output']>;
  subscribeAnonymously: SubscriberMutationResult_V2;
  triggerDOI: Maybe<TriggerDoiResult>;
  unsubscribe_v3: UnsubscribeMutationResult;
  /** @deprecated use updateAccountInformation_v2 */
  updateAccountInformation: User;
  updateAccountInformation_v2: User;
  /** Updates existing user's address */
  updateAddress: Address;
  /** date format YYYY-MM-DD (e.g. 2006-01-02) */
  updateBirthdate: User;
  updateBusinessCustomer: User;
  /** @deprecated use updateCartItem_v2 */
  updateCartItem: Maybe<CartResponse>;
  updateCartItem_v2: Maybe<CartResponse>;
  updateCheckoutAddress: CheckoutResponse;
  updateCheckoutPaymentMethod: CheckoutResponse;
  updateEmail: User;
  updateExpressOrder: UpdateExpressOrderResponse;
  updatePassword_v2: SetNewPasswordResponse;
  updatePayPalAdyenDetails: UpdatePayPalAdyenDetailsResponse;
  /** @deprecated use updatePayPalAdyenDetails instead, https://home24.atlassian.net/browse/CHO-2170 */
  updatePayPalAdyenPaymentData: UpdatePayPalAdyenPaymentDataResponse;
  /** @deprecated use updateExpressOrder instead, https://home24.atlassian.net/browse/CHO-2111 */
  updatePayPalOrder: UpdatePayPalOrderResponse;
  updatePaymentMethodDetails: PaymentMethodUpdateResponse;
  updateReclamation: Maybe<Reclamation>;
  /** @deprecated Nobody started using this and now it's not needed. */
  updateReclamationItem: Maybe<ReclamationItem>;
  updateReclamationQuantities: Maybe<Scalars['Void']['output']>;
  updateSubscriptions_v3: SubscriberMutationResult_V3;
  uploadReclamationAttachments: Array<Scalars['String']['output']>;
  uploadUrl: UploadResponse;
  verifySellerRatingToken: Maybe<SellerRatingOrderInfo>;
}

export interface MutationActivateCouponArgs {
  couponCode: Scalars['String']['input'];
}

export interface MutationActivateStoreCouponArgs {
  storeCouponCode: Scalars['String']['input'];
}

export interface MutationAddArticleToWishlistArgs {
  sku: Scalars['String']['input'];
}

export interface MutationAddArticlesToWishlistArgs {
  challenge: InputMaybe<Challenge>;
  sku: Array<Scalars['String']['input']>;
}

export interface MutationAddCheckoutAddressArgs {
  address: CheckoutAddressInput;
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
  overrideBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutationAddCheckoutBillingAddressArgs {
  address: CheckoutAddressInput;
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
}

export interface MutationAddCheckoutPaymentMethodArgs {
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
  paymentMethod: CheckoutPaymentInput;
}

export interface MutationAddOrDeleteItemInReclamationRequestArgs {
  items: Array<InputMaybe<ReclamationItemState>>;
  reclamationId: Scalars['String']['input'];
}

export interface MutationAddToCartArgs {
  assemblyServiceAdded?: InputMaybe<Scalars['Boolean']['input']>;
  challenge: InputMaybe<Challenge>;
  electronicsDisposalAdded?: InputMaybe<Scalars['Boolean']['input']>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAddToCartBatchArgs {
  challenge: InputMaybe<Challenge>;
  items: Array<AddToCartItem>;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAddToCartBatch_V2Args {
  cartType?: CartType;
  challenge: InputMaybe<Challenge>;
  items: Array<AddToCartItem_V2>;
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAddToCart_V2Args {
  cartType?: CartType;
  challenge: InputMaybe<Challenge>;
  item: AddToCartItem_V2;
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAddToDigitalCartArgs {
  challenge: InputMaybe<Challenge>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
}

export interface MutationApplyVoucher_V2Args {
  code: Scalars['String']['input'];
  locale: InputMaybe<GQLLocale>;
  source?: VoucherApplicationSource;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationAssociateWithThirdPartyProviderArgs {
  provider: ThirdPartyProvider;
  provider_token: Scalars['String']['input'];
}

export interface MutationCancelCheckoutArgs {
  checkoutID: Scalars['String']['input'];
  device: CheckoutDevice;
  locale: GQLLocale;
}

export interface MutationCloseMiraklIncidentArgs {
  omsLineId: Scalars['String']['input'];
  omsOrderId: Scalars['String']['input'];
}

export interface MutationCloseThreadArgs {
  orderId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
}

export interface MutationCompleteCheckoutOrderMethodArgs {
  analytics: InputMaybe<AnalyticsContext>;
  cancelLink: Scalars['String']['input'];
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  failureLink: Scalars['String']['input'];
  locale: GQLLocale;
  paymentData: InputMaybe<CheckoutPaymentData>;
  successLink: Scalars['String']['input'];
  tracking: InputMaybe<CheckoutTracking>;
}

export interface MutationConfirmSubscription_V2Args {
  hash: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}

export interface MutationConvertGuestArgs {
  flow?: InputMaybe<LoginFlow>;
  newPassword: Scalars['String']['input'];
}

export interface MutationConvertGuestWithThirdPartyProviderArgs {
  flow?: InputMaybe<LoginFlow>;
  provider: ThirdPartyProvider;
  provider_token: Scalars['String']['input'];
}

export interface MutationCreateAddressArgs {
  address: CreateAddressInput;
}

export interface MutationCreateCustomerRequestArgs {
  request: CustomerRequest;
}

export interface MutationCreateExpressOrderArgs {
  locale: GQLLocale;
  paymentData: CreateExpressOrderPaymentData;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationCreatePayPalOrderArgs {
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationCreateReclamationRequestArgs {
  aggregated?: Scalars['Boolean']['input'];
  locale: InputMaybe<GQLLocale>;
  orderId: Scalars['String']['input'];
  type: InputMaybe<ReclamationType>;
}

export interface MutationCreateReviewArgs {
  request: ReviewInput;
}

export interface MutationDeleteAddressArgs {
  id: Scalars['String']['input'];
}

export interface MutationDeleteCheckoutAddressArgs {
  addressUID: Scalars['String']['input'];
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
}

export interface MutationDeleteCheckoutPaymentMethodArgs {
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
  paymentMethodId: Scalars['String']['input'];
}

export interface MutationDeleteReclamationAttachmentArgs {
  filepath: Scalars['String']['input'];
  itemId: InputMaybe<Scalars['String']['input']>;
  lineNo: InputMaybe<Scalars['String']['input']>;
  reclamationId: Scalars['String']['input'];
}

export interface MutationDeleteVoucherArgs {
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationDeleteVoucher_V2Args {
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationGetReviewLinkArgs {
  orderID: Scalars['String']['input'];
}

export interface MutationLinkAccountWithEmailAndPasswordArgs {
  challenge: InputMaybe<Challenge>;
  email: Scalars['String']['input'];
  flow: LoginFlow;
  locale: GQLLocale;
  password: Scalars['String']['input'];
}

export interface MutationLinkAccountWithThirdPartyProviderArgs {
  flow: LoginFlow;
  locale: GQLLocale;
  provider: ThirdPartyProvider;
  provider_token: Scalars['String']['input'];
}

export interface MutationLoginAnonymouslyArgs {
  accessToken: InputMaybe<Scalars['String']['input']>;
  locale: GQLLocale;
}

export interface MutationLoginGuestWithOrderNumberAndOtpArgs {
  flow?: InputMaybe<LoginFlow>;
  orderNumber: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}

export interface MutationLoginGuest_V2Args {
  customerID: Scalars['String']['input'];
  flow?: InputMaybe<LoginFlow>;
  guestKey: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  zip: Scalars['String']['input'];
}

export interface MutationLoginWithEmailAndPasswordArgs {
  challenge: InputMaybe<Challenge>;
  email: Scalars['String']['input'];
  flow?: InputMaybe<LoginFlow>;
  locale: GQLLocale;
  password: Scalars['String']['input'];
}

export interface MutationLoginWithEmailAndPassword_V2Args {
  challenge: InputMaybe<Challenge>;
  email: Scalars['String']['input'];
  flow?: InputMaybe<LoginFlow>;
  locale: GQLLocale;
  password: Scalars['String']['input'];
}

export interface MutationLoginWithThirdPartyProviderArgs {
  flow: LoginFlow;
  locale: GQLLocale;
  provider: ThirdPartyProvider;
  provider_token: Scalars['String']['input'];
}

export interface MutationLogout_V2Args {
  flow?: InputMaybe<LoginFlow>;
}

export interface MutationLogout_V3Args {
  flow?: InputMaybe<LoginFlow>;
  locale: GQLLocale;
}

export interface MutationOptInToHomeClubArgs {
  affiliateId: InputMaybe<Scalars['String']['input']>;
  device: InputMaybe<HomeClubOptInDevice>;
  locale: InputMaybe<GQLLocale>;
  subscribeButlersNewsletter: InputMaybe<Scalars['Boolean']['input']>;
}

export interface MutationRedeemGiftCardArgs {
  challenge: InputMaybe<Challenge>;
  giftCard: RedeemGiftCard;
  userIp: InputMaybe<Scalars['String']['input']>;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRedeemGiftCard_V2Args {
  challenge: InputMaybe<Challenge>;
  giftCard: RedeemGiftCard;
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationReevaluateCartDiscountsArgs {
  cartType?: CartType;
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRefreshTokenArgs {
  flow: InputMaybe<LoginFlow>;
  keepOldTokens: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
}

export interface MutationRegisterGuestCustomerArgs {
  challenge: InputMaybe<Challenge>;
  request: RegisterGuestRequest;
}

export interface MutationRegisterWithThirdPartyProviderArgs {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  gender?: UserGender;
  lastname: Scalars['String']['input'];
  locale: GQLLocale;
  loginFlow: LoginFlow;
  newsletterSubscription: InputMaybe<Scalars['Boolean']['input']>;
  provider: ThirdPartyProvider;
  provider_token: Scalars['String']['input'];
  referredBy: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRegister_V3Args {
  challenge: InputMaybe<Challenge>;
  request: RegisterRequest_V2;
}

export interface MutationRemoveArticleFromSavedForLaterArgs {
  sku: Scalars['String']['input'];
}

export interface MutationRemoveArticleFromWishlistArgs {
  sku: Scalars['String']['input'];
}

export interface MutationRemoveFromCartArgs {
  sku: Scalars['String']['input'];
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRemoveFromCart_V2Args {
  cartType?: CartType;
  locale: GQLLocale;
  sku: Scalars['String']['input'];
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRemoveFromDigitalCartArgs {
  sku: Scalars['String']['input'];
}

export interface MutationRemoveGiftCardArgs {
  id: Scalars['String']['input'];
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRemoveGiftCard_V2Args {
  id: Scalars['String']['input'];
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationRemoveThirdPartyProviderAssociationArgs {
  provider: ThirdPartyProvider;
}

export interface MutationReplyToThreadArgs {
  attachments: InputMaybe<Array<Scalars['String']['input']>>;
  message: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
}

export interface MutationRequestAttachmentUploadArgs {
  entries: Array<AttachmentUploadRequestEntry>;
}

export interface MutationRequestOtpWithTbMarketplaceOrderIdAndZipAndEmailArgs {
  email: Scalars['String']['input'];
  locale: GQLLocale;
  orderId: Scalars['String']['input'];
  zip: Scalars['String']['input'];
}

export interface MutationRequestPasswordReset_V2Args {
  email: Scalars['String']['input'];
  locale: GQLLocale;
}

export interface MutationSaveArticleForLaterArgs {
  sku: Scalars['String']['input'];
}

export interface MutationSelectCheckoutShippingAddressArgs {
  addressUID: Scalars['String']['input'];
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
}

export interface MutationSetAddressAsDefaultArgs {
  billingAddress: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  shippingAddress: Scalars['Boolean']['input'];
}

export interface MutationSetNewPassword_V2Args {
  flow?: InputMaybe<LoginFlow>;
  hash: Scalars['String']['input'];
  locale: GQLLocale;
  password: Scalars['String']['input'];
}

export interface MutationStartExpressCheckoutArgs {
  device: CheckoutDevice;
  locale: GQLLocale;
  loginFlow: InputMaybe<LoginFlow>;
  orderID: Scalars['String']['input'];
  payerID: Scalars['String']['input'];
}

export interface MutationStartExpressCheckout_V2Args {
  device: CheckoutDevice;
  express: StartExpressCheckoutInput;
  locale: GQLLocale;
  loginFlow: InputMaybe<LoginFlow>;
}

export interface MutationSubmitReclamationRequestArgs {
  reclamationId: Scalars['String']['input'];
}

export interface MutationSubscribeAnonymouslyArgs {
  email: Scalars['String']['input'];
  locale: GQLLocale;
  subscriptionType: InputMaybe<SubscriptionTypeAnon>;
}

export interface MutationTriggerDoiArgs {
  locale: GQLLocale;
}

export interface MutationUnsubscribe_V3Args {
  hash: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}

export interface MutationUpdateAccountInformationArgs {
  info: AccountInformation;
  locale: GQLLocale;
}

export interface MutationUpdateAccountInformation_V2Args {
  info: AccountInformation_V2;
  locale: GQLLocale;
}

export interface MutationUpdateAddressArgs {
  address: UpdateAddressInput;
}

export interface MutationUpdateBirthdateArgs {
  birthdate: Scalars['String']['input'];
}

export interface MutationUpdateBusinessCustomerArgs {
  companyName: InputMaybe<Scalars['String']['input']>;
  taxNumber: InputMaybe<Scalars['String']['input']>;
  vatNumber: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpdateCartItemArgs {
  assemblyServiceAdded: Scalars['Boolean']['input'];
  electronicsDisposalAdded?: InputMaybe<Scalars['Boolean']['input']>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpdateCartItem_V2Args {
  cartType?: CartType;
  item: UpdateCartItem;
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpdateCheckoutAddressArgs {
  address: CheckoutAddressInput;
  addressUID: Scalars['String']['input'];
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
}

export interface MutationUpdateCheckoutPaymentMethodArgs {
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
  paymentId: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: CheckoutPaymentMethodType;
}

export interface MutationUpdateEmailArgs {
  email: Scalars['String']['input'];
  locale: GQLLocale;
}

export interface MutationUpdateExpressOrderArgs {
  locale: GQLLocale;
  paymentData: UpdateExpressOrderPaymentData;
  zipCode: Scalars['String']['input'];
}

export interface MutationUpdatePassword_V2Args {
  currentPassword: Scalars['String']['input'];
  flow?: InputMaybe<LoginFlow>;
  locale: GQLLocale;
  newPassword: Scalars['String']['input'];
}

export interface MutationUpdatePayPalAdyenDetailsArgs {
  details: PayPalPaymentDetails;
}

export interface MutationUpdatePayPalAdyenPaymentDataArgs {
  details: PayPalPaymentDetails;
  paymentData: Scalars['String']['input'];
}

export interface MutationUpdatePayPalOrderArgs {
  locale: GQLLocale;
  orderID: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}

export interface MutationUpdatePaymentMethodDetailsArgs {
  paymentId: Scalars['String']['input'];
  update: CheckoutPaymentMethodUpdate;
}

export interface MutationUpdateReclamationArgs {
  aggregated?: Scalars['Boolean']['input'];
  reclamationId: Scalars['String']['input'];
  updateBatches: InputMaybe<Array<ReclamationUpdateBatch>>;
}

export interface MutationUpdateReclamationItemArgs {
  aggregated?: Scalars['Boolean']['input'];
  comment: InputMaybe<Scalars['String']['input']>;
  lineNo: Scalars['String']['input'];
  partNumbers: InputMaybe<Array<Scalars['String']['input']>>;
  reclamationId: Scalars['String']['input'];
  vendorOrderId: InputMaybe<Scalars['String']['input']>;
}

export interface MutationUpdateReclamationQuantitiesArgs {
  items: Array<InputMaybe<ReclamationItemQuantity>>;
  reclamationId: Scalars['String']['input'];
}

export interface MutationUpdateSubscriptions_V3Args {
  enableMultiChannel?: Scalars['Boolean']['input'];
  locale: GQLLocale;
  subscriptions: Array<SubscriptionRequest_V2>;
}

export interface MutationUploadReclamationAttachmentsArgs {
  files: Array<UploadFile>;
}

export interface MutationUploadUrlArgs {
  imagesInfo: Array<ImageInfo>;
}

export interface MutationVerifySellerRatingTokenArgs {
  locale: GQLLocale;
  orderNumber: Scalars['ID']['input'];
  token: Scalars['String']['input'];
}

export interface NamedArticlesList {
  articles: Array<Article>;
  name: Scalars['String']['output'];
}

export interface NamedArticlesListArticlesArgs {
  locale: GQLLocale;
}

export interface NewsletterBlock {
  asteriskText: Maybe<Scalars['JSON']['output']>;
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  buttonKind: Maybe<NewsletterBlock_ButtonKind>;
  endColor: Maybe<Scalars['String']['output']>;
  headingText: Maybe<Scalars['String']['output']>;
  icon: Maybe<ContentExtendedContentImageSet>;
  id: Maybe<Scalars['String']['output']>;
  newsletterType: NewsletterBlock_NewsletterType;
  startColor: Maybe<Scalars['String']['output']>;
  subline: Maybe<Scalars['JSON']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
}

export interface NewsletterBlockAsteriskTextArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export interface NewsletterBlockSublineArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export enum NewsletterBlock_ButtonKind {
  Black = 'black',
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum NewsletterBlock_NewsletterType {
  B2bNewsletter = 'b2bNewsletter',
  ButlersNewsletter = 'butlersNewsletter',
  Newsletter = 'newsletter',
}

export enum NotificationFrequency {
  Monthly = 'monthly',
  Weekly = 'weekly',
}

export interface OfferTeaserBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isTitleCenterAligned: Maybe<Scalars['Boolean']['output']>;
  titleText: Maybe<Scalars['JSON']['output']>;
}

export interface OfferTeaserBlockTitleTextArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export interface OlapicBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export enum OmsType {
  Mirakl = 'MIRAKL',
  Sap = 'SAP',
  Tradebyte = 'TRADEBYTE',
}

export interface OnetrustSettingsOverlayBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface OnlineCoupon {
  code: Scalars['String']['output'];
  conditions: OnlineCouponConditions;
  /** Indicates the percentage discount for the coupon. */
  discountPercentage: Scalars['Int']['output'];
  /** Indicates if the coupon is already activated by the user. */
  isActivated: Scalars['Boolean']['output'];
}

export interface OnlineCouponConditions {
  onlyHomeClub: Scalars['Boolean']['output'];
}

export interface OpeningHours {
  closingTime: Maybe<Scalars['String']['output']>;
  openingDayFrom: Maybe<Scalars['String']['output']>;
  openingDayTo: Maybe<Scalars['String']['output']>;
  openingTime: Maybe<Scalars['String']['output']>;
}

export interface Order {
  billingAddress: Address;
  checkoutId: Maybe<Scalars['String']['output']>;
  /**  to be used in OrderDetails and OrderOverview pages. Can't be requested together with items_v2  */
  consolidatedItems: Maybe<Array<ConsolidatedItem>>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  customerAccountType: AccountType;
  customerNumber: Scalars['String']['output'];
  deliveryTypes: Array<ArticleDeliveryType>;
  discountTotal: Scalars['Int']['output'];
  ecoMobilierTotal: Maybe<Scalars['Int']['output']>;
  grandTotal: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  invoiceHasBeenRequested: Scalars['Boolean']['output'];
  isReviewed: Scalars['Boolean']['output'];
  items_v2: Maybe<Array<OrderItemV2>>;
  netTotal: Maybe<Scalars['Int']['output']>;
  oms: Maybe<OrderOms>;
  payback: Maybe<OrderPaybackData>;
  payment: OrderPayment;
  shippingAddress: Address;
  shippingTotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  threads: Maybe<Array<Thread>>;
  totalItems: Scalars['Int']['output'];
  type: OrderType;
  voucherCode: Maybe<Scalars['String']['output']>;
}

export interface OrderDocument {
  contentType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: OrderDocumentType;
  url: Maybe<Scalars['String']['output']>;
}

export enum OrderDocumentType {
  CreditMemo = 'CREDIT_MEMO',
  DebitMemo = 'DEBIT_MEMO',
  DunningFirst = 'DUNNING_FIRST',
  DunningSecond = 'DUNNING_SECOND',
  DunningThird = 'DUNNING_THIRD',
  ExchangeLabel = 'EXCHANGE_LABEL',
  ExchangeNote = 'EXCHANGE_NOTE',
  Invoice = 'INVOICE',
  ReturnLabel = 'RETURN_LABEL',
  ReturnNote = 'RETURN_NOTE',
  Unknown = 'UNKNOWN',
}

export interface OrderItem {
  additionalService: Maybe<Array<AdditionalService>>;
  allowedReclamationType: Maybe<ReclamationType>;
  article: Maybe<Article>;
  assemblyService: Maybe<OrderItemAssembly>;
  brand: Maybe<Scalars['String']['output']>;
  cancellationStatus: Maybe<OrderStatus>;
  couponCode: Maybe<Scalars['String']['output']>;
  couponDiscountAmount: Maybe<Scalars['Int']['output']>;
  delivery: OrderItemDelivery;
  description: Maybe<Scalars['String']['output']>;
  electronicsDisposal: Scalars['Boolean']['output'];
  image: Maybe<Scalars['String']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  itemOrders_v2: Array<OrderItemOrderV2>;
  lastItemOrder_v2: OrderItemOrderV2;
  lastStatus: Maybe<OrderStatus>;
  lineNo: Scalars['String']['output'];
  oms: Maybe<OrderItemOms>;
  price: Maybe<OrderItemPrice>;
  reclamationRequestsItems: Maybe<Array<ReclamationItem>>;
  shortDescription: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface OrderItemArticleArgs {
  locale: GQLLocale;
}

export interface OrderItemImageUrlArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface OrderItemAssembly {
  article: Article;
  price: OrderItemPrice;
  sku: Scalars['String']['output'];
}

export interface OrderItemAssemblyArticleArgs {
  locale: GQLLocale;
}

export interface OrderItemDelivery {
  deliveryToCurb: Scalars['Boolean']['output'];
  group: Maybe<Scalars['Int']['output']>;
  possibleDeliveryDateMax: Scalars['String']['output'];
  possibleDeliveryDateMin: Scalars['String']['output'];
  shippingMethod: ShippingMethod;
  time: ArticleDeliveryTime;
  type_v2: ArticleDeliveryType;
}

export interface OrderItemIncidentInfo {
  reason: Maybe<Scalars['String']['output']>;
  reasonCode: Maybe<Scalars['String']['output']>;
}

export interface OrderItemOms {
  mirakl: Maybe<OrderItemOmsMirakl>;
}

export interface OrderItemOmsMirakl {
  incident: Maybe<OrderItemIncidentInfo>;
  lineId: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  status: Scalars['String']['output'];
}

export interface OrderItemOrder {
  carrierDate: Maybe<Scalars['String']['output']>;
  deliveryDate: Maybe<Scalars['String']['output']>;
  documents: Maybe<Array<OrderDocument>>;
  id: Scalars['String']['output'];
  lastStatus: Maybe<Scalars['String']['output']>;
  parcels: Maybe<Array<OrderItemParcel>>;
  process: Maybe<OrderItemProcess>;
  statusHistory: Maybe<Array<OrderItemStatus>>;
  trackingLink: Maybe<Scalars['String']['output']>;
  type: OrderType;
}

export interface OrderItemOrderV2 {
  cancellationStatus: Maybe<OrderStatus>;
  carrierDate: Maybe<Scalars['String']['output']>;
  carrierType: Maybe<CarrierType>;
  deliveryDate: Maybe<Scalars['String']['output']>;
  documents: Maybe<Array<OrderDocument>>;
  id: Scalars['String']['output'];
  lastStatus: Maybe<OrderStatus>;
  parcels: Maybe<Array<OrderItemParcel>>;
  process: Maybe<OrderItemProcess>;
  steps: Maybe<Array<OrderItemStep>>;
  /** @deprecated field is used in itemsV2 which will be replaced by consolidatedItems in MyAccount. After switching use 'link' field from parcels: https://home24.atlassian.net/browse/RUN-6026 */
  trackingLink: Maybe<Scalars['String']['output']>;
  type: OrderType;
}

export interface OrderItemParcel {
  tracking: Maybe<OrderItemParcelTracking>;
}

export interface OrderItemParcelTracking {
  agent: Scalars['String']['output'];
  code: Scalars['String']['output'];
  link: Maybe<Scalars['String']['output']>;
}

export interface OrderItemPrice {
  currency: Scalars['String']['output'];
  ecoMobilierTotal: Maybe<Scalars['Int']['output']>;
  shippingFee: Maybe<Scalars['Int']['output']>;
  value: Scalars['Int']['output'];
}

export enum OrderItemProcess {
  Lost = 'LOST',
  LostReplaced = 'LOST_REPLACED',
  NormalReplaced = 'NORMAL_REPLACED',
  Rejected = 'REJECTED',
  Remain = 'REMAIN',
  RemainReplaced = 'REMAIN_REPLACED',
}

export interface OrderItemStatus {
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
}

export interface OrderItemStep {
  isCompleted: Scalars['Boolean']['output'];
  status: OrderStatus;
}

export interface OrderItemV2 {
  additionalServices: Maybe<Array<AdditionalService>>;
  allowedReclamationType: Maybe<ReclamationType>;
  article: Maybe<Article>;
  assemblyService: Maybe<OrderItemAssembly>;
  cancellationStatus: Maybe<OrderStatus>;
  delivery: OrderItemDelivery;
  electronicsDisposal: Scalars['Boolean']['output'];
  itemOrders: Array<OrderItemOrderV2>;
  lastItemOrder: OrderItemOrderV2;
  lastStatus: Maybe<OrderStatus>;
  lineNo: Scalars['String']['output'];
  oms: Maybe<OrderItemOms>;
  price: Maybe<OrderItemPrice>;
  reclamationRequestsItems: Maybe<Array<ReclamationItem>>;
}

export interface OrderItemV2ArticleArgs {
  locale: GQLLocale;
}

export interface OrderOms {
  isRated: Scalars['Boolean']['output'];
  mirakl: Maybe<OrderOmsMirakl>;
  orderId: Maybe<Scalars['String']['output']>;
  shop: Maybe<Shop>;
  tradebyte: Maybe<OrderOmsTradebyte>;
  type_v2: OmsType;
}

export interface OrderOmsMirakl {
  status: Scalars['String']['output'];
}

export interface OrderOmsTradebyte {
  orderId: Scalars['String']['output'];
}

export interface OrderPaybackData {
  approvalStatus: Maybe<PaybackApprovalStatus>;
  basicPoints: Maybe<Scalars['Int']['output']>;
  cardNumber: Scalars['String']['output'];
  extraPoints: Maybe<Scalars['Int']['output']>;
}

export interface OrderPayment {
  giftCards: Maybe<OrderPaymentGiftCardData>;
  instructions_v2: Maybe<OrderPaymentInstruction_V2>;
  method: CheckoutPaymentMethodType;
  total: Scalars['Int']['output'];
}

export interface OrderPaymentGiftCard {
  amount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  maskedCode: Scalars['String']['output'];
}

export interface OrderPaymentGiftCardData {
  cards: Maybe<Array<OrderPaymentGiftCard>>;
  total: Scalars['Int']['output'];
}

export interface OrderPaymentInstructionCard extends OrderPaymentInstruction_V2 {
  cardNumber: Maybe<Scalars['String']['output']>;
  expiryMonth: Maybe<Scalars['String']['output']>;
  expiryYear: Maybe<Scalars['String']['output']>;
  maskedCardNumber: Maybe<Scalars['String']['output']>;
  methodType: CheckoutPaymentMethodType;
  owner: Maybe<Scalars['String']['output']>;
  pseudoCardPan: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
}

export interface OrderPaymentInstructionIdeal extends OrderPaymentInstruction_V2 {
  bankGroupType: Maybe<Scalars['String']['output']>;
  methodType: CheckoutPaymentMethodType;
  onlineBankTransferType: Maybe<Scalars['String']['output']>;
}

export interface OrderPaymentInstructionInstallment extends OrderPaymentInstruction_V2 {
  customerIban: Maybe<Scalars['String']['output']>;
  customerInterestRate: Maybe<Scalars['String']['output']>;
  effectiveInterestRate: Maybe<Scalars['Float']['output']>;
  installmentAmount: Maybe<Scalars['Int']['output']>;
  lastInstallmentAmount: Maybe<Scalars['Int']['output']>;
  methodType: CheckoutPaymentMethodType;
  numberOfInstallments: Maybe<Scalars['Int']['output']>;
  profileNo: Maybe<Scalars['Int']['output']>;
  termsLink: Maybe<Scalars['String']['output']>;
  totalAmount: Maybe<Scalars['Int']['output']>;
  totalAmountWithInterest: Maybe<Scalars['Int']['output']>;
}

export interface OrderPaymentInstructionInvoice extends OrderPaymentInstruction_V2 {
  bankAccountHolder: Maybe<Scalars['String']['output']>;
  bankAccountNumber: Maybe<Scalars['String']['output']>;
  bankBic: Maybe<Scalars['String']['output']>;
  bankCity: Maybe<Scalars['String']['output']>;
  bankCode: Maybe<Scalars['String']['output']>;
  bankCountry: Maybe<Scalars['String']['output']>;
  bankIban: Maybe<Scalars['String']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  customerNumber: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['String']['output']>;
  methodType: CheckoutPaymentMethodType;
  referenceNumber: Maybe<Scalars['String']['output']>;
}

export interface OrderPaymentInstruction_V2 {
  methodType: CheckoutPaymentMethodType;
}

export enum OrderStatus {
  CancellationRejected = 'CANCELLATION_REJECTED',
  CancellationRequested = 'CANCELLATION_REQUESTED',
  Cancelled = 'CANCELLED',
  CancelledBySeller = 'CANCELLED_BY_SELLER',
  Delivered = 'DELIVERED',
  ExchangeProcessingFurnitureShipping = 'EXCHANGE_PROCESSING_FURNITURE_SHIPPING',
  ExchangeProcessingParcel = 'EXCHANGE_PROCESSING_PARCEL',
  ExchangeShipped = 'EXCHANGE_SHIPPED',
  Ordered = 'ORDERED',
  Other = 'OTHER',
  Picked = 'PICKED',
  Processing = 'PROCESSING',
  ReturnDelivered = 'RETURN_DELIVERED',
  ReturnDeliveryLost = 'RETURN_DELIVERY_LOST',
  ReturnDeliveryLostReplaced = 'RETURN_DELIVERY_LOST_REPLACED',
  ReturnDeliveryRejected = 'RETURN_DELIVERY_REJECTED',
  ReturnDeliveryRemain = 'RETURN_DELIVERY_REMAIN',
  ReturnDeliveryRemainReplaced = 'RETURN_DELIVERY_REMAIN_REPLACED',
  ReturnProcessingFurnitureShipping = 'RETURN_PROCESSING_FURNITURE_SHIPPING',
  ReturnProcessingParcel = 'RETURN_PROCESSING_PARCEL',
  ReturnRequested = 'RETURN_REQUESTED',
  ReturnShipped = 'RETURN_SHIPPED',
  Shipped = 'SHIPPED',
}

export enum OrderType {
  Exchange = 'EXCHANGE',
  Order = 'ORDER',
  Return = 'RETURN',
  Sparepart = 'SPAREPART',
  Spareparts = 'SPAREPARTS',
  Temporary = 'TEMPORARY',
  Undefined = 'UNDEFINED',
}

export interface OrdersActivity {
  firstOrderDate: Scalars['String']['output'];
  lastOrderDate: Scalars['String']['output'];
  penultimateOrderDate: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
}

export interface PayPalPaymentDetails {
  billingToken?: InputMaybe<Scalars['String']['input']>;
  facilitatorAccessToken: Scalars['String']['input'];
  orderID: Scalars['String']['input'];
  payerID: Scalars['String']['input'];
  paymentID: Scalars['String']['input'];
  paymentSource: Scalars['String']['input'];
}

export enum PaybackApprovalStatus {
  Approved = 'APPROVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export interface PaybackData {
  basicPoints: Scalars['Int']['output'];
}

export interface Payment {
  applePaySession: PaymentDataApplePaySession;
  paymentData: Maybe<StoredPaymentData>;
  paymentMethodId: Maybe<Scalars['String']['output']>;
  paymentMethodType: CheckoutPaymentMethodType;
}

export interface PaymentApplePaySessionArgs {
  validationURL: Scalars['String']['input'];
}

export interface PaymentDataApplePaySession {
  token: Scalars['String']['output'];
}

export interface PaymentDataCard {
  cardType: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  expiryMonth: Scalars['String']['output'];
  expiryYear: Scalars['String']['output'];
  id: Scalars['String']['output'];
  maskedCardNumber: Scalars['String']['output'];
}

export interface PaymentDataIdealBank {
  bankGroupType: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface PaymentDataInstallmentRate {
  basketAmount: Scalars['Int']['output'];
  customerIBAN: Scalars['String']['output'];
  effectiveInterestRate: Scalars['Float']['output'];
  installmentAmount: Scalars['Int']['output'];
  installmentProfileNumber: Scalars['Int']['output'];
  interestRate: Scalars['Float']['output'];
  lastInstallmentAmount: Scalars['Int']['output'];
  numberOfInstallments: Scalars['Int']['output'];
  readMore: Scalars['String']['output'];
  totalAmount: Scalars['Int']['output'];
}

export interface PaymentDataTemporaryCard {
  cardType: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maskedCardNumber: Scalars['String']['output'];
  saveMode: CheckoutPaymentCardSaveMode;
}

export interface PaymentMethodUpdateResponse {
  paymentMethodID: Scalars['String']['output'];
}

export interface PaymentOption {
  links: PaymentOptionLinks;
}

export interface PaymentOptionApplePay extends PaymentOption {
  config: Scalars['String']['output'];
  links: PaymentOptionLinks;
}

export interface PaymentOptionCardAdyenConfig {
  brands: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clientKey: Maybe<Scalars['String']['output']>;
  environment: Maybe<Scalars['String']['output']>;
}

export interface PaymentOptionCardAdyenPayment extends PaymentOption {
  config: Maybe<PaymentOptionCardAdyenConfig>;
  links: PaymentOptionLinks;
  storedCards: Maybe<Array<Maybe<PaymentDataCard>>>;
  temporaryCard: Maybe<PaymentDataTemporaryCard>;
}

export interface PaymentOptionCardPayment extends PaymentOption {
  links: PaymentOptionLinks;
  settings: Maybe<Scalars['String']['output']>;
  storedCards: Maybe<Array<Maybe<PaymentDataCard>>>;
}

export interface PaymentOptionDefault extends PaymentOption {
  links: PaymentOptionLinks;
}

export interface PaymentOptionIdeal extends PaymentOption {
  allowedBanks: Maybe<Array<Maybe<PaymentDataIdealBank>>>;
  links: PaymentOptionLinks;
}

export interface PaymentOptionInstallmentAfterpay extends PaymentOption {
  allowedRates: Maybe<Array<Maybe<PaymentDataInstallmentRate>>>;
  links: PaymentOptionLinks;
}

export interface PaymentOptionLinks {
  initialize: Scalars['String']['output'];
  validate: Scalars['String']['output'];
}

export interface PaymentOptionPayPalAdyenConfig {
  clientKey: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  merchantId: Maybe<Scalars['String']['output']>;
  paymentMethods: Maybe<Scalars['Map']['output']>;
}

export interface PaymentOptionPayPalConfig {
  clientID: Scalars['String']['output'];
}

/** Logic connecting category id with the list of SKUs */
export enum PlpBackend {
  Home24 = 'Home24',
  /** Still work in progress! Test only via Feature toggles!!! */
  ThirdParty = 'ThirdParty',
}

export interface PreShipping {
  amountDue: Scalars['Int']['output'];
  savingsTotal: Scalars['Int']['output'];
}

export interface PremiumBrandContent {
  brandUrl: Maybe<Scalars['String']['output']>;
  mainImage: Maybe<ContentShopTheLookSlice>;
  textBlock: Maybe<ContentTextBlock>;
  twoThirdPictureText: Maybe<ContentTwoThirdsPictureTextSlice>;
}

export interface ProductDescriptionContent {
  description: Array<Scalars['String']['output']>;
}

export interface ProductDetailContent {
  brand: Maybe<ArticleBrand>;
  details: Array<ArticleDetail>;
  sketch: Maybe<Array<Maybe<ArticleGalleryImage>>>;
}

export interface ProductDimensionContent {
  dimension: Dimensions;
  sketch: Maybe<Array<Maybe<ArticleGalleryImage>>>;
}

export interface ProductFaqContent {
  faq: Maybe<ArticleFaq>;
}

export interface ProductList {
  active: Scalars['Boolean']['output'];
  appDomainId: Scalars['Int']['output'];
  articleCount: Scalars['Int']['output'];
  /** Paginated collection of articles belonging to the product list */
  articlesList: ProductListArticles;
  breadcrumbs: Array<Maybe<ProductListBreadcrumb>>;
  browseRequest: Maybe<Scalars['String']['output']>;
  browsedBy: Maybe<Scalars['String']['output']>;
  catalogQuery: Scalars['String']['output'];
  /** By default only **active children product lists that have articles** are returned. See the parameters list to tweak the query. */
  childrenProductLists: ProductListCollection;
  defaultFilter: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  isAlias: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  navigation: Maybe<ProductList>;
  nonAliasParentId: Scalars['String']['output'];
  parentProductList: Maybe<ProductList>;
  redirectToProductList: Maybe<ProductList>;
  redirectUrl: Maybe<Scalars['String']['output']>;
  /**
   * Related category pages only available on the ThirdParty (Constructor) backend path.
   * Returns null when no related categories exist (e.g. native backend).
   */
  relatedCategories: Maybe<Array<ProductList>>;
  relatedPages: Array<ProductList>;
  resultId: Scalars['String']['output'];
  /** @deprecated Use seo_v2 */
  seo: Seo;
  seoBlock_v2: Array<Maybe<SeoPageSlice>>;
  seoCms: Maybe<Scalars['String']['output']>;
  seo_v2: Maybe<Seo>;
  shortName: Maybe<Scalars['String']['output']>;
  /**
   * Indicates whether the "from price" label should be shown for articles in this product list.
   * Based on a curated list of L2 category IDs.
   */
  showFromPrice: Scalars['Boolean']['output'];
  topBannersV2: Array<ContentTopBannerV2Slice>;
  urlPath: Scalars['String']['output'];
  visualNavigationEnabled: Scalars['Boolean']['output'];
}

export interface ProductListArticlesListArgs {
  first: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  optionsSorting?: InputMaybe<ProductListFilterOptionsSorting>;
}

export interface ProductListChildrenProductListsArgs {
  selectedSort?: ChildProductListSortOption;
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<ProductListNavigation>;
  showOnDevice: InputMaybe<Array<ProductListDevice>>;
}

export interface ProductListImageArgs {
  format?: InputMaybe<ProductListImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface ProductListArticles {
  /** Collection of articles. */
  articles: Array<Maybe<Article>>;
  /**
   * Constructor.io feature flags enabled for this browse/PLP request.
   * Only includes features where features[name] = true.
   */
  cioFeatureFlags: Maybe<Array<ConstructorFeatureFlag>>;
  /** Number of articles in the current slice. */
  count: Scalars['Int']['output'];
  customFilters: Maybe<Array<Maybe<CustomFilter>>>;
  /** Collection of possible filters that can be used as selection criteria. */
  filters: Array<Maybe<ProductListFilter>>;
  /** indicates whether the response from cio contains non-token-matched results */
  hasEmbeddedResults: Scalars['Boolean']['output'];
  /** depending on search provider, can be empty string */
  resultId: Scalars['String']['output'];
  /** search request JSON serialized into string */
  searchRequest: Maybe<Scalars['String']['output']>;
  selectedFiltersCount: Scalars['Int']['output'];
  /** Selected sort option */
  selectedSort: ProductListArticlesSortOption;
  /** Total number of articles meeting provided criteria. */
  totalCount: Scalars['Int']['output'];
}

export enum ProductListArticlesSortOption {
  AverageRating = 'AVERAGE_RATING',
  DiscountDesc = 'DISCOUNT_DESC',
  FirstSellableAtDesc = 'FIRST_SELLABLE_AT_DESC',
  Popularity = 'POPULARITY',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
}

export interface ProductListArticlesSortOptionLocalized {
  localized: Scalars['String']['output'];
  option: ProductListArticlesSortOption;
}

export interface ProductListArticlesSortOptionLocalized_V2 {
  localized: Scalars['String']['output'];
  option: Scalars['String']['output'];
}

export interface ProductListBreadcrumb {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface ProductListCategoryTreeFilter {
  /** Tree of of filter options that can be selected for the current set of articles. (max depth of 3) */
  children: Array<Maybe<ProductListTreeFilterItem>>;
  /** Filter `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** It is a localized filter name displayed on a page. */
  name: Scalars['String']['output'];
}

export interface ProductListCollection {
  count: Scalars['Int']['output'];
  list: Array<Maybe<ProductList>>;
}

export enum ProductListDevice {
  /** Web browser on desktop device */
  Desktop = 'DESKTOP',
  /** Web browser on mobile device */
  Mobile = 'MOBILE',
  /** Mobile native application */
  MobileApp = 'MOBILE_APP',
}

export type ProductListFilter =
  | ProductListCategoryTreeFilter
  | ProductListOptionFilter
  | ProductListRangeFilter;

export enum ProductListFilterOptionsSorting {
  Alphabetical = 'ALPHABETICAL',
  ByArticleCountDesc = 'BY_ARTICLE_COUNT_DESC',
}

export enum ProductListImageFormat {
  Avif = 'AVIF',
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP',
}

export enum ProductListNavigation {
  AliasNavigation = 'ALIAS_NAVIGATION',
  MainNavigation = 'MAIN_NAVIGATION',
  MobileAppNavigation = 'MOBILE_APP_NAVIGATION',
  SideNavigation = 'SIDE_NAVIGATION',
  VisualNavigation = 'VISUAL_NAVIGATION',
}

/**
 * **ProductListOptionFilter** represents a filter object that is used for selecting articles
 * having an article quality defined as one or multiple possible options.
 */
export interface ProductListOptionFilter {
  /** Locale-agnostic key of the group which the filter belongs to */
  groupKey: Maybe<Scalars['String']['output']>;
  /** Group which the filter belongs to */
  groupName: Maybe<Scalars['String']['output']>;
  /** Filter `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Multiple options can be selected if `multiselect` is true. */
  multiselect: Maybe<Scalars['Boolean']['output']>;
  /** It is a localized filter name displayed on a page. */
  name: Scalars['String']['output'];
  /** Collection of filter options that can be selected for the current set of articles. */
  options: Array<Maybe<ProductListOptionFilterItem>>;
  /** Defines whether option icons should be displayed or not */
  showIcon: Maybe<Scalars['Boolean']['output']>;
}

/** **ProductListOptionFilterItem** represents a single option filter item that could be selected. */
export interface ProductListOptionFilterItem {
  /** It's a path to optional image that could be displayed together or instead of the text value. */
  imagePath: Maybe<Scalars['String']['output']>;
  /** Option `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Number of articles with particular option value. */
  numberOfArticles: Scalars['Int']['output'];
  /** `True` means that the options has been used in selection criteria of the current collection of articles. */
  selected: Scalars['Boolean']['output'];
  /** It is a localized value displayed on a page. */
  value: Scalars['String']['output'];
}

/**
 * **ProductListRangeFilter** represents a filter object that is used for selecting articles
 * having a numerical value of an article quality withing [min, max] range.
 */
export interface ProductListRangeFilter {
  /** Maximum value that can be selected for the current collection of articles. */
  currentMax: Scalars['Int']['output'];
  /** Minimum value that can be selected for the current collection of articles. */
  currentMin: Scalars['Int']['output'];
  /** Locale-agnostic key of the group which the filter belongs to */
  groupKey: Maybe<Scalars['String']['output']>;
  /** Group which the filter belongs to */
  groupName: Maybe<Scalars['String']['output']>;
  /** Filter `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Maximum value that can be selected for the current collection of articles. */
  max: Scalars['Int']['output'];
  /** Minimum value that can be selected for the current collection of articles. */
  min: Scalars['Int']['output'];
  /** It is a localized filter name displayed on a page. */
  name: Scalars['String']['output'];
  /** Optional maximum value selected by the user */
  selectedMax: Maybe<Scalars['Int']['output']>;
  /** Optional minimum value selected by the user */
  selectedMin: Maybe<Scalars['Int']['output']>;
  /** Unit of measure. */
  unit: Maybe<Scalars['String']['output']>;
}

export interface ProductListTreeFilterItem {
  /** Recursion to select inner filter value */
  children: Array<Maybe<ProductListTreeFilterItem>>;
  /** Option `key` is used to build queries to backend services. */
  key: Scalars['String']['output'];
  /** Number of articles with particular option value. */
  numberOfArticles: Scalars['Int']['output'];
  /** `True` means that the options has been used in selection criteria of the current collection of articles. */
  selected: Scalars['Boolean']['output'];
  /** It is a localized value displayed on a page. */
  value: Scalars['String']['output'];
}

export interface ProductListViewTeaser {
  backgroundColor: Maybe<Scalars['String']['output']>;
  contentId: Maybe<Scalars['String']['output']>;
  countdownEndDate: Maybe<Scalars['String']['output']>;
  countdownLabel: Maybe<Scalars['String']['output']>;
  ctaButtonAriaLabel: Maybe<Scalars['String']['output']>;
  ctaLink: Maybe<ContentLink>;
  ctaText: Maybe<Scalars['String']['output']>;
  headline: Maybe<Scalars['String']['output']>;
  legalDisclaimerContent: Maybe<Scalars['String']['output']>;
  legalDisclaimerLabel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  picture: Maybe<ContentFullContentImageSet>;
  subline: Maybe<Scalars['String']['output']>;
  textColor: Maybe<Scalars['String']['output']>;
}

export interface ProductListWithSkusBlock {
  articles: Maybe<Array<Article>>;
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  ctaHref: Maybe<ContentLink>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaType: Maybe<ProductListWithSkusBlock_CtaType>;
  heading: Maybe<Scalars['JSON']['output']>;
  headingCenterAligned: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  productsLimit: Maybe<Scalars['Float']['output']>;
}

export interface ProductListWithSkusBlockHeadingArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export enum ProductListWithSkusBlock_CtaType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface ProductSafetyInformation {
  contactPersonEU: Maybe<ProductSafetyInformationContact>;
  content: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<ProductSafetyInformationContact>;
}

export interface ProductSafetyInformationContact {
  emailOrUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  postalAddress: Maybe<Scalars['String']['output']>;
}

/** Result of the exact product match */
export interface ProductSuggestion {
  /**
   * Constructor.io feature flags enabled for this autocomplete request.
   * Only includes features where features[name] = true.
   */
  cioFeatureFlags: Maybe<Array<ConstructorFeatureFlag>>;
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentSku: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  priceV2: ArticlePrices;
  sku: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

/** Result of the exact product match */
export interface ProductSuggestionImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
}

export interface Query {
  Content_v2: Maybe<Content_V2>;
  Contents_v2: Maybe<Contents_V2>;
  /** Provides shop-in-shop slice and its data from `Prismic` */
  ShopInShopSlice: Maybe<ContentShopInShopSliceV2>;
  /** Provides all data about all showrooms and outlets from prismic */
  ShowroomOutletSlice: Maybe<Array<Maybe<ContentLocalBusinessDataSlice>>>;
  /** Returns a collection of Articles by SKUs. */
  articles: Array<Maybe<Article>>;
  /**
   * Returns a collection of suggested results for a given prefix.
   * @deprecated use `autoSuggestion_v2`
   */
  autoSuggestion: Array<Maybe<AutoSuggestion>>;
  autoSuggestion_v2: Array<Maybe<AutoSuggestionResult>>;
  availableDomains: Array<Domain>;
  /** Returns a collection of brands pages. */
  brandsGlossary: Maybe<BrandGlossary>;
  /** @deprecated Use productListSortOptions_v2 because we have migrated category service to contentTree */
  categoryArticlesSortOptions: Array<CategoryArticlesSortOptionLocalized>;
  contactForm: Maybe<ContactForm>;
  contactFormSettings: Maybe<ContactFormSettings>;
  /** Provides content pages from `Prismic` served by `Cosmic API` */
  content: Content;
  /** Provides a document of new `content` type from `Prismic` */
  contentPage_v2: Maybe<ContentPage>;
  /** Provides preview of any document type defined in the schema by a direct request to `Prismic` */
  contentPreview_v2: Maybe<ContentPreviewPage_V2>;
  /**
   * We are storing coupons on a single Prismic document, identified by uid.
   * Each Slice have a title to identify individual coupon.
   * Assuming we would not have hundreds of coupons per Prismic document.
   * @deprecated Use storeCoupon instead. https://home24.atlassian.net/browse/PDE-3704
   */
  coupon: Maybe<Coupon>;
  /** @deprecated Use storeCoupons instead. https://home24.atlassian.net/browse/PDE-3704 */
  coupons: Array<Coupon>;
  /** Provides campaigns selected by Dynamic Yield */
  dyCampaigns: Array<DynamicYieldDecision>;
  /**
   * Returns the status information of a gift card
   *
   * Send empty string as PIN for cards without PIN (old butlers cards)
   */
  giftCardStatus: GiftCardStatus;
  /**
   * isGuestAccount is used to determine if a guest user has _already_ converted their account.
   * It determines if they should be shown a regular login page or the guest login page when following
   * the guest login link
   */
  isGuestAccount: Scalars['Boolean']['output'];
  isValidReferralId: Scalars['Boolean']['output'];
  productListShopInShopSlice: Maybe<ContentShopInShopSliceV2>;
  /** @deprecated Use productListSortOptions_v2 */
  productListSortOptions: Array<ProductListArticlesSortOptionLocalized>;
  productListSortOptions_v2: Array<ProductListArticlesSortOptionLocalized_V2>;
  /**
   * Returns a collection of ProductLists by IDs.
   * By default only **active lists that have articles** are returned. See the parameters list to tweak the query.
   * @deprecated use productLists_v2. Pagination will not work.
   */
  productLists: Array<Maybe<ProductList>>;
  productLists_v2: Array<Maybe<ProductList>>;
  /** Returns a Reclamation by reclamation id. */
  reclamation: Maybe<Reclamation>;
  /**
   * Returns a ReclamationItem by reclamation id and item id.
   * Temporarily it is allowed to use `lineNo` as item id.
   */
  reclamationItem: Maybe<ReclamationItem>;
  /**
   * Returns a collection of Reasons by reclamation id and item id.
   * Temporarily it is allowed to use `lineNo` as item id.
   */
  reclamationReasons: ReclamationReasonList;
  /**
   * Returns a collection of Solutions by reclamation id and item id.
   * Temporarily it is allowed to use `lineNo` as item id.
   */
  reclamationSolutions: ReclamationSolutionList;
  /** Fetches recommendations based on the provided parameters. */
  recommendations_v2: RecommendationsResponse_V2;
  /** Returns a list of Request Reasons based on language and type. */
  requestReasons: RequestReasonList;
  /** Returns a search result. */
  search: Maybe<SearchResult>;
  searchSortOptions: Array<SearchSortOptionLocalized>;
  searchThirdPartyIndex: Scalars['String']['output'];
  /**  returns shop data from shop-service. Locale used for ShopLegalInfo.title. ShippingInfo holds default shipping thresholds */
  shop: Maybe<Shop>;
  sponsoredAdTeaser: Array<SponsoredAdTeaser>;
  /**
   * We are storing store coupons on a single Prismic document, identified by uid.
   * Each Slice have a title to identify individual store coupon.
   * Assuming we would not have hundreds of store coupons per Prismic document.
   */
  storeCoupon: Maybe<StoreCoupon>;
  storeCoupons: Array<StoreCoupon>;
  /** Returns a collection of Stores for given location. */
  storeLocation: Maybe<LocationResponse>;
  /** Returns a collection of Stores. */
  stores: Maybe<Array<Stores>>;
  /**
   * Returns url mapping information
   * @deprecated use urlmapping_v2 instead
   */
  urlmapping: Maybe<UrlMapping>;
  /** Returns url mapping for a full URL */
  urlmapping_v2: Maybe<UrlMapping>;
  user: User;
  validateEmail: EmailValidationResult;
  /** @deprecated use validationRules_v2 */
  validationRules: ValidationRules;
  validationRules_v2: ValidationRules_V2;
  /** Identifies if certain features are enabled for the visitor */
  visitorConfiguration: Maybe<VisitorConfiguration>;
  visitorHash: Scalars['String']['output'];
  voucher: Maybe<Voucher>;
}

export interface QueryContent_V2Args {
  draft: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  locale: InputMaybe<GQLLocale>;
  select: InputMaybe<Scalars['Boolean']['input']>;
}

export interface QueryContents_V2Args {
  draft: InputMaybe<Scalars['Boolean']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<GQLLocale>;
  page: InputMaybe<Scalars['Int']['input']>;
  pagination: InputMaybe<Scalars['Boolean']['input']>;
  select: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<Content_V2_Where>;
}

export interface QueryShopInShopSliceArgs {
  documentUID: Scalars['String']['input'];
  locale: GQLLocale;
}

export interface QueryShowroomOutletSliceArgs {
  locale: GQLLocale;
}

export interface QueryArticlesArgs {
  locale: GQLLocale;
  skus: Array<Scalars['String']['input']>;
}

export interface QueryAutoSuggestionArgs {
  backend?: InputMaybe<SearchBackend>;
  locale: GQLLocale;
  prefix: Scalars['String']['input'];
}

export interface QueryAutoSuggestion_V2Args {
  backend?: InputMaybe<SearchBackend>;
  limit?: Scalars['Int']['input'];
  locale: GQLLocale;
  prefix: Scalars['String']['input'];
  thirdPartyClientId: InputMaybe<Scalars['String']['input']>;
  thirdPartySessionId: InputMaybe<Scalars['String']['input']>;
  urlParams: InputMaybe<Scalars['String']['input']>;
  userAgent: InputMaybe<Scalars['String']['input']>;
  userIP: InputMaybe<Scalars['String']['input']>;
}

export interface QueryBrandsGlossaryArgs {
  locale: GQLLocale;
}

export interface QueryCategoryArticlesSortOptionsArgs {
  locale: GQLLocale;
}

export interface QueryContactFormArgs {
  documentId: Scalars['String']['input'];
  locale: GQLLocale;
}

export interface QueryContactFormSettingsArgs {
  locale: GQLLocale;
}

export interface QueryContentArgs {
  locale: GQLLocale;
}

export interface QueryContentPage_V2Args {
  id: Scalars['String']['input'];
}

export interface QueryContentPreview_V2Args {
  id: Scalars['String']['input'];
  ref: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
}

export interface QueryCouponArgs {
  locale: GQLLocale;
  ref: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uid?: Scalars['String']['input'];
}

export interface QueryCouponsArgs {
  locale: GQLLocale;
  ref: InputMaybe<Scalars['String']['input']>;
  uid?: Scalars['String']['input'];
}

export interface QueryDyCampaignsArgs {
  channel?: DynamicYieldChannel;
  contextType: DynamicYieldPageContexType;
  data: InputMaybe<Array<Scalars['String']['input']>>;
  isImplicitPageview?: InputMaybe<Scalars['Boolean']['input']>;
  locale: GQLLocale;
  pageAttributes: InputMaybe<Array<DynamicYieldPageAttribute>>;
  pageUrl: Scalars['String']['input'];
  previewToken: InputMaybe<Scalars['String']['input']>;
  referrer: InputMaybe<Scalars['String']['input']>;
  selectors: Array<Scalars['String']['input']>;
  splitByDataItems?: InputMaybe<Scalars['Boolean']['input']>;
  userAgent: InputMaybe<Scalars['String']['input']>;
  userIP: InputMaybe<Scalars['String']['input']>;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface QueryGiftCardStatusArgs {
  challenge: InputMaybe<Challenge>;
  code: Scalars['String']['input'];
  pin: Scalars['String']['input'];
}

export interface QueryIsGuestAccountArgs {
  customerId: Scalars['String']['input'];
}

export interface QueryIsValidReferralIdArgs {
  referralId: Scalars['String']['input'];
}

export interface QueryProductListShopInShopSliceArgs {
  locale: GQLLocale;
  productListId: Scalars['String']['input'];
}

export interface QueryProductListSortOptionsArgs {
  backend?: PlpBackend;
  locale: GQLLocale;
}

export interface QueryProductListSortOptions_V2Args {
  backend?: PlpBackend;
  locale: GQLLocale;
}

export interface QueryProductListsArgs {
  backend?: PlpBackend;
  crossDeviceHash: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
  locale: GQLLocale;
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<ProductListNavigation>;
  showOnDevice: InputMaybe<Array<ProductListDevice>>;
  sortingScore: InputMaybe<ArticlesSortingScore>;
  thirdPartyClientId: InputMaybe<Scalars['String']['input']>;
  thirdPartySessionId: InputMaybe<Scalars['String']['input']>;
  urlParams: InputMaybe<Scalars['String']['input']>;
  userAgent: InputMaybe<Scalars['String']['input']>;
  userIP: InputMaybe<Scalars['String']['input']>;
}

export interface QueryProductLists_V2Args {
  backend?: PlpBackend;
  crossDeviceHash: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids: Array<Scalars['String']['input']>;
  locale: GQLLocale;
  offset?: InputMaybe<Scalars['Int']['input']>;
  optionsSorting?: InputMaybe<ProductListFilterOptionsSorting>;
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<ProductListNavigation>;
  showOnDevice: InputMaybe<Array<ProductListDevice>>;
  sortingScore: InputMaybe<ArticlesSortingScore>;
  thirdPartyClientId: InputMaybe<Scalars['String']['input']>;
  thirdPartySessionId: InputMaybe<Scalars['String']['input']>;
  urlParams: InputMaybe<Scalars['String']['input']>;
  userAgent: InputMaybe<Scalars['String']['input']>;
  userIP: InputMaybe<Scalars['String']['input']>;
}

export interface QueryReclamationArgs {
  aggregated?: Scalars['Boolean']['input'];
  reclamationId: Scalars['String']['input'];
}

export interface QueryReclamationItemArgs {
  aggregated?: Scalars['Boolean']['input'];
  itemId: InputMaybe<Scalars['String']['input']>;
  lineNo: InputMaybe<Scalars['String']['input']>;
  reclamationId: Scalars['String']['input'];
}

export interface QueryReclamationReasonsArgs {
  itemId: InputMaybe<Scalars['String']['input']>;
  lineNo: InputMaybe<Scalars['String']['input']>;
  reclamationId: Scalars['String']['input'];
}

export interface QueryReclamationSolutionsArgs {
  includeUnavailable: InputMaybe<Scalars['Boolean']['input']>;
  itemId: InputMaybe<Scalars['String']['input']>;
  lineNo: InputMaybe<Scalars['String']['input']>;
  reclamationId: Scalars['String']['input'];
}

export interface QueryRecommendations_V2Args {
  filters: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  locale: GQLLocale;
  skus: InputMaybe<Array<Scalars['String']['input']>>;
  term: InputMaybe<Scalars['String']['input']>;
  userInfo: InputMaybe<UserInfo>;
}

export interface QueryRequestReasonsArgs {
  locale: InputMaybe<GQLLocale>;
  type: RequestType;
}

export interface QuerySearchArgs {
  backend?: InputMaybe<SearchBackend>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCategoryTree?: InputMaybe<Scalars['Boolean']['input']>;
  locale: GQLLocale;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: InputMaybe<Scalars['String']['input']>;
  thirdPartyClientId: InputMaybe<Scalars['String']['input']>;
  thirdPartySessionId: InputMaybe<Scalars['String']['input']>;
  urlParams: InputMaybe<Scalars['String']['input']>;
  userAgent: InputMaybe<Scalars['String']['input']>;
  userIP: InputMaybe<Scalars['String']['input']>;
}

export interface QuerySearchSortOptionsArgs {
  backend?: InputMaybe<SearchBackend>;
  locale: GQLLocale;
}

export interface QuerySearchThirdPartyIndexArgs {
  locale: GQLLocale;
}

export interface QueryShopArgs {
  id: Scalars['String']['input'];
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface QuerySponsoredAdTeaserArgs {
  locale: GQLLocale;
  placements: Array<SponsoredAdPlacement>;
  productListId: InputMaybe<Scalars['String']['input']>;
  searchQuery: InputMaybe<Scalars['String']['input']>;
}

export interface QueryStoreCouponArgs {
  locale: GQLLocale;
  ref: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uid?: Scalars['String']['input'];
}

export interface QueryStoreCouponsArgs {
  locale: GQLLocale;
  ref: InputMaybe<Scalars['String']['input']>;
  uid?: Scalars['String']['input'];
}

export interface QueryStoreLocationArgs {
  limit: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['String']['input'];
  page: InputMaybe<Scalars['Int']['input']>;
}

export interface QueryStoresArgs {
  location: Scalars['String']['input'];
  sku: Scalars['String']['input'];
}

export interface QueryUrlmappingArgs {
  locale: GQLLocale;
  path: Scalars['String']['input'];
}

export interface QueryUrlmapping_V2Args {
  url: Scalars['String']['input'];
}

export interface QueryValidateEmailArgs {
  email: Scalars['String']['input'];
}

export interface QueryValidationRulesArgs {
  locale: GQLLocale;
}

export interface QueryValidationRules_V2Args {
  locale: GQLLocale;
}

export interface QueryVisitorHashArgs {
  email: Scalars['String']['input'];
}

export interface QueryVoucherArgs {
  code: Scalars['String']['input'];
  locale: GQLLocale;
}

export interface RatingDistribution {
  count: Scalars['Int']['output'];
  rating: Scalars['Int']['output'];
}

export interface Reclamation {
  appDomainId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isSubmitted: Scalars['Boolean']['output'];
  items: Array<Maybe<ReclamationItem>>;
  language: GQLLocale;
  order_v2: Order;
  type: ReclamationType;
}

export interface ReclamationItemsArgs {
  showAddedToClaimOnly: Scalars['Boolean']['input'];
}

export enum ReclamationAccessPolicy {
  Disallowed = 'DISALLOWED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export interface ReclamationItem {
  article: Maybe<Article>;
  assemblyPrice: Maybe<ReclamationOrderItemPrice>;
  attachmentPolicy: ReclamationAccessPolicy;
  chooseSolutionAllowed: Scalars['Boolean']['output'];
  claimedQuantity: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  commentPolicy: ReclamationAccessPolicy;
  id: Scalars['String']['output'];
  isAddedToClaim: Scalars['Boolean']['output'];
  /** @deprecated Use `attachmentPolicy`. */
  isImageRequired: Scalars['Boolean']['output'];
  nextSteps: Array<Maybe<ReclamationItemNextStep>>;
  /**  Use `orderItem` field instead of `article` when only some basic article data is needed.  */
  orderItem: Maybe<OrderItem>;
  orderItemV2: Maybe<OrderItemV2>;
  partNumberPolicy: ReclamationAccessPolicy;
  partNumbers: Array<Scalars['String']['output']>;
  /** @deprecated Use `partNumberPolicy`. */
  partNumbersAllowed: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  reason: Maybe<ReclamationItemReason>;
  resources: Array<Scalars['String']['output']>;
  solution: Maybe<ReclamationItemSolution>;
  vendorOrderId: Scalars['String']['output'];
  vendorOrderIdPolicy: ReclamationAccessPolicy;
}

export interface ReclamationItemArticleArgs {
  locale: GQLLocale;
}

export interface ReclamationItemNextStep {
  description: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
}

export interface ReclamationItemQuantity {
  lineNo: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}

export interface ReclamationItemReason {
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ReclamationItemSolution {
  id: Scalars['String']['output'];
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ReclamationItemState {
  lineNo: Scalars['String']['input'];
  state: Scalars['Boolean']['input'];
}

export interface ReclamationOrderItemPrice {
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
}

export interface ReclamationReason {
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values: Array<Maybe<ReclamationReasonValue>>;
}

export interface ReclamationReasonList {
  reasons: Array<Maybe<ReclamationReason>>;
  title: Scalars['String']['output'];
}

export interface ReclamationReasonValue {
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ReclamationSolution {
  available: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  ecoFriendly: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface ReclamationSolutionList {
  title: Scalars['String']['output'];
  values: Array<Maybe<ReclamationSolution>>;
}

export enum ReclamationType {
  Cancellations = 'CANCELLATIONS',
  ReturnsAndComplaints = 'RETURNS_AND_COMPLAINTS',
}

export interface ReclamationUpdateBatch {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isAddedToClaim?: InputMaybe<Scalars['Boolean']['input']>;
  isAddedToFlow?: InputMaybe<Scalars['Boolean']['input']>;
  lineNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  partNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  vendorOrderId?: InputMaybe<Scalars['String']['input']>;
}

export interface RecommendationItem {
  /** Recommended article. */
  article: Maybe<Article>;
  /** Recommendation strategy ID. */
  strategyId: Scalars['String']['output'];
}

export interface RecommendationSliderBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  selector: RecommendationSliderBlock_Selector;
}

export enum RecommendationSliderBlock_Selector {
  ContentReco1 = 'ContentReco1',
  ContentReco2 = 'ContentReco2',
  ContentReco3 = 'ContentReco3',
}

export interface RecommendationsResponse_V2 {
  /**
   * Constructor.io feature flags enabled for this recommendations request.
   * Only includes features where features[name] = true.
   */
  cioFeatureFlags: Maybe<Array<ConstructorFeatureFlag>>;
  /** List of recommended items. */
  items: Maybe<Array<RecommendationItem>>;
  /** Trace id from third-party service */
  resultId: Scalars['String']['output'];
  /**
   * Parent SKUs used as seed items for recommendations (resolved from input SKUs).
   * Used by frontend for data-cnstrc-recommendations-seed-items attribute.
   */
  seedSkus: Array<Scalars['String']['output']>;
  /** Display name of a Recommendation slider */
  title: Scalars['String']['output'];
}

export interface RedeemGiftCard {
  code: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
}

export interface RegisterGuestRequest {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: UserGender;
  lastName: Scalars['String']['input'];
  locale: GQLLocale;
  loginFlow: LoginFlow;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface RegisterRequest_V2 {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  gender: UserGender;
  lastname: Scalars['String']['input'];
  locale: GQLLocale;
  loginFlow: LoginFlow;
  newsletterSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  referredBy?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
}

export interface RegisterResponse {
  errors: Maybe<Scalars['Map']['output']>;
  tokens: Maybe<Tokens>;
  user: Maybe<User>;
}

export interface RegisterResponse_V2 {
  tokens: Maybe<Tokens>;
  user: Maybe<User>;
}

/** A related search query suggestion returned by Constructor.io. */
export interface RelatedSearch {
  /** The related search query string. */
  query: Scalars['String']['output'];
}

export interface RequestReason {
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values: Array<Maybe<RequestReason>>;
}

export interface RequestReasonList {
  reasons: Array<Maybe<RequestReason>>;
  title: Scalars['String']['output'];
}

export enum RequestType {
  Cancellations = 'CANCELLATIONS',
  Help = 'HELP',
  ReturnsAndComplaints = 'RETURNS_AND_COMPLAINTS',
}

export interface ReviewInput {
  comment: Scalars['String']['input'];
  grade: Scalars['Int']['input'];
  omsOrderId: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
}

export interface ReviewKeyword {
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  negativeCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
  sentiment: Sentiment;
}

export interface ReviewLinkResponse {
  url: Scalars['String']['output'];
}

export interface ReviewSummary {
  keywords: Maybe<Array<ReviewKeyword>>;
  summary: Maybe<Scalars['String']['output']>;
}

export interface SafetyAndSustainability {
  packaging: Maybe<SustainabilityInfo>;
  product: Maybe<SustainabilityInfo>;
}

export enum SearchBackend {
  /**
   * Old behavior
   * @deprecated Internal search disabled, ThirdParty will be used
   */
  Home24 = 'Home24',
  /** Constructor.io */
  ThirdParty = 'ThirdParty',
}

export type SearchResult = SearchResultArticles | SearchResultRedirect;

export interface SearchResultArticles {
  articles: Array<Maybe<Article>>;
  /** @deprecated categories is deprecated, now categories are merged with filters, use filters instead https://home24.atlassian.net/browse/SPP-5598 */
  categories: Maybe<ProductListFilter>;
  categoryId: Maybe<Scalars['String']['output']>;
  categoryName: Maybe<Scalars['String']['output']>;
  /**
   * Constructor.io feature flags enabled for this search request.
   * Only includes features where features[name] = true.
   */
  cioFeatureFlags: Maybe<Array<ConstructorFeatureFlag>>;
  customFilters: Maybe<Array<Maybe<CustomFilter>>>;
  filters: Array<Maybe<ProductListFilter>>;
  /** @deprecated filters_v2 is deprecated, use filters instead https://home24.atlassian.net/browse/SPP-5598 */
  filters_v2: Array<Maybe<ProductListFilter>>;
  /** indicates whether the response from cio contains non-token-matched results */
  hasEmbeddedResults: Scalars['Boolean']['output'];
  /** 1-level deeper product groups for visual navigation */
  navigation: Maybe<Array<Maybe<ProductList>>>;
  /**
   * Related search queries from Constructor.io.
   * Returns null if fewer than 3 related searches are available.
   * Limited to a maximum of 15 entries.
   */
  relatedSearches: Maybe<Array<RelatedSearch>>;
  /** depending on search provider, can be empty string */
  resultId: Scalars['String']['output'];
  /** search request JSON serialized into string */
  searchRequest: Maybe<Scalars['String']['output']>;
  selectedFiltersCount: Scalars['Int']['output'];
  selectedSort: Scalars['String']['output'];
  total: Scalars['Int']['output'];
}

export interface SearchResultArticlesNavigationArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface SearchResultRedirect {
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** depending on search provider, can be empty string */
  resultId: Scalars['String']['output'];
  /** search request JSON serialized into string */
  searchRequest: Maybe<Scalars['String']['output']>;
  target: Maybe<UrlMappingTarget>;
}

export interface SearchSortOptionLocalized {
  localized: Scalars['String']['output'];
  urlParam: Scalars['String']['output'];
}

/** Result of human written historical search keywords */
export interface SearchSuggestion {
  /** Optional field of categories associated with the search suggestion */
  categories: Array<CategorySuggestion>;
  /**
   * Constructor.io feature flags enabled for this autocomplete request.
   * Only includes features where features[name] = true.
   */
  cioFeatureFlags: Maybe<Array<ConstructorFeatureFlag>>;
  /** Optional field when keyword have image attached */
  image: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Optional field when keyword have count of matches */
  total: Maybe<Scalars['Int']['output']>;
}

/** Result of human written historical search keywords */
export interface SearchSuggestionCategoriesArgs {
  ignoreAfterSuggestion?: InputMaybe<Scalars['Int']['input']>;
  lastLevelCategories?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Result of human written historical search keywords */
export interface SearchSuggestionImageArgs {
  format?: InputMaybe<ArticleImageFormat>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
}

export interface Section {
  dimension: Array<Scalars['String']['output']>;
  dimensionV2: Array<DimensionValue>;
}

export interface SellerRatingOrderInfo {
  isRated: Scalars['Boolean']['output'];
  items: Array<SellerRatingOrderItem>;
  omsOrderId: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  shopName: Scalars['String']['output'];
}

export interface SellerRatingOrderItem {
  article: Maybe<Article>;
  sku: Scalars['String']['output'];
}

export interface SellerRatingOrderItemArticleArgs {
  locale: GQLLocale;
}

export enum Sentiment {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE',
}

/** SEO data */
export interface Seo {
  canonicalLink: Scalars['String']['output'];
  hreflang: Array<Hreflang>;
  metaDescription: Scalars['String']['output'];
  metaImage: Maybe<Scalars['String']['output']>;
  metaRobots: Scalars['String']['output'];
  metaTitle: Maybe<Scalars['String']['output']>;
}

export interface SeoBlockSlice extends SeoPageSlice {
  content: Scalars['String']['output'];
  richText: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface SeoPageSlice {
  type: Scalars['String']['output'];
}

export interface SeoTabBarItem {
  isActive: Scalars['Boolean']['output'];
  link: Maybe<ContentLink>;
  text: Maybe<Scalars['String']['output']>;
}

export interface SeoTabBarSlice extends SeoPageSlice {
  activeBackgroundColor: Maybe<Scalars['String']['output']>;
  activeTextColor: Maybe<Scalars['String']['output']>;
  items: Array<Maybe<SeoTabBarItem>>;
  type: Scalars['String']['output'];
}

export interface SetNewPasswordResponse {
  tokens: Maybe<Tokens>;
  user: Maybe<User>;
}

export interface ShippingCampaign {
  endDate: Scalars['String']['output'];
  regularShippingSubTotal: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
}

export type ShippingInfoRow = ShippingInfoTableDataRow | ShippingInfoTableHeaderRow;

export interface ShippingInfoTable {
  rows: Array<ShippingInfoRow>;
  title: Scalars['String']['output'];
}

export interface ShippingInfoTableDataColumn {
  textColor: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface ShippingInfoTableDataRow {
  columns: Array<ShippingInfoTableDataColumn>;
}

export interface ShippingInfoTableHeaderRow {
  columns: Array<ShippingInfoTableDataColumn>;
}

export enum ShippingMethod {
  Curb_2Mh = 'CURB_2MH',
  Std = 'STD',
  Std_2Mh = 'STD_2MH',
  StdL = 'STD_L',
  Virtual = 'VIRTUAL',
}

export interface ShippingPrice {
  /**  Shipping price in cents  */
  value: Scalars['Int']['output'];
}

export interface ShippingThreshold {
  cost: ShopShippingCost;
  from: ShopShippingCost;
  to: Maybe<ShopShippingCost>;
}

export enum ShippingZoneName {
  De = 'DE',
}

export interface Shop {
  KPIs: Maybe<ShopKpIs>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalInfo: Array<ShopLegalInfo>;
  logo: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  ratings: Maybe<ShopRatings>;
  /** @deprecated Use shippingInfo_v4 instead */
  shippingInfo: ShopShippingInfo;
  /**
   * `shippingInfo_v2` returns the shipping thresholds for the given zipCode, or nil if zipCode is not provided or empty
   * @deprecated Use shippingInfo_v4 instead
   */
  shippingInfo_v2: Maybe<ShopShippingInfo>;
  shippingInfo_v4: Maybe<ShopShippingInfoV4>;
  state: Maybe<ShopState>;
  workingHours: Maybe<Scalars['String']['output']>;
}

export interface ShopLegalInfoArgs {
  types?: InputMaybe<Array<ShopLegalInfoType>>;
}

export interface ShopLogoArgs {
  format?: InputMaybe<LogoImageFormat>;
  maxHeight: InputMaybe<Scalars['Int']['input']>;
  maxWidth: InputMaybe<Scalars['Int']['input']>;
}

export interface ShopInShopData {
  banner: Maybe<ContentFullContentImageSet>;
  drawerContent: Maybe<Scalars['String']['output']>;
  filterQuery: Maybe<Scalars['String']['output']>;
  homepage: Maybe<ContentLink>;
  linkLabel: Maybe<Scalars['String']['output']>;
  logo: ContentImage;
  navigation: ShopInShopNavigation;
  shopName: Scalars['String']['output'];
}

export interface ShopInShopNavigation {
  level1Items: Array<ShopInShopNavigationLevel1Item>;
}

export interface ShopInShopNavigationLevel1Item {
  /** @deprecated use href_v2.fullUrl */
  href: Maybe<Scalars['String']['output']>;
  href_v2: Maybe<ContentLink>;
  level2Items: Maybe<Array<ShopInShopNavigationLevel2Item>>;
  name: Scalars['String']['output'];
  thumbnail: Maybe<ContentImage>;
}

export interface ShopInShopNavigationLevel2Item {
  /** @deprecated use href_v2.fullUrl */
  href: Scalars['String']['output'];
  href_v2: ContentLink;
  name: Scalars['String']['output'];
  thumbnail: Maybe<ContentImage>;
}

export interface ShopKpIs {
  avgIncidentResolutionTime: Maybe<Scalars['Float']['output']>;
  lateShipmentRate: Maybe<Scalars['Float']['output']>;
  totalOrders: Scalars['Int']['output'];
}

export interface ShopLegalInfo {
  content: Maybe<Scalars['String']['output']>;
  key: ShopLegalInfoType;
  title: Scalars['String']['output'];
}

export enum ShopLegalInfoType {
  Agb = 'AGB',
  DataProtectionAgreement = 'DATA_PROTECTION_AGREEMENT',
  Impressum = 'IMPRESSUM',
  Reclamation = 'RECLAMATION',
  /** only applicable to fr_FR */
  RecyclingAndRemovalPolicy = 'RECYCLING_AND_REMOVAL_POLICY',
  ReturnPolicy = 'RETURN_POLICY',
  ShopInfo = 'SHOP_INFO',
}

export interface ShopRatings {
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  firstReviewDate: Scalars['String']['output'];
  ratingDistribution: Array<RatingDistribution>;
}

export interface ShopShippingCost {
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
}

export interface ShopShippingInfo {
  /** freeThreshold is a global value representing the highest free threshold from all shipping types. It is never specific to article. */
  freeThreshold: Maybe<ShopShippingCost>;
  furnitureShipping: Array<ShippingThreshold>;
  furnitureShippingFreeThreshold: Maybe<ShopShippingCost>;
  parcelService: Array<ShippingThreshold>;
  parcelServiceFreeThreshold: Maybe<ShopShippingCost>;
  zone: Scalars['String']['output'];
}

export interface ShopShippingInfoV4 {
  description: Maybe<Scalars['String']['output']>;
  legalInfo: Scalars['String']['output'];
  tables: Maybe<Array<ShippingInfoTable>>;
}

export enum ShopState {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED',
  Unknown = 'UNKNOWN',
}

export interface ShopTheLookBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  items: Maybe<Array<Article>>;
  sliderTitle: Maybe<Scalars['String']['output']>;
}

/**  Sponsored article added to the PLP or Search  */
export interface Sponsored {
  /**  id for tracking and debugging bidding results  */
  id: Scalars['String']['output'];
  /**  [Optional] Campaign Owner  */
  owner: Maybe<Scalars['String']['output']>;
}

export enum SponsoredAdPlacement {
  PlpBannerPosition_16 = 'PLP_BANNER_POSITION_16',
}

export interface SponsoredAdTeaser {
  advertiser: Maybe<Scalars['String']['output']>;
  bannerId: Scalars['String']['output'];
  /** Accessibility label for the call-to-action (aria-label). */
  ctaAriaLabel: Maybe<Scalars['String']['output']>;
  ctaTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  image: SponsoredAdTeaserImage;
  link: ContentLink;
  placement: SponsoredAdPlacement;
  /** Raw placement ID string used for tracking (e.g. plp-banner-position-16). */
  placementId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
}

export interface SponsoredAdTeaserImage {
  alt: Maybe<Scalars['String']['output']>;
  desktop: Maybe<Scalars['String']['output']>;
  mobile: Scalars['String']['output'];
}

export interface StartExpressCheckoutInput {
  paymentMethodType: CheckoutPaymentMethodType;
  paypal?: InputMaybe<StartExpressCheckoutPayPalData>;
  paypalAdyen?: InputMaybe<StartExpressCheckoutPayPalAdyenData>;
}

export interface StartExpressCheckoutPayPalAdyenData {
  billingAddress: CheckoutAddressInput;
  email: Scalars['String']['input'];
  shippingAddress?: InputMaybe<CheckoutAddressInput>;
}

export interface StartExpressCheckoutPayPalData {
  orderID: Scalars['String']['input'];
  payerID: Scalars['String']['input'];
}

export interface StartExpressCheckoutResponse {
  billingAddress: Maybe<Address>;
  completed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  errors: Maybe<Array<CheckoutError>>;
  shippingAddress: Maybe<Address>;
}

export interface StoreCoupon {
  code: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  image: Maybe<ContentFullContentImageSet>;
  legalInfo: Maybe<Scalars['String']['output']>;
  storeType: StoreType;
  title: Scalars['String']['output'];
  validFrom: Scalars['Time']['output'];
  validTo: Scalars['Time']['output'];
}

export enum StoreCouponFilter {
  /**  Available while in early development phase, but potentially will be deprecated by more granular filtering  */
  All = 'ALL',
}

export enum StoreType {
  Outlet = 'outlet',
  Showroom = 'showroom',
  Store = 'store',
}

export type StoredPaymentData = PaymentDataCard | PaymentDataIdealBank | PaymentDataInstallmentRate;

export interface Stores {
  address: Scalars['String']['output'];
  address_addition: Maybe<Scalars['String']['output']>;
  availability: AvailabilityType;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  lat: Scalars['String']['output'];
  lon: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: BranchType;
  zip_code: Scalars['String']['output'];
}

export interface SubOrder {
  createdAt: Scalars['String']['output'];
  deliveryCost: Scalars['Int']['output'];
  deliveryTypes: Array<ArticleDeliveryType>;
  isHome24: Scalars['Boolean']['output'];
  items: Maybe<Array<OrderItem>>;
  shopId: Scalars['String']['output'];
  shopName: Scalars['String']['output'];
  subTotal: Scalars['Int']['output'];
}

export enum SubOrdersGrouping {
  CartItemGroups = 'CartItemGroups',
  ShopId = 'ShopId',
}

export interface SubscriberMutationResult_V2 {
  subscriptions: Maybe<Array<UserSubscription>>;
  visitorHash: Scalars['String']['output'];
  wasSubscribed: Scalars['Boolean']['output'];
}

export interface SubscriberMutationResult_V3 {
  subscriptions: Maybe<Array<UserSubscription_V2>>;
  visitorHash: Scalars['String']['output'];
  wasSubscribed: Scalars['Boolean']['output'];
}

export enum SubscriptionChannel {
  AppPush = 'appPush',
  Email = 'email',
  Post = 'post',
}

export interface SubscriptionChannel_V2 {
  key: Scalars['String']['output'];
  localized: Scalars['String']['output'];
}

export interface SubscriptionRequest {
  channel: SubscriptionChannel;
  state: SubscriptionState;
  type: SubscriptionType;
}

export interface SubscriptionRequest_V2 {
  channel: Scalars['String']['input'];
  notificationFrequency?: InputMaybe<NotificationFrequency>;
  state: SubscriptionState;
  type: Scalars['String']['input'];
}

export enum SubscriptionState {
  Confirmed = 'confirmed',
  Pending = 'pending',
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
}

export enum SubscriptionType {
  B2bNewsletter = 'b2bNewsletter',
  CartReminder = 'cartReminder',
  DirectMail = 'directMail',
  GoogleCustomerMatch = 'googleCustomerMatch',
  HomeClubNewsletter = 'homeClubNewsletter',
  ItemAlert = 'itemAlert',
  Newsletter = 'newsletter',
  ProductRecommendation = 'productRecommendation',
  Survey = 'survey',
  Transactional = 'transactional',
  WishlistReminder = 'wishlistReminder',
}

export enum SubscriptionTypeAnon {
  B2bNewsletter = 'b2bNewsletter',
  Newsletter = 'newsletter',
}

export interface SubscriptionType_V2 {
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  localized: Scalars['String']['output'];
}

export interface SustainabilityInfo {
  compostable: Maybe<Scalars['String']['output']>;
  dangerousSubstances: Maybe<DangerousSubstances>;
  percentageOfRecycledMaterials: Maybe<Scalars['Int']['output']>;
  recyclable: Maybe<Scalars['String']['output']>;
  reusable: Maybe<Scalars['String']['output']>;
}

export interface TableOfContentItem {
  anchor: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface TableOfContentSlice extends SeoPageSlice {
  headings: Array<TableOfContentItem>;
  headline: Scalars['String']['output'];
  isContentCenterAligned: Scalars['Boolean']['output'];
  isContentWithReducedWidth: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
}

export interface TakeOrderResponse {
  action: Maybe<Action>;
  /**  Checkout ID  */
  cid: Scalars['String']['output'];
  errors: Maybe<Array<CheckoutError>>;
  redirectUrl: Scalars['String']['output'];
  /**  User ID  */
  uid: Scalars['String']['output'];
}

export enum Team {
  Cit = 'CIT',
  Cpt = 'CPT',
  Fit = 'FIT',
  Shop = 'SHOP',
  Unknown = 'Unknown',
}

export interface TextBlockBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isContentCenterAligned: Maybe<Scalars['Boolean']['output']>;
  isContentWithReducedWidth: Maybe<Scalars['Boolean']['output']>;
  textContent: Maybe<Scalars['JSON']['output']>;
}

export interface TextBlockBlockTextContentArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export enum TextContainerPosition {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT',
}

export enum ThirdPartyProvider {
  Apple = 'apple',
  Google = 'google',
}

export type ThirdPartyProviderLoginResponse = LoginResponse | LoginWithThirdPartyProviderError;

export interface Thread {
  articles: Maybe<Array<Maybe<Article>>>;
  id: Scalars['String']['output'];
  isClosed: Scalars['Boolean']['output'];
  messages: Array<ThreadMessage>;
  skus: Array<Scalars['String']['output']>;
  topic: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface ThreadArticlesArgs {
  locale: GQLLocale;
}

export interface ThreadMessage {
  attachments: Maybe<Array<ThreadMessageAttachment>>;
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  from: ThreadMessageSender;
  id: Scalars['String']['output'];
}

export interface ThreadMessageAttachment {
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface ThreadMessageSender {
  displayName: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface Tokens {
  accessToken: Scalars['String']['output'];
  expireIn: Scalars['Int']['output'];
  refreshToken: Maybe<Scalars['String']['output']>;
}

export interface TopTeaserBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface TriggerDoiResult {
  status: Scalars['String']['output'];
}

export interface TrustSealItem {
  icon: Maybe<ContentImage>;
  link: Maybe<ContentLink>;
  text: Maybe<Scalars['String']['output']>;
}

export interface TwoThirdsPictureTextBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<TwoThirdsPictureTextBlockItem>>;
}

export interface TwoThirdsPictureTextBlockItem {
  ctaBackgroundColor: Maybe<Scalars['String']['output']>;
  ctaLabel: Maybe<Scalars['String']['output']>;
  ctaLabelColor: Maybe<Scalars['String']['output']>;
  ctaUrl: Maybe<ContentLink>;
  description: Maybe<Scalars['JSON']['output']>;
  id: Maybe<Scalars['String']['output']>;
  image: Maybe<ContentFullContentImageSet>;
  revert: Maybe<Scalars['Boolean']['output']>;
  showInPremium: Maybe<Scalars['Boolean']['output']>;
}

export interface TwoThirdsPictureTextBlockItemDescriptionArgs {
  depth: InputMaybe<Scalars['Int']['input']>;
}

export interface UnknownSlice extends ContentPageSlice {
  type: Scalars['String']['output'];
}

export interface UnsubscribeMutationResult {
  status: Scalars['String']['output'];
  type: SubscriptionType;
}

export interface UpdateAddressInput {
  additional?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<UserGender>;
  isDefaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  street: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
  zip: Scalars['String']['input'];
}

export interface UpdateCartItem {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  services?: InputMaybe<Array<AdditionalServiceType>>;
  servicesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sku: Scalars['String']['input'];
}

export interface UpdateExpressOrderPayPalData {
  orderID: Scalars['String']['input'];
}

export interface UpdateExpressOrderPaymentData {
  paymentMethodType: CheckoutPaymentMethodType;
  paypal?: InputMaybe<UpdateExpressOrderPayPalData>;
}

export interface UpdateExpressOrderResponse {
  error: Maybe<Scalars['String']['output']>;
}

export interface UpdatePayPalAdyenDetailsResponse {
  error: Maybe<Scalars['String']['output']>;
}

export interface UpdatePayPalAdyenPaymentDataResponse {
  error: Maybe<Scalars['String']['output']>;
}

export interface UpdatePayPalOrderResponse {
  error: Maybe<Scalars['String']['output']>;
}

export interface UploadFile {
  file: Scalars['Upload']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  lineNo?: InputMaybe<Scalars['String']['input']>;
  reclamationId: Scalars['String']['input'];
}

export interface UploadInfo {
  filename: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
}

export interface UploadResponse {
  uploads: Array<UploadInfo>;
}

export interface UrlMapping {
  target: UrlMappingTarget;
  type: Scalars['String']['output'];
}

export interface UrlMappingTarget {
  target: Scalars['String']['output'];
}

export interface UrlMappingTarget_Article extends UrlMappingTarget {
  article: Maybe<Article>;
  sku: Scalars['String']['output'];
  target: Scalars['String']['output'];
}

export interface UrlMappingTarget_Category extends UrlMappingTarget {
  /** @deprecated use UrlMappingTarget_ContentTreeNode */
  category: Maybe<Category>;
  id: Scalars['String']['output'];
  target: Scalars['String']['output'];
  urlParams: Scalars['String']['output'];
}

export interface UrlMappingTarget_CategoryCategoryArgs {
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<CategoryListCategoryIn>;
  showOnDevice: InputMaybe<Array<CategoryDevice>>;
  sortingScore: InputMaybe<ArticlesSortingScore>;
  urlParams: InputMaybe<Scalars['String']['input']>;
}

export interface UrlMappingTarget_ContentPage extends UrlMappingTarget {
  contentPage: Maybe<ContentPage>;
  id: Scalars['String']['output'];
  target: Scalars['String']['output'];
}

export interface UrlMappingTarget_ContentTreeNode extends UrlMappingTarget {
  id: Scalars['String']['output'];
  productList: Maybe<ProductList>;
  target: Scalars['String']['output'];
  urlParams: Scalars['String']['output'];
}

export interface UrlMappingTarget_ContentTreeNodeProductListArgs {
  showEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  showInactive?: InputMaybe<Scalars['Boolean']['input']>;
  showListedIn: InputMaybe<ProductListNavigation>;
  showOnDevice: InputMaybe<Array<ProductListDevice>>;
  sortingScore: InputMaybe<ArticlesSortingScore>;
  urlParams: InputMaybe<Scalars['String']['input']>;
}

export interface UrlMappingTarget_External extends UrlMappingTarget {
  target: Scalars['String']['output'];
  targetPath: Scalars['String']['output'];
}

export interface UrlMappingTarget_Unknown extends UrlMappingTarget {
  target: Scalars['String']['output'];
  targetPath: Scalars['String']['output'];
}

export interface User {
  accountAddress: Maybe<Address>;
  addresses: Maybe<Array<Maybe<Address>>>;
  allowedBillingAddressCountries: Array<Scalars['String']['output']>;
  authenticationProviders: Array<AuthenticationProvider>;
  birthDate: Maybe<Scalars['String']['output']>;
  /**
   * Returns cart from cache
   * @deprecated use cachedCart_v2
   */
  cachedCart: Maybe<CartResponse>;
  /** Returns cart from cache */
  cachedCart_v2: Maybe<CartResponse>;
  /** @deprecated use cart_v2 */
  cart: Maybe<CartResponse>;
  cart_v2: Maybe<CartResponse>;
  /** @deprecated use checkout_v2 */
  checkout: Maybe<CheckoutResponse>;
  checkoutOrder: Maybe<CheckoutOrder>;
  checkout_v2: Maybe<CheckoutWithCartResponse>;
  companyName: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** @deprecated use digitalCart_v2 */
  digitalCart: Maybe<CartResponse>;
  digitalCart_v2: Maybe<CartResponse>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<UserGender>;
  hasOrders: Scalars['Boolean']['output'];
  /** butlers digital pass ID */
  homeClub: HomeClub;
  isConvertibleGuest: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  loggedInAs: UserLoggedInAs;
  order: Maybe<Order>;
  /**
   * Returns customer orders by ids
   * @deprecated use orders_v3
   */
  orders: Array<Maybe<Order>>;
  /** @deprecated use orders_v3 */
  orders_v2: Array<Order>;
  orders_v3: UserOrders;
  paybackCardNumber: Maybe<Scalars['String']['output']>;
  referralAllowed: Scalars['Boolean']['output'];
  referralLink: Maybe<Scalars['String']['output']>;
  savedForLater: Maybe<NamedArticlesList>;
  shippingAddresses: Maybe<Array<Maybe<Address>>>;
  subscriptions: Array<UserSubscription_V2>;
  taxNumber: Maybe<Scalars['String']['output']>;
  type: UserType;
  uid: Scalars['String']['output'];
  vatNumber: Maybe<Scalars['String']['output']>;
  visitorHash: Maybe<Scalars['String']['output']>;
  visitorId: Maybe<Scalars['Int']['output']>;
  wishlist: Maybe<Wishlist>;
  /** Returns zip code from user's default shipping address */
  zipCode: Maybe<Scalars['String']['output']>;
}

export interface UserCachedCartArgs {
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface UserCachedCart_V2Args {
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface UserCartArgs {
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface UserCart_V2Args {
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface UserCheckoutArgs {
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
}

export interface UserCheckoutOrderArgs {
  cid: Scalars['String']['input'];
}

export interface UserCheckout_V2Args {
  checkoutType?: InputMaybe<CheckoutType>;
  device: CheckoutDevice;
  locale: GQLLocale;
  zipCode: InputMaybe<Scalars['String']['input']>;
}

export interface UserDigitalCart_V2Args {
  locale: GQLLocale;
}

export interface UserOrderArgs {
  id: Scalars['String']['input'];
}

export interface UserOrdersArgs {
  ids: InputMaybe<Array<Scalars['String']['input']>>;
  types: InputMaybe<Array<OrderType>>;
}

export interface UserOrders_V2Args {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserOrders_V3Args {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserReferralLinkArgs {
  locale: GQLLocale;
}

export interface UserSubscriptionsArgs {
  channels: InputMaybe<Array<SubscriptionChannel>>;
  enableMultiChannel?: Scalars['Boolean']['input'];
  isAppUser?: InputMaybe<Scalars['Boolean']['input']>;
  locale: GQLLocale;
}

export enum UserGender {
  Diverse = 'DIVERSE',
  Female = 'FEMALE',
  Male = 'MALE',
  Undefined = 'UNDEFINED',
}

export interface UserInfo {
  /** If `X-H24-Cross-Device-Hash` header value is present, this will be ignored. */
  crossDeviceHash?: InputMaybe<Scalars['String']['input']>;
  /** If `ConstructorioID_client_id` cookie value is present, this will be ignored. */
  thirdPartyClientId?: InputMaybe<Scalars['String']['input']>;
  /** If `ConstructorioID_session_id` cookie value is present, this will be ignored. */
  thirdPartySessionId?: InputMaybe<Scalars['String']['input']>;
  /** If `User-Agent` header value is present, this will be ignored. */
  userAgent?: InputMaybe<Scalars['String']['input']>;
  /** If `X-H24-Device-Ip` or `X-Forwarded-For` header values are present, this will be ignored. */
  userIP?: InputMaybe<Scalars['String']['input']>;
}

export enum UserLoggedInAs {
  Anonymous = 'ANONYMOUS',
  Guest = 'GUEST',
  Partial = 'PARTIAL',
  User = 'USER',
}

export interface UserOrders {
  firstOrderDate: Scalars['String']['output'];
  lastOrderDate: Scalars['String']['output'];
  orders: Array<Order>;
  penultimateOrderDate: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
}

export interface UserSubscription {
  channel: SubscriptionChannel;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  pausedUntil: Maybe<Scalars['String']['output']>;
  state: SubscriptionState;
  type: SubscriptionType;
}

export interface UserSubscription_V2 {
  channel: SubscriptionChannel_V2;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  notificationFrequency: Maybe<NotificationFrequency>;
  pausedUntil: Maybe<Scalars['String']['output']>;
  state: SubscriptionState;
  type: SubscriptionType_V2;
}

export enum UserType {
  Business = 'business',
  Private = 'private',
}

export interface UspBarEntryPoint {
  icon: ContentImage;
  label: Scalars['String']['output'];
  labelUrl: Maybe<ContentLink>;
}

export interface UspBarUrgentMessage {
  bgColor: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  textHoverColor: Scalars['String']['output'];
  textUrl: Maybe<ContentLink>;
  visibleOnLarge: Scalars['Boolean']['output'];
  visibleOnMedium: Scalars['Boolean']['output'];
  visibleOnSmall: Scalars['Boolean']['output'];
}

export type ValidationRule =
  | ValidationRuleAllOf
  | ValidationRuleAnyOf
  | ValidationRuleBlacklistPattern
  | ValidationRuleMaxLength
  | ValidationRuleMinLength
  | ValidationRuleNot
  | ValidationRulePattern
  | ValidationRuleRequired;

/** Age validation used on birthdate */
export interface ValidationRuleAge {
  errorMessage: Scalars['String']['output'];
  /**
   * maximum age.
   *
   * NULL means there is no maximum
   */
  max: Maybe<Scalars['Int']['output']>;
  /**
   * minimum age.
   *
   * NULL means there is no minimum
   */
  min: Maybe<Scalars['Int']['output']>;
}

/** All of the rules have to pass */
export interface ValidationRuleAllOf {
  rules: Array<ValidationRule_V2>;
}

/** At least one of the rules has to pass */
export interface ValidationRuleAnyOf {
  rules: Array<ValidationRule_V2>;
}

/** !!!DEPRECATED!!! Use ValidationRuleNot + ValidationRulePattern instead */
export interface ValidationRuleBlacklistPattern {
  /** @deprecated No longer supported */
  errorMessage: Scalars['String']['output'];
  /** @deprecated No longer supported */
  value: Scalars['String']['output'];
}

/** !!!DEPRECATED!!! Use ValidationRulePattern instead */
export interface ValidationRuleMaxLength {
  /** @deprecated No longer supported */
  errorMessage: Scalars['String']['output'];
  /** @deprecated No longer supported */
  value: Scalars['Int']['output'];
}

/** !!!DEPRECATED!!! Use ValidationRulePattern instead */
export interface ValidationRuleMinLength {
  /** @deprecated No longer supported */
  errorMessage: Scalars['String']['output'];
  /** @deprecated No longer supported */
  value: Scalars['Int']['output'];
}

/** All of the rules mustn't pass */
export interface ValidationRuleNot {
  rules: Array<ValidationRule_V2>;
}

/** Regex pattern validation */
export interface ValidationRulePattern {
  errorMessage: Scalars['String']['output'];
  successMessage: Scalars['String']['output'];
  type: ValidationRulePatternType;
  value: Scalars['String']['output'];
}

export enum ValidationRulePatternType {
  Enum = 'enum',
  Length = 'length',
  Pattern = 'pattern',
}

/** Field is required */
export interface ValidationRuleRequired {
  errorMessage: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
}

export type ValidationRule_V2 =
  | ValidationRuleAge
  | ValidationRuleAllOf
  | ValidationRuleAnyOf
  | ValidationRuleNot
  | ValidationRulePattern
  | ValidationRuleRequired;

export interface ValidationRules {
  agb: Array<ValidationRule>;
  email: Array<ValidationRule>;
  firstname: Array<ValidationRule>;
  lastname: Array<ValidationRule>;
  password: Array<ValidationRule>;
}

export interface ValidationRules_V2 {
  address: AddressValidationRules;
  agb: Array<ValidationRule_V2>;
  birthdate: Array<ValidationRule_V2>;
  company: CompanyValidationRules;
  email: Array<ValidationRule_V2>;
  firstname: Array<ValidationRule_V2>;
  giftCard: GiftCardValidationRules;
  lastname: Array<ValidationRule_V2>;
  limangoOrderNumber: Array<ValidationRule_V2>;
  otp: Array<ValidationRule_V2>;
  password: Array<ValidationRule_V2>;
}

export interface ValidationRules_V2AddressArgs {
  countryCode: Scalars['String']['input'];
}

export interface VerticalSpacingBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
}

export interface VideoBlock {
  blockName: Maybe<Scalars['String']['output']>;
  blockType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isContentCenterAligned: Maybe<Scalars['Boolean']['output']>;
  isContentWithReducedWidth: Maybe<Scalars['Boolean']['output']>;
  link: Maybe<ContentLink>;
}

/** Assuming using via CommonGateway to preserve locale */
export interface VisitorConfiguration {
  /** Tells if additional services feature toggle is enabled. */
  additionalServicesEnabled: Scalars['Boolean']['output'];
  /**
   * Value of X-H24-Cross-Device-Hash header
   * It is NOT the same as user.uid, user.visitorId, user.visitorHash
   * crossDeviceHash logic is for both anonymous and logged in users
   */
  crossDeviceHash: Scalars['String']['output'];
  /**
   *  Using GrowthBook via country attribute (`X-H24-Country` header). Locale is not used
   * @deprecated Use homeClub_v2 instead, https://home24.atlassian.net/browse/PDE-3769
   */
  homeClub: Scalars['Boolean']['output'];
  homeClub_v2: Scalars['Boolean']['output'];
  /**
   * Value of X-H24-Visitor-Location header from CommonGateway.
   * Returning "external" when no header (testing without CommonGateway)
   */
  location: VisitorLocation;
  /**
   * Value of X-H24-Visitor-Location-Id header from CommonGateway.
   * This value provides additional information about a location.
   * For example, BUTLERS location can have location ID "110108"
   * which identifies a specific BUTLERS shop.
   * Some locations can have no Id.
   */
  locationId: Maybe<Scalars['String']['output']>;
  marketplace: Scalars['Boolean']['output'];
  plp: PlpBackend;
  search: SearchBackend;
}

/** Assuming using via CommonGateway to preserve locale */
export interface VisitorConfigurationHomeClubArgs {
  locale: GQLLocale;
}

export enum VisitorLocation {
  Butlers = 'BUTLERS',
  External = 'EXTERNAL',
  H24 = 'H24',
  Kikxxl = 'KIKXXL',
  ShrBer = 'SHR_BER',
  ShrBln = 'SHR_BLN',
  ShrDus = 'SHR_DUS',
  ShrFfm = 'SHR_FFM',
  ShrFra = 'SHR_FRA',
  ShrGen = 'SHR_GEN',
  ShrHam = 'SHR_HAM',
  ShrMuc = 'SHR_MUC',
  ShrMun = 'SHR_MUN',
  ShrStr = 'SHR_STR',
  ShrVie = 'SHR_VIE',
  ShrZur = 'SHR_ZUR',
  Unknown = 'UNKNOWN',
}

export enum VisualNavigationRenderingType {
  BigImageTopGrid = 'BIG_IMAGE_TOP_GRID',
  BigImageTopSlider = 'BIG_IMAGE_TOP_SLIDER',
  CompactImageBackGrid = 'COMPACT_IMAGE_BACK_GRID',
  CompactImageBackSlider = 'COMPACT_IMAGE_BACK_SLIDER',
  CompactImageRightGrid = 'COMPACT_IMAGE_RIGHT_GRID',
  CompactImageRightSlider = 'COMPACT_IMAGE_RIGHT_SLIDER',
}

export interface Voucher {
  channel: VoucherChannel;
  code: Scalars['String']['output'];
  conditions: VoucherConditions;
  /**
   * Indicates if the coupon is already activated by the user.
   * @deprecated use `OnlineCoupon.isActivated` instead, https://home24.atlassian.net/browse/SPP-5738
   */
  couponIsActivated: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * Indicates if the voucher is a coupon or not.
   * @deprecated check for `campaignType` instead, https://home24.atlassian.net/browse/SPP-5738
   */
  isCoupon: Scalars['Boolean']['output'];
  type: VoucherType;
}

export interface VoucherAbsolute {
  amount: Maybe<Scalars['Int']['output']>;
}

export enum VoucherApplicationSource {
  Customer = 'customer',
  Unknown = 'unknown',
  VoucherManager = 'voucherManager',
}

export interface VoucherCascadingAbsolute {
  ranges: Array<VoucherCascadingRange>;
}

export interface VoucherCascadingRange {
  discount: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
}

export interface VoucherCascadingRelative {
  /** Max discount amount in cents */
  maxAmount: Maybe<Scalars['Int']['output']>;
  ranges: Array<VoucherCascadingRange>;
}

export interface VoucherCategoriesList {
  blacklist: Array<Category>;
  whitelist: Array<Category>;
}

export enum VoucherChannel {
  CorporateBenefits = 'CORPORATE_BENEFITS',
  Unknown = 'UNKNOWN',
}

export interface VoucherConditions {
  active: Scalars['Boolean']['output'];
  applicableOnlyToSecondMostExpensiveItem: Scalars['Boolean']['output'];
  applicableToItemsOnSale: Maybe<VoucherOnSaleType>;
  articlesList: Maybe<ProductListArticles>;
  /** @deprecated new taxonomy implementation */
  categories: Maybe<VoucherCategoriesList>;
  customerType: Maybe<UserType>;
  maxUses: Maybe<VoucherMaxUses>;
  /** Order value in cents */
  minOrderValue: Maybe<Scalars['Int']['output']>;
  onlyHomeClub: Scalars['Boolean']['output'];
  validFrom: Scalars['Time']['output'];
  validTo: Scalars['Time']['output'];
}

export interface VoucherConditionsArticlesListArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  optionsSorting?: InputMaybe<ProductListFilterOptionsSorting>;
  sortingScore: InputMaybe<ArticlesSortingScore>;
  urlParams: InputMaybe<Scalars['String']['input']>;
}

export interface VoucherFreeShipping {
  amount: Maybe<Scalars['Int']['output']>;
}

export interface VoucherMaxUses {
  perCustomer: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Int']['output']>;
}

export enum VoucherMethod {
  Absolute = 'ABSOLUTE',
  CascadingAbsolute = 'CASCADING_ABSOLUTE',
  CascadingRelative = 'CASCADING_RELATIVE',
  FreeShipping = 'FREE_SHIPPING',
  Relative = 'RELATIVE',
}

export enum VoucherOnSaleType {
  AllItems = 'All_ITEMS',
  NotOnSale = 'NOT_ON_SALE',
  OnlyOnSale = 'ONLY_ON_SALE',
}

export interface VoucherRelative {
  amount: Maybe<Scalars['Int']['output']>;
  percentage: Scalars['Int']['output'];
}

export type VoucherType =
  | VoucherAbsolute
  | VoucherCascadingAbsolute
  | VoucherCascadingRelative
  | VoucherFreeShipping
  | VoucherRelative;

export interface Wishlist {
  articles: Array<Article>;
  name: Scalars['String']['output'];
}

export interface WishlistArticlesArgs {
  locale: GQLLocale;
}

export interface CountContents_V2 {
  totalDocs: Maybe<Scalars['Int']['output']>;
}

/**  Value for "@type" used together with "@context": "https://schema.org"  */
export enum SchemaOrgType {
  /**  Article  */
  Article = 'ARTICLE',
  /**  ProfilePage  */
  ProfilePage = 'PROFILE_PAGE',
}
